import * as j from "react";
import A, { createContext as xe, useContext as be, useMemo as re, useRef as X, useCallback as pe, useState as oe, useEffect as ue, forwardRef as qt, memo as Tc, Fragment as ut, useLayoutEffect as fi, isValidElement as Rc, cloneElement as Fc, createElement as Lc, useId as Yt, useReducer as ol, useSyncExternalStore as Dc, createRef as Mc } from "react";
import * as ir from "react-dom";
import Ac, { createPortal as il, flushSync as rn } from "react-dom";
var Nr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function no(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ir = { exports: {} }, zn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gi;
function _c() {
  if (Gi) return zn;
  Gi = 1;
  var e = A, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, s, u) {
    var c, f = {}, p = null, d = null;
    u !== void 0 && (p = "" + u), s.key !== void 0 && (p = "" + s.key), s.ref !== void 0 && (d = s.ref);
    for (c in s) r.call(s, c) && !i.hasOwnProperty(c) && (f[c] = s[c]);
    if (l && l.defaultProps) for (c in s = l.defaultProps, s) f[c] === void 0 && (f[c] = s[c]);
    return { $$typeof: t, type: l, key: p, ref: d, props: f, _owner: o.current };
  }
  return zn.Fragment = n, zn.jsx = a, zn.jsxs = a, zn;
}
var Un = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ki;
function Nc() {
  return Ki || (Ki = 1, process.env.NODE_ENV !== "production" && function() {
    var e = A, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = Symbol.iterator, h = "@@iterator";
    function v(b) {
      if (b === null || typeof b != "object")
        return null;
      var F = g && b[g] || b[h];
      return typeof F == "function" ? F : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(b) {
      {
        for (var F = arguments.length, I = new Array(F > 1 ? F - 1 : 0), K = 1; K < F; K++)
          I[K - 1] = arguments[K];
        w("error", b, I);
      }
    }
    function w(b, F, I) {
      {
        var K = x.ReactDebugCurrentFrame, de = K.getStackAddendum();
        de !== "" && (F += "%s", I = I.concat([de]));
        var le = I.map(function(se) {
          return String(se);
        });
        le.unshift("Warning: " + F), Function.prototype.apply.call(console[b], console, le);
      }
    }
    var S = !1, E = !1, L = !1, T = !1, _ = !1, W;
    W = Symbol.for("react.module.reference");
    function P(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === r || b === i || _ || b === o || b === u || b === c || T || b === d || S || E || L || typeof b == "object" && b !== null && (b.$$typeof === p || b.$$typeof === f || b.$$typeof === a || b.$$typeof === l || b.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === W || b.getModuleId !== void 0));
    }
    function D(b, F, I) {
      var K = b.displayName;
      if (K)
        return K;
      var de = F.displayName || F.name || "";
      return de !== "" ? I + "(" + de + ")" : I;
    }
    function k(b) {
      return b.displayName || "Context";
    }
    function z(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case l:
            var F = b;
            return k(F) + ".Consumer";
          case a:
            var I = b;
            return k(I._context) + ".Provider";
          case s:
            return D(b, b.render, "ForwardRef");
          case f:
            var K = b.displayName || null;
            return K !== null ? K : z(b.type) || "Memo";
          case p: {
            var de = b, le = de._payload, se = de._init;
            try {
              return z(se(le));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, q = 0, U, J, Y, G, Z, Q, B;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function ce() {
      {
        if (q === 0) {
          U = console.log, J = console.info, Y = console.warn, G = console.error, Z = console.group, Q = console.groupCollapsed, B = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        q++;
      }
    }
    function H() {
      {
        if (q--, q === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, b, {
              value: U
            }),
            info: M({}, b, {
              value: J
            }),
            warn: M({}, b, {
              value: Y
            }),
            error: M({}, b, {
              value: G
            }),
            group: M({}, b, {
              value: Z
            }),
            groupCollapsed: M({}, b, {
              value: Q
            }),
            groupEnd: M({}, b, {
              value: B
            })
          });
        }
        q < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ge = x.ReactCurrentDispatcher, fe;
    function ee(b, F, I) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (de) {
            var K = de.stack.trim().match(/\n( *(at )?)/);
            fe = K && K[1] || "";
          }
        return `
` + fe + b;
      }
    }
    var Oe = !1, Ae;
    {
      var He = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new He();
    }
    function We(b, F) {
      if (!b || Oe)
        return "";
      {
        var I = Ae.get(b);
        if (I !== void 0)
          return I;
      }
      var K;
      Oe = !0;
      var de = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var le;
      le = ge.current, ge.current = null, ce();
      try {
        if (F) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (je) {
              K = je;
            }
            Reflect.construct(b, [], se);
          } else {
            try {
              se.call();
            } catch (je) {
              K = je;
            }
            b.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (je) {
            K = je;
          }
          b();
        }
      } catch (je) {
        if (je && K && typeof je.stack == "string") {
          for (var ae = je.stack.split(`
`), Ne = K.stack.split(`
`), we = ae.length - 1, Ce = Ne.length - 1; we >= 1 && Ce >= 0 && ae[we] !== Ne[Ce]; )
            Ce--;
          for (; we >= 1 && Ce >= 0; we--, Ce--)
            if (ae[we] !== Ne[Ce]) {
              if (we !== 1 || Ce !== 1)
                do
                  if (we--, Ce--, Ce < 0 || ae[we] !== Ne[Ce]) {
                    var Te = `
` + ae[we].replace(" at new ", " at ");
                    return b.displayName && Te.includes("<anonymous>") && (Te = Te.replace("<anonymous>", b.displayName)), typeof b == "function" && Ae.set(b, Te), Te;
                  }
                while (we >= 1 && Ce >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, ge.current = le, H(), Error.prepareStackTrace = de;
      }
      var kt = b ? b.displayName || b.name : "", Rt = kt ? ee(kt) : "";
      return typeof b == "function" && Ae.set(b, Rt), Rt;
    }
    function _e(b, F, I) {
      return We(b, !1);
    }
    function R(b) {
      var F = b.prototype;
      return !!(F && F.isReactComponent);
    }
    function ie(b, F, I) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return We(b, R(b));
      if (typeof b == "string")
        return ee(b);
      switch (b) {
        case u:
          return ee("Suspense");
        case c:
          return ee("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case s:
            return _e(b.render);
          case f:
            return ie(b.type, F, I);
          case p: {
            var K = b, de = K._payload, le = K._init;
            try {
              return ie(le(de), F, I);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Fe = {}, it = x.ReactDebugCurrentFrame;
    function vt(b) {
      if (b) {
        var F = b._owner, I = ie(b.type, b._source, F ? F.type : null);
        it.setExtraStackFrame(I);
      } else
        it.setExtraStackFrame(null);
    }
    function qe(b, F, I, K, de) {
      {
        var le = Function.call.bind(he);
        for (var se in b)
          if (le(b, se)) {
            var ae = void 0;
            try {
              if (typeof b[se] != "function") {
                var Ne = Error((K || "React class") + ": " + I + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ne.name = "Invariant Violation", Ne;
              }
              ae = b[se](F, se, K, I, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ae = we;
            }
            ae && !(ae instanceof Error) && (vt(de), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", K || "React class", I, se, typeof ae), vt(null)), ae instanceof Error && !(ae.message in Fe) && (Fe[ae.message] = !0, vt(de), $("Failed %s type: %s", I, ae.message), vt(null));
          }
      }
    }
    var ht = Array.isArray;
    function bt(b) {
      return ht(b);
    }
    function Nt(b) {
      {
        var F = typeof Symbol == "function" && Symbol.toStringTag, I = F && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return I;
      }
    }
    function gt(b) {
      try {
        return yt(b), !1;
      } catch {
        return !0;
      }
    }
    function yt(b) {
      return "" + b;
    }
    function at(b) {
      if (gt(b))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nt(b)), yt(b);
    }
    var Le = x.ReactCurrentOwner, lt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, It, ze;
    function hn(b) {
      if (he.call(b, "ref")) {
        var F = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function De(b) {
      if (he.call(b, "key")) {
        var F = Object.getOwnPropertyDescriptor(b, "key").get;
        if (F && F.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function Jt(b, F) {
      typeof b.ref == "string" && Le.current;
    }
    function Cr(b, F) {
      {
        var I = function() {
          It || (It = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        I.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: I,
          configurable: !0
        });
      }
    }
    function bn(b, F) {
      {
        var I = function() {
          ze || (ze = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", F));
        };
        I.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: I,
          configurable: !0
        });
      }
    }
    var Pr = function(b, F, I, K, de, le, se) {
      var ae = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: b,
        key: F,
        ref: I,
        props: se,
        // Record the component responsible for creating this element.
        _owner: le
      };
      return ae._store = {}, Object.defineProperty(ae._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ae, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: K
      }), Object.defineProperty(ae, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: de
      }), Object.freeze && (Object.freeze(ae.props), Object.freeze(ae)), ae;
    };
    function Or(b, F, I, K, de) {
      {
        var le, se = {}, ae = null, Ne = null;
        I !== void 0 && (at(I), ae = "" + I), De(F) && (at(F.key), ae = "" + F.key), hn(F) && (Ne = F.ref, Jt(F, de));
        for (le in F)
          he.call(F, le) && !lt.hasOwnProperty(le) && (se[le] = F[le]);
        if (b && b.defaultProps) {
          var we = b.defaultProps;
          for (le in we)
            se[le] === void 0 && (se[le] = we[le]);
        }
        if (ae || Ne) {
          var Ce = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          ae && Cr(se, Ce), Ne && bn(se, Ce);
        }
        return Pr(b, ae, Ne, de, K, Le.current, se);
      }
    }
    var Nn = x.ReactCurrentOwner, xt = x.ReactDebugCurrentFrame;
    function Ot(b) {
      if (b) {
        var F = b._owner, I = ie(b.type, b._source, F ? F.type : null);
        xt.setExtraStackFrame(I);
      } else
        xt.setExtraStackFrame(null);
    }
    var In;
    In = !1;
    function jn(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function gn() {
      {
        if (Nn.current) {
          var b = z(Nn.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function Zt(b) {
      return "";
    }
    var yn = {};
    function kn(b) {
      {
        var F = gn();
        if (!F) {
          var I = typeof b == "string" ? b : b.displayName || b.name;
          I && (F = `

Check the top-level render call using <` + I + ">.");
        }
        return F;
      }
    }
    function xn(b, F) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var I = kn(F);
        if (yn[I])
          return;
        yn[I] = !0;
        var K = "";
        b && b._owner && b._owner !== Nn.current && (K = " It was passed a child from " + z(b._owner.type) + "."), Ot(b), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', I, K), Ot(null);
      }
    }
    function jt(b, F) {
      {
        if (typeof b != "object")
          return;
        if (bt(b))
          for (var I = 0; I < b.length; I++) {
            var K = b[I];
            jn(K) && xn(K, F);
          }
        else if (jn(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var de = v(b);
          if (typeof de == "function" && de !== b.entries)
            for (var le = de.call(b), se; !(se = le.next()).done; )
              jn(se.value) && xn(se.value, F);
        }
      }
    }
    function xo(b) {
      {
        var F = b.type;
        if (F == null || typeof F == "string")
          return;
        var I;
        if (typeof F == "function")
          I = F.propTypes;
        else if (typeof F == "object" && (F.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        F.$$typeof === f))
          I = F.propTypes;
        else
          return;
        if (I) {
          var K = z(F);
          qe(I, b.props, "prop", K, b);
        } else if (F.PropTypes !== void 0 && !In) {
          In = !0;
          var de = z(F);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", de || "Unknown");
        }
        typeof F.getDefaultProps == "function" && !F.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $o(b) {
      {
        for (var F = Object.keys(b.props), I = 0; I < F.length; I++) {
          var K = F[I];
          if (K !== "children" && K !== "key") {
            Ot(b), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", K), Ot(null);
            break;
          }
        }
        b.ref !== null && (Ot(b), $("Invalid attribute `ref` supplied to `React.Fragment`."), Ot(null));
      }
    }
    var Tr = {};
    function Rr(b, F, I, K, de, le) {
      {
        var se = P(b);
        if (!se) {
          var ae = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ne = Zt();
          Ne ? ae += Ne : ae += gn();
          var we;
          b === null ? we = "null" : bt(b) ? we = "array" : b !== void 0 && b.$$typeof === t ? (we = "<" + (z(b.type) || "Unknown") + " />", ae = " Did you accidentally export a JSX literal instead of a component?") : we = typeof b, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ae);
        }
        var Ce = Or(b, F, I, de, le);
        if (Ce == null)
          return Ce;
        if (se) {
          var Te = F.children;
          if (Te !== void 0)
            if (K)
              if (bt(Te)) {
                for (var kt = 0; kt < Te.length; kt++)
                  jt(Te[kt], b);
                Object.freeze && Object.freeze(Te);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              jt(Te, b);
        }
        if (he.call(F, "key")) {
          var Rt = z(b), je = Object.keys(F).filter(function($n) {
            return $n !== "key";
          }), Bn = je.length > 0 ? "{key: someKey, " + je.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Tr[Rt + Bn]) {
            var Eo = je.length > 0 ? "{" + je.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Bn, Rt, Eo, Rt), Tr[Rt + Bn] = !0;
          }
        }
        return b === r ? $o(Ce) : xo(Ce), Ce;
      }
    }
    function wo(b, F, I) {
      return Rr(b, F, I, !0);
    }
    function Fr(b, F, I) {
      return Rr(b, F, I, !1);
    }
    var Vn = Fr, Tt = wo;
    Un.Fragment = r, Un.jsx = Vn, Un.jsxs = Tt;
  }()), Un;
}
var Xi;
function Ic() {
  return Xi || (Xi = 1, process.env.NODE_ENV === "production" ? Ir.exports = _c() : Ir.exports = Nc()), Ir.exports;
}
var C = Ic(), Co = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Ji;
function jc() {
  return Ji || (Ji = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (i = o(i, r(l)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var l in i)
          t.call(i, l) && i[l] && (a = o(a, l));
        return a;
      }
      function o(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(Co)), Co.exports;
}
var kc = jc();
const ye = /* @__PURE__ */ no(kc), al = A.forwardRef(
  ({ children: e, className: t, disabled: n, formGroup: r, ...o }, i) => {
    const a = ye(t, {
      "form-group": r
    });
    return /* @__PURE__ */ C.jsx("fieldset", { ...o, ref: i, className: a, disabled: n, children: e });
  }
), Ub = A.forwardRef(
  ({ children: e, className: t, disabled: n, inline: r, noValidate: o, validated: i, ...a }, l) => {
    const s = ye(t, "form", {
      "form-inline": r,
      "was-validated": i,
      "needs-validation": o
    });
    return /* @__PURE__ */ C.jsx("form", { ...a, className: s, noValidate: o, ref: l, children: /* @__PURE__ */ C.jsx(al, { disabled: n, children: e }) });
  }
), Gt = A.forwardRef(
  ({
    children: e,
    className: t,
    invalid: n,
    onBlur: r = () => {
    },
    onChange: o = () => {
    },
    tag: i = "input",
    valid: a,
    ...l
  }, s) => A.createElement(
    i,
    {
      ...l,
      className: ye(t, {
        "is-valid": a && !n,
        "is-invalid": n && !a
      }),
      onBlur: (u) => {
        u.stopPropagation(), r((u == null ? void 0 : u.target).value, u);
      },
      onChange: (u) => {
        u.stopPropagation(), o((u == null ? void 0 : u.target).value, u);
      },
      ref: s
    },
    e
  )
), ro = ({
  className: e,
  title: t = "Required",
  ...n
}) => {
  const r = ye(e, "required", "text-danger", "ml-1");
  return /* @__PURE__ */ C.jsx("span", { ...n, className: r, title: t, children: "*" });
}, Vc = A.forwardRef(
  ({ children: e, className: t, hidden: n, required: r, ...o }, i) => {
    const a = ye(t, {
      "sr-only": n
    });
    return /* @__PURE__ */ C.jsxs("legend", { ...o, ref: i, className: a, children: [
      e,
      r && /* @__PURE__ */ C.jsx(ro, {})
    ] });
  }
), ll = ({
  children: e,
  className: t,
  tag: n = "p",
  tooltip: r = !1,
  type: o = "help",
  ...i
}) => A.createElement(
  n,
  {
    ...i,
    className: ye(t, {
      "small form-text text-muted": o === "help",
      "valid-feedback mb-0": o === "success" && !r,
      "invalid-feedback mb-0": o === "error" && !r,
      "valid-tooltip": o === "success" && r,
      "invalid-tooltip": o === "error" && r
    })
  },
  e
), Bc = ({
  className: e,
  children: t,
  inline: n = !1,
  stacked: r = !1,
  type: o = "radio",
  legend: i,
  ...a
}) => {
  const l = re(
    () => ({
      type: o,
      stacked: r
    }),
    [o, r]
  );
  return /* @__PURE__ */ C.jsx(sl.Provider, { value: l, children: /* @__PURE__ */ C.jsxs(al, { formGroup: !0, children: [
    /* @__PURE__ */ C.jsx(Vc, { children: i }),
    /* @__PURE__ */ C.jsx("div", { className: n ? "advanced-choice__wrapper--inline" : "", ...a, children: t })
  ] }) });
}, sl = xe(null), Hc = () => {
  const e = be(sl);
  if (e == null)
    throw new Error("useChoiceContext must be used within a ChoiceContext.Provider");
  return e;
}, Wc = A.forwardRef(
  ({ className: e, description: t, imageUrl: n, label: r, id: o, ...i }, a) => {
    const { stacked: l, type: s = "radio" } = Hc(), u = ye(e, "advanced-choice", l && "advanced-choice--stacked");
    return /* @__PURE__ */ C.jsxs("div", { className: u, children: [
      /* @__PURE__ */ C.jsx(
        Gt,
        {
          ...i,
          id: o,
          className: "advanced-choice__input",
          ref: a,
          type: s
        }
      ),
      /* @__PURE__ */ C.jsxs("label", { className: "advanced-choice__label form-check-label", htmlFor: o, children: [
        r,
        /* @__PURE__ */ C.jsx(ll, { className: "my-0", children: t })
      ] }),
      n && /* @__PURE__ */ C.jsx("img", { src: n, alt: "", className: "advanced-choice__image" })
    ] });
  }
), qb = Object.assign(Bc, {
  Item: Wc
}), Zi = A.forwardRef(
  ({ children: e, className: t, id: n, label: r, inline: o = !1, indeterminate: i = !1, ...a }, l) => {
    const s = ye(t, "form-check", o && "form-check-inline"), u = A.useRef({
      innerRef: null,
      outerRef: null
    });
    return A.useEffect(() => {
      u.current.innerRef && (u.current.innerRef.indeterminate = i);
    }, [i]), /* @__PURE__ */ C.jsxs("div", { className: s, children: [
      /* @__PURE__ */ C.jsx(
        Gt,
        {
          ...a,
          id: n,
          ref: (c) => {
            u.current = {
              innerRef: c,
              outerRef: l
            };
          },
          type: "checkbox",
          className: "form-check-input"
        }
      ),
      /* @__PURE__ */ C.jsx("label", { className: "form-check-label", htmlFor: n, children: r }),
      e
    ] });
  }
);
var oo = /* @__PURE__ */ ((e) => (e.primary = "primary", e.secondary = "secondary", e.success = "success", e.danger = "danger", e.warning = "warning", e.info = "info", e.light = "light", e.dark = "dark", e.link = "link", e.unstyled = "unstyled", e.text = "text", e))(oo || {}), er = /* @__PURE__ */ ((e) => (e.xsmall = "xs", e.small = "sm", e.medium = "md", e.large = "lg", e.xlarge = "xl", e))(er || {}), Xn = /* @__PURE__ */ ((e) => (e.brand = "brand", e.regular = "regular", e.solid = "solid", e))(Xn || {});
const zc = ({
  append: e,
  appendClassName: t,
  children: n,
  className: r,
  feedback: o,
  matching: i,
  prepend: a,
  prependClassName: l,
  size: s = er.medium,
  ...u
}) => {
  const c = ye(r, "input-group", {
    [`input-group-${s}`]: s,
    "input-group--matching-icon": i
  });
  return /* @__PURE__ */ C.jsxs("div", { ...u, className: c, children: [
    a && /* @__PURE__ */ C.jsx("span", { className: ye(l, "input-group-prepend"), children: a }),
    n,
    e && /* @__PURE__ */ C.jsx("span", { className: ye(t, "input-group-append"), children: e }),
    o
  ] });
}, Uc = A.forwardRef(
  ({ children: e, className: t, hidden: n, htmlFor: r, required: o = !1, ...i }, a) => {
    const l = ye(t, "form-label", {
      "sr-only": n
    });
    return /* @__PURE__ */ C.jsxs("label", { ...i, ref: a, className: l, htmlFor: r, children: [
      e,
      o && /* @__PURE__ */ C.jsx(ro, {})
    ] });
  }
), ul = A.forwardRef(
  ({ className: e, plaintext: t, size: n, ...r }, o) => {
    const i = ye(e, {
      "form-control": !t,
      "form-control-plaintext": t,
      [`form-control-${n}`]: n
    });
    return /* @__PURE__ */ C.jsx(Gt, { ...r, className: i, ref: o });
  }
), Yb = A.forwardRef(
  ({
    id: e,
    label: t,
    onChange: n = () => {
    },
    required: r = !1,
    value: o
  }, i) => /* @__PURE__ */ C.jsxs(A.Fragment, { children: [
    /* @__PURE__ */ C.jsx(Uc, { htmlFor: `${e}-color`, id: `${e}-label`, required: r, children: t }),
    /* @__PURE__ */ C.jsx(
      zc,
      {
        prepend: /* @__PURE__ */ C.jsx(
          Gt,
          {
            id: `${e}-color`,
            type: "color",
            onChange: (a) => {
              n(a);
            },
            onInput: (a) => {
              n(a.target.value);
            },
            className: "form-control",
            style: {
              width: "40px",
              padding: "1px 2px",
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            },
            value: o,
            required: r
          }
        ),
        children: /* @__PURE__ */ C.jsx(
          ul,
          {
            ref: i,
            id: `${e}-text`,
            "aria-labelledby": `${e}-label`,
            value: o,
            maxLength: 7,
            pattern: "#[0-9A-Fa-f]{6}",
            title: "#FFFFFF",
            onChange: (a) => {
              n(a);
            }
          }
        )
      }
    )
  ] })
), Kt = typeof document < "u" ? A.useLayoutEffect : () => {
};
function ct(e) {
  const t = X(null);
  return Kt(() => {
    t.current = e;
  }, [
    e
  ]), pe((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
function qc(e) {
  let [t, n] = oe(e), r = X(null), o = ct(() => {
    if (!r.current) return;
    let a = r.current.next();
    if (a.done) {
      r.current = null;
      return;
    }
    t === a.value ? o() : n(a.value);
  });
  Kt(() => {
    r.current && o();
  });
  let i = ct((a) => {
    r.current = a(t), o();
  });
  return [
    t,
    i
  ];
}
const Yr = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, cl = /* @__PURE__ */ A.createContext(Yr), Yc = /* @__PURE__ */ A.createContext(!1);
let Gc = !!(typeof window < "u" && window.document && window.document.createElement), Po = /* @__PURE__ */ new WeakMap();
function Kc(e = !1) {
  let t = be(cl), n = X(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let a = Po.get(i);
      a == null ? Po.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== a.state && (t.current = a.id, Po.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Xc(e) {
  let t = be(cl);
  t === Yr && !Gc && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Kc(!!e), r = t === Yr && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Jc(e) {
  let t = A.useId(), [n] = oe(fl()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Yr.prefix}`;
  return e || `${r}-${t}`;
}
const Zc = typeof A.useId == "function" ? Jc : Xc;
function Qc() {
  return !1;
}
function ef() {
  return !0;
}
function tf(e) {
  return () => {
  };
}
function fl() {
  return typeof A.useSyncExternalStore == "function" ? A.useSyncExternalStore(tf, Qc, ef) : be(Yc);
}
let nf = !!(typeof window < "u" && window.document && window.document.createElement), Pn = /* @__PURE__ */ new Map(), Jn;
typeof FinalizationRegistry < "u" && (Jn = new FinalizationRegistry((e) => {
  Pn.delete(e);
}));
function an(e) {
  let [t, n] = oe(e), r = X(null), o = Zc(t), i = X(null);
  if (Jn && Jn.register(i, o), nf) {
    const a = Pn.get(o);
    a && !a.includes(r) ? a.push(r) : Pn.set(o, [
      r
    ]);
  }
  return Kt(() => {
    let a = o;
    return () => {
      Jn && Jn.unregister(i), Pn.delete(a);
    };
  }, [
    o
  ]), ue(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), o;
}
function rf(e, t) {
  if (e === t) return e;
  let n = Pn.get(e);
  if (n)
    return n.forEach((o) => o.current = t), t;
  let r = Pn.get(t);
  return r ? (r.forEach((o) => o.current = e), e) : t;
}
function Qi(e = []) {
  let t = an(), [n, r] = qc(t), o = pe(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return Kt(o, [
    t,
    o,
    ...e
  ]), n;
}
function dl(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const At = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Wt = (e) => e && "window" in e && e.window === e ? e : At(e).defaultView || window;
function of(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function af(e) {
  return of(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let lf = !1;
function di() {
  return lf;
}
function pl(e, t) {
  if (!di()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : af(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const ar = (e = document) => {
  var t;
  if (!di()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function ml(e) {
  return di() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function vl(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = vl(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function sf() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = vl(e)) && (r && (r += " "), r += t);
  return r;
}
function ft(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let i = t[o], a = r[o];
      typeof i == "function" && typeof a == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = dl(i, a) : (o === "className" || o === "UNSAFE_className") && typeof i == "string" && typeof a == "string" ? t[o] = sf(i, a) : o === "id" && i && a ? t.id = rf(i, a) : t[o] = a !== void 0 ? a : i;
    }
  }
  return t;
}
function uf(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    for (let n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
const cf = /* @__PURE__ */ new Set([
  "id"
]), ff = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), df = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), pf = /^(data-.*)$/;
function io(e, t = {}) {
  let { labelable: n, isLink: r, propNames: o } = t, i = {};
  for (const a in e) Object.prototype.hasOwnProperty.call(e, a) && (cf.has(a) || n && ff.has(a) || r && df.has(a) || o != null && o.has(a) || pf.test(a)) && (i[a] = e[a]);
  return i;
}
function ea(e) {
  if (mf()) e.focus({
    preventScroll: !0
  });
  else {
    let t = vf(e);
    e.focus(), hf(t);
  }
}
let jr = null;
function mf() {
  if (jr == null) {
    jr = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return jr = !0, !0;
        }
      });
    } catch {
    }
  }
  return jr;
}
function vf(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function hf(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function bf(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function pi(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function vr(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const hl = vr(function() {
  return pi(/^Mac/i);
}), bl = vr(function() {
  return pi(/^iPhone/i);
}), gf = vr(function() {
  return pi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  hl() && navigator.maxTouchPoints > 1;
}), yf = vr(function() {
  return bl() || gf();
}), gl = vr(function() {
  return bf(/Android/i);
});
let Cn = /* @__PURE__ */ new Map(), Wo = /* @__PURE__ */ new Set();
function ta() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let o = Cn.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), Cn.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let o = Cn.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), Cn.delete(r.target)), Cn.size === 0)) {
      for (let i of Wo) i();
      Wo.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? ta() : document.addEventListener("DOMContentLoaded", ta));
function xf(e) {
  requestAnimationFrame(() => {
    Cn.size === 0 ? e() : Wo.add(e);
  });
}
function mi() {
  let e = X(/* @__PURE__ */ new Map()), t = pe((o, i, a, l) => {
    let s = l != null && l.once ? (...u) => {
      e.current.delete(a), a(...u);
    } : a;
    e.current.set(a, {
      type: i,
      eventTarget: o,
      fn: s,
      options: l
    }), o.addEventListener(i, s, l);
  }, []), n = pe((o, i, a, l) => {
    var s;
    let u = ((s = e.current.get(a)) === null || s === void 0 ? void 0 : s.fn) || a;
    o.removeEventListener(i, u, l), e.current.delete(a);
  }, []), r = pe(() => {
    e.current.forEach((o, i) => {
      n(o.eventTarget, o.type, i, o.options);
    });
  }, [
    n
  ]);
  return ue(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function $f(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = an(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      n,
      ...o.trim().split(/\s+/)
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
function wf(e) {
  const t = X(null);
  return re(() => ({
    get current() {
      return t.current;
    },
    set current(n) {
      t.current = n, typeof e == "function" ? e(n) : e && (e.current = n);
    }
  }), [
    e
  ]);
}
function Ef(e, t) {
  Kt(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Sf(e, t, n, r) {
  let o = ct(n), i = n == null;
  ue(() => {
    if (i || !e.current) return;
    let a = e.current;
    return a.addEventListener(t, o, r), () => {
      a.removeEventListener(t, o, r);
    };
  }, [
    e,
    t,
    r,
    i,
    o
  ]);
}
function Cf(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : gl() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function yl(e, t, n) {
  let r = X(t), o = ct(() => {
    n && n(r.current);
  });
  ue(() => {
    var i;
    let a = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return a == null || a.addEventListener("reset", o), () => {
      a == null || a.removeEventListener("reset", o);
    };
  }, [
    e,
    o
  ]);
}
function xl(e, t, n) {
  let [r, o] = oe(e || t), i = X(e !== void 0), a = e !== void 0;
  ue(() => {
    let u = i.current;
    u !== a && console.warn(`WARN: A component changed from ${u ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}.`), i.current = a;
  }, [
    a
  ]);
  let l = a ? e : r, s = pe((u, ...c) => {
    let f = (p, ...d) => {
      n && (Object.is(l, p) || n(p, ...d)), a || (l = p);
    };
    typeof u == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((d, ...g) => {
      let h = u(a ? l : d, ...g);
      return f(h, ...c), a ? d : h;
    })) : (a || o(u), f(u, ...c));
  }, [
    a,
    l,
    n
  ]);
  return [
    l,
    s
  ];
}
function Oo(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function kr(e, t) {
  let n = e, r = t.toString(), o = r.indexOf("."), i = o >= 0 ? r.length - o : 0;
  if (i > 0) {
    let a = Math.pow(10, i);
    n = Math.round(n * a) / a;
  }
  return n;
}
function Lt(e, t, n, r) {
  t = Number(t), n = Number(n);
  let o = (e - (isNaN(t) ? 0 : t)) % r, i = kr(Math.abs(o) * 2 >= r ? e + Math.sign(o) * (r - Math.abs(o)) : e - o, r);
  return isNaN(t) ? !isNaN(n) && i > n && (i = Math.floor(kr(n / r, r)) * r) : i < t ? i = t : !isNaN(n) && i > n && (i = t + Math.floor(kr((n - t) / r, r)) * r), i = kr(i, r), i;
}
const Pf = Symbol("default");
function Of({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ A.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function ao(e) {
  let { className: t, style: n, children: r, defaultClassName: o, defaultChildren: i, defaultStyle: a, values: l } = e;
  return re(() => {
    let s, u, c;
    return typeof t == "function" ? s = t({
      ...l,
      defaultClassName: o
    }) : s = t, typeof n == "function" ? u = n({
      ...l,
      defaultStyle: a || {}
    }) : u = n, typeof r == "function" ? c = r({
      ...l,
      defaultChildren: i
    }) : r == null ? c = i : c = r, {
      className: s ?? o,
      style: u || a ? {
        ...a,
        ...u
      } : void 0,
      children: c ?? i,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    o,
    i,
    a,
    l
  ]);
}
function $l(e, t) {
  let n = be(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || Pf;
    if (!n.slots[r]) {
      let o = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), i = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${i} Valid slot names are ${o}.`);
    }
    return n.slots[r];
  }
  return n;
}
function hr(e, t, n) {
  let r = $l(n, e.slot) || {}, { ref: o, ...i } = r, a = wf(re(() => uf(t, o), [
    t,
    o
  ])), l = ft(i, e);
  return "style" in i && i.style && "style" in e && e.style && (typeof i.style == "function" || typeof e.style == "function" ? l.style = (s) => {
    let u = typeof i.style == "function" ? i.style(s) : i.style, c = {
      ...s.defaultStyle,
      ...u
    }, f = typeof e.style == "function" ? e.style({
      ...s,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : l.style = {
    ...i.style,
    ...e.style
  }), [
    l,
    a
  ];
}
function Tf(e = !0) {
  let [t, n] = oe(e), r = X(!1), o = pe((i) => {
    r.current = !0, n(!!i);
  }, []);
  return Kt(() => {
    r.current || n(!1);
  }, []), [
    o,
    t
  ];
}
function Rf(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const Ff = /* @__PURE__ */ xe(!1);
function wl(e) {
  let t = (n, r) => be(Ff) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, qt(t);
}
class El {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function Sl(e) {
  let t = X({
    isFocused: !1,
    observer: null
  });
  Kt(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = ct((r) => {
    e == null || e(r);
  });
  return pe((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, i = (a) => {
        t.current.isFocused = !1, o.disabled && n(new El("blur", a)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let l = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Lf = !1, mn = null, zo = /* @__PURE__ */ new Set(), tr = /* @__PURE__ */ new Map(), un = !1, Uo = !1;
const Df = {
  Tab: !0,
  Escape: !0
};
function lo(e, t) {
  for (let n of zo) n(e, t);
}
function Mf(e) {
  return !(e.metaKey || !hl() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Gr(e) {
  un = !0, Mf(e) && (mn = "keyboard", lo("keyboard", e));
}
function tt(e) {
  mn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (un = !0, lo("pointer", e));
}
function Cl(e) {
  Cf(e) && (un = !0, mn = "virtual");
}
function Pl(e) {
  e.target === window || e.target === document || Lf || !e.isTrusted || (!un && !Uo && (mn = "virtual", lo("virtual", e)), un = !1, Uo = !1);
}
function Ol() {
  un = !1, Uo = !0;
}
function qo(e) {
  if (typeof window > "u" || tr.get(Wt(e))) return;
  const t = Wt(e), n = At(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    un = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Gr, !0), n.addEventListener("keyup", Gr, !0), n.addEventListener("click", Cl, !0), t.addEventListener("focus", Pl, !0), t.addEventListener("blur", Ol, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", tt, !0), n.addEventListener("pointermove", tt, !0), n.addEventListener("pointerup", tt, !0)) : (n.addEventListener("mousedown", tt, !0), n.addEventListener("mousemove", tt, !0), n.addEventListener("mouseup", tt, !0)), t.addEventListener("beforeunload", () => {
    Tl(e);
  }, {
    once: !0
  }), tr.set(t, {
    focus: r
  });
}
const Tl = (e, t) => {
  const n = Wt(e), r = At(e);
  t && r.removeEventListener("DOMContentLoaded", t), tr.has(n) && (n.HTMLElement.prototype.focus = tr.get(n).focus, r.removeEventListener("keydown", Gr, !0), r.removeEventListener("keyup", Gr, !0), r.removeEventListener("click", Cl, !0), n.removeEventListener("focus", Pl, !0), n.removeEventListener("blur", Ol, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", tt, !0), r.removeEventListener("pointermove", tt, !0), r.removeEventListener("pointerup", tt, !0)) : (r.removeEventListener("mousedown", tt, !0), r.removeEventListener("mousemove", tt, !0), r.removeEventListener("mouseup", tt, !0)), tr.delete(n));
};
function Af(e) {
  const t = At(e);
  let n;
  return t.readyState !== "loading" ? qo(e) : (n = () => {
    qo(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Tl(e, n);
}
typeof document < "u" && Af();
function Rl() {
  return mn !== "pointer";
}
function _f() {
  return mn;
}
function Nf(e) {
  mn = e, lo(e, null);
}
const If = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function jf(e, t, n) {
  let r = At(n == null ? void 0 : n.target);
  const o = typeof window < "u" ? Wt(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? Wt(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, a = typeof window < "u" ? Wt(n == null ? void 0 : n.target).HTMLElement : HTMLElement, l = typeof window < "u" ? Wt(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof o && !If.has(r.activeElement.type) || r.activeElement instanceof i || r.activeElement instanceof a && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof l && !Df[n.key]);
}
function kf(e, t, n) {
  qo(), ue(() => {
    let r = (o, i) => {
      jf(!!(n != null && n.isTextInput), o, i) && e(Rl());
    };
    return zo.add(r), () => {
      zo.delete(r);
    };
  }, t);
}
function Vf(e) {
  const t = At(e), n = ar(t);
  if (_f() === "virtual") {
    let r = n;
    xf(() => {
      ar(t) === r && e.isConnected && ea(e);
    });
  } else ea(e);
}
function vi(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const i = pe((s) => {
    if (s.target === s.currentTarget)
      return r && r(s), o && o(!1), !0;
  }, [
    r,
    o
  ]), a = Sl(i), l = pe((s) => {
    const u = At(s.target), c = u ? ar(u) : ar();
    s.target === s.currentTarget && c === ml(s.nativeEvent) && (n && n(s), o && o(!0), a(s));
  }, [
    o,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? l : void 0,
      onBlur: !t && (r || o) ? i : void 0
    }
  };
}
function na(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Bf(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: na(e.onKeyDown),
      onKeyUp: na(e.onKeyUp)
    }
  };
}
let Hf = /* @__PURE__ */ A.createContext(null);
function Wf(e) {
  let t = be(Hf) || {};
  Ef(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function zf(e, t) {
  let { focusProps: n } = vi(e), { keyboardProps: r } = Bf(e), o = ft(n, r), i = Wf(t), a = e.isDisabled ? {} : i, l = X(e.autoFocus);
  ue(() => {
    l.current && t.current && Vf(t.current), l.current = !1;
  }, [
    t
  ]);
  let s = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (s = void 0), {
    focusableProps: ft({
      ...o,
      tabIndex: s
    }, a)
  };
}
function Fl(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, i = X({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: l } = mi(), s = pe((f) => {
    f.currentTarget.contains(f.target) && i.current.isFocusWithin && !f.currentTarget.contains(f.relatedTarget) && (i.current.isFocusWithin = !1, l(), n && n(f), o && o(!1));
  }, [
    n,
    o,
    i,
    l
  ]), u = Sl(s), c = pe((f) => {
    if (!f.currentTarget.contains(f.target)) return;
    const p = At(f.target), d = ar(p);
    if (!i.current.isFocusWithin && d === ml(f.nativeEvent)) {
      r && r(f), o && o(!0), i.current.isFocusWithin = !0, u(f);
      let g = f.currentTarget;
      a(p, "focus", (h) => {
        if (i.current.isFocusWithin && !pl(g, h.target)) {
          let v = new El("blur", new p.defaultView.FocusEvent("blur", {
            relatedTarget: h.target
          }));
          v.target = g, v.currentTarget = g, s(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    o,
    u,
    a,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: s
    }
  };
}
let Kr = !1, To = 0;
function Yo() {
  Kr = !0, setTimeout(() => {
    Kr = !1;
  }, 50);
}
function ra(e) {
  e.pointerType === "touch" && Yo();
}
function Uf() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", ra) : document.addEventListener("touchend", Yo), To++, () => {
      To--, !(To > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", ra) : document.removeEventListener("touchend", Yo));
    };
}
function so(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [i, a] = oe(!1), l = X({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  ue(Uf, []);
  let { addGlobalListener: s, removeAllGlobalListeners: u } = mi(), { hoverProps: c, triggerHoverEnd: f } = re(() => {
    let p = (h, v) => {
      if (l.pointerType = v, o || v === "touch" || l.isHovered || !h.currentTarget.contains(h.target)) return;
      l.isHovered = !0;
      let x = h.currentTarget;
      l.target = x, s(At(h.target), "pointerover", ($) => {
        l.isHovered && l.target && !pl(l.target, $.target) && d($, $.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: x,
        pointerType: v
      }), n && n(!0), a(!0);
    }, d = (h, v) => {
      let x = l.target;
      l.pointerType = "", l.target = null, !(v === "touch" || !l.isHovered || !x) && (l.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: x,
        pointerType: v
      }), n && n(!1), a(!1));
    }, g = {};
    return typeof PointerEvent < "u" ? (g.onPointerEnter = (h) => {
      Kr && h.pointerType === "mouse" || p(h, h.pointerType);
    }, g.onPointerLeave = (h) => {
      !o && h.currentTarget.contains(h.target) && d(h, h.pointerType);
    }) : (g.onTouchStart = () => {
      l.ignoreEmulatedMouseEvents = !0;
    }, g.onMouseEnter = (h) => {
      !l.ignoreEmulatedMouseEvents && !Kr && p(h, "mouse"), l.ignoreEmulatedMouseEvents = !1;
    }, g.onMouseLeave = (h) => {
      !o && h.currentTarget.contains(h.target) && d(h, "mouse");
    }), {
      hoverProps: g,
      triggerHoverEnd: d
    };
  }, [
    t,
    n,
    r,
    o,
    l,
    s,
    u
  ]);
  return ue(() => {
    o && f({
      currentTarget: l.target
    }, l.pointerType);
  }, [
    o
  ]), {
    hoverProps: c,
    isHovered: i
  };
}
function qf(e, t) {
  let { onScroll: n, isDisabled: r } = e, o = pe((i) => {
    i.ctrlKey || (i.preventDefault(), i.stopPropagation(), n && n({
      deltaX: i.deltaX,
      deltaY: i.deltaY
    }));
  }, [
    n
  ]);
  Sf(t, "wheel", r ? void 0 : o);
}
const Yf = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Gf = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Kf(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Yf.has(n.script);
  }
  let t = e.split("-")[0];
  return Gf.has(t);
}
const Xf = Symbol.for("react-aria.i18n.locale");
function Ll() {
  let e = typeof window < "u" && window[Xf] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Kf(e) ? "rtl" : "ltr"
  };
}
let Go = Ll(), Zn = /* @__PURE__ */ new Set();
function oa() {
  Go = Ll();
  for (let e of Zn) e(Go);
}
function Jf() {
  let e = fl(), [t, n] = oe(Go);
  return ue(() => (Zn.size === 0 && window.addEventListener("languagechange", oa), Zn.add(n), () => {
    Zn.delete(n), Zn.size === 0 && window.removeEventListener("languagechange", oa);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Zf = /* @__PURE__ */ A.createContext(null);
function hi() {
  let e = Jf();
  return be(Zf) || e;
}
const Qf = Symbol.for("react-aria.i18n.locale"), ed = Symbol.for("react-aria.i18n.strings");
let En;
class uo {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let o = this.getStringsForLocale(n)[t];
    if (!o) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return o;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = td(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[Qf];
    if (En === void 0) {
      let o = window[ed];
      if (!o) return null;
      En = {};
      for (let i in o) En[i] = new uo({
        [n]: o[i]
      }, n);
    }
    let r = En == null ? void 0 : En[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function td(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = nd(e);
  if (t[r]) return t[r];
  for (let o in t)
    if (o.startsWith(r + "-")) return t[o];
  return t[n];
}
function nd(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const ia = /* @__PURE__ */ new Map(), aa = /* @__PURE__ */ new Map();
class rd {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let o = n["=" + t];
    if (o) return typeof o == "function" ? o() : o;
    let i = this.locale + ":" + r, a = ia.get(i);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), ia.set(i, a));
    let l = a.select(t);
    return o = n[l] || n.other, typeof o == "function" ? o() : o;
  }
  number(t) {
    let n = aa.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), aa.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const la = /* @__PURE__ */ new WeakMap();
function od(e) {
  let t = la.get(e);
  return t || (t = new uo(e), la.set(e, t)), t;
}
function id(e, t) {
  return t && uo.getGlobalDictionaryForPackage(t) || od(e);
}
function Dl(e, t) {
  let { locale: n } = hi(), r = id(e, t);
  return re(() => new rd(n, r), [
    n,
    r
  ]);
}
let Ro = /* @__PURE__ */ new Map(), Ko = !1;
try {
  Ko = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Xr = !1;
try {
  Xr = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Ml = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Jr {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!Ko && this.options.signDisplay != null ? n = ld(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Xr) {
      var r;
      let { unit: o, unitDisplay: i = "short", locale: a } = this.resolvedOptions();
      if (!o) return n;
      let l = (r = Ml[o]) === null || r === void 0 ? void 0 : r[i];
      n += l[a] || l.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), o = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !Ko && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Xr && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = ad(t, n), this.options = n;
  }
}
function ad(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Xr) {
    var r;
    let { unit: a, unitDisplay: l = "short" } = t;
    if (!a) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = Ml[a]) === null || r === void 0) && r[l])) throw new Error(`Unsupported unit ${a} with unitDisplay = ${l}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let o = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (Ro.has(o)) return Ro.get(o);
  let i = new Intl.NumberFormat(e, t);
  return Ro.set(o, i), i;
}
function ld(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let o = e.format(-n), i = e.format(n), a = o.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...a
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(i, "!!!").replace(a, "+").replace("!!!", i);
    } else return e.format(n);
  }
}
const sd = new RegExp("^.*\\(.*\\).*$"), ud = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng"
];
class Al {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return Fo(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, n, r) {
    return Fo(this.locale, this.options, t).isValidPartialNumber(t, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return Fo(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, n = {}) {
    this.locale = t, this.options = n;
  }
}
const sa = /* @__PURE__ */ new Map();
function Fo(e, t, n) {
  let r = ua(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let o of ud) if (o !== r.options.numberingSystem) {
      let i = ua(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + o, t);
      if (i.isValidPartialNumber(n)) return i;
    }
  }
  return r;
}
function ua(e, t) {
  let n = e + (t ? Object.entries(t).sort((o, i) => o[0] < i[0] ? -1 : 1).join() : ""), r = sa.get(n);
  return r || (r = new cd(e, t), sa.set(n, r)), r;
}
class cd {
  parse(t) {
    let n = this.sanitize(t);
    if (this.symbols.group && (n = Vr(n, this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let a = n.indexOf("-");
      n = n.replace("-", "");
      let l = n.indexOf(".");
      l === -1 && (l = n.length), n = n.replace(".", ""), l - 2 === 0 ? n = `0.${n}` : l - 2 === -1 ? n = `0.0${n}` : l - 2 === -2 ? n = "0.00" : n = `${n.slice(0, l - 2)}.${n.slice(l - 2)}`, a > -1 && (n = `-${n}`);
    }
    let r = n ? +n : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var o, i;
      let a = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((o = this.options.minimumFractionDigits) !== null && o !== void 0 ? o : 0) + 2, 20),
        maximumFractionDigits: Math.min(((i = this.options.maximumFractionDigits) !== null && i !== void 0 ? i : 0) + 2, 20)
      };
      return new Al(this.locale, a).parse(new Jr(this.locale, a).format(r));
    }
    return this.options.currencySign === "accounting" && sd.test(t) && (r = -1 * r), r;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = t.replace(",", this.symbols.decimal), t = t.replace("،", this.symbols.decimal)), this.symbols.group && (t = Vr(t, ".", this.symbols.group))), this.options.locale === "fr-FR" && (t = Vr(t, ".", " ")), t;
  }
  isValidPartialNumber(t, n = -1 / 0, r = 1 / 0) {
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && n < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.group && t.startsWith(this.symbols.group) || this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (t = Vr(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
  constructor(t, n = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, n), this.options = this.formatter.resolvedOptions(), this.symbols = dd(t, this.formatter, this.options, n);
    var r, o;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((o = this.options.maximumFractionDigits) !== null && o !== void 0 ? o : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const ca = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), fd = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function dd(e, t, n, r) {
  var o, i, a, l;
  let s = new Intl.NumberFormat(e, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand"
  }), u = s.formatToParts(-10000.111), c = s.formatToParts(10000.111), f = fd.map((P) => s.formatToParts(P));
  var p;
  let d = (p = (o = u.find((P) => P.type === "minusSign")) === null || o === void 0 ? void 0 : o.value) !== null && p !== void 0 ? p : "-", g = (i = c.find((P) => P.type === "plusSign")) === null || i === void 0 ? void 0 : i.value;
  !g && ((r == null ? void 0 : r.signDisplay) === "exceptZero" || (r == null ? void 0 : r.signDisplay) === "always") && (g = "+");
  let v = (a = new Intl.NumberFormat(e, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((P) => P.type === "decimal")) === null || a === void 0 ? void 0 : a.value, x = (l = u.find((P) => P.type === "group")) === null || l === void 0 ? void 0 : l.value, $ = u.filter((P) => !ca.has(P.type)).map((P) => fa(P.value)), w = f.flatMap((P) => P.filter((D) => !ca.has(D.type)).map((D) => fa(D.value))), S = [
    .../* @__PURE__ */ new Set([
      ...$,
      ...w
    ])
  ].sort((P, D) => D.length - P.length), E = S.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${S.join("|")}|[\\p{White_Space}]`, "gu"), L = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), T = new Map(L.map((P, D) => [
    P,
    D
  ])), _ = new RegExp(`[${L.join("")}]`, "g");
  return {
    minusSign: d,
    plusSign: g,
    decimal: v,
    group: x,
    literals: E,
    numeral: _,
    index: (P) => String(T.get(P))
  };
}
function Vr(e, t, n) {
  return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function fa(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function da(e = {}) {
  let { locale: t } = hi();
  return re(() => new Jr(t, e), [
    t,
    e
  ]);
}
function co(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = X({
    isFocused: !1,
    isFocusVisible: t || Rl()
  }), [i, a] = oe(!1), [l, s] = oe(() => o.current.isFocused && o.current.isFocusVisible), u = pe(() => s(o.current.isFocused && o.current.isFocusVisible), []), c = pe((d) => {
    o.current.isFocused = d, a(d), u();
  }, [
    u
  ]);
  kf((d) => {
    o.current.isFocusVisible = d, u();
  }, [], {
    isTextInput: n
  });
  let { focusProps: f } = vi({
    isDisabled: r,
    onFocusChange: c
  }), { focusWithinProps: p } = Fl({
    isDisabled: !r,
    onFocusWithinChange: c
  });
  return {
    isFocused: i,
    isFocusVisible: l,
    focusProps: r ? p : f
  };
}
const _l = 7e3;
let et = null;
function pd(e, t = "assertive", n = _l) {
  et ? et.announce(e, t, n) : (et = new vd(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? et.announce(e, t, n) : setTimeout(() => {
    et != null && et.isAttached() && (et == null || et.announce(e, t, n));
  }, 100));
}
function md(e) {
  et && et.clear(e);
}
class vd {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = _l) {
    var o, i;
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? (o = this.assertiveLog) === null || o === void 0 || o.appendChild(a) : (i = this.politeLog) === null || i === void 0 || i.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const Nl = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Il = {
  ...Nl,
  customError: !0,
  valid: !1
}, qn = {
  isInvalid: !1,
  validationDetails: Nl,
  validationErrors: []
}, hd = xe({}), Xo = "__formValidationState" + Date.now();
function jl(e) {
  if (e[Xo]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: o, commitValidation: i } = e[Xo];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: o,
      commitValidation: i
    };
  }
  return bd(e);
}
function bd(e) {
  let { isInvalid: t, validationState: n, name: r, value: o, builtinValidation: i, validate: a, validationBehavior: l = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let s = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: Il
  } : null, u = re(() => {
    if (!a || o == null) return null;
    let P = gd(a, o);
    return pa(P);
  }, [
    a,
    o
  ]);
  i != null && i.validationDetails.valid && (i = void 0);
  let c = be(hd), f = re(() => r ? Array.isArray(r) ? r.flatMap((P) => Jo(c[P])) : Jo(c[r]) : [], [
    c,
    r
  ]), [p, d] = oe(c), [g, h] = oe(!1);
  c !== p && (d(c), h(!1));
  let v = re(() => pa(g ? [] : f), [
    g,
    f
  ]), x = X(qn), [$, w] = oe(qn), S = X(qn), E = () => {
    if (!L) return;
    T(!1);
    let P = u || i || x.current;
    Lo(P, S.current) || (S.current = P, w(P));
  }, [L, T] = oe(!1);
  return ue(E), {
    realtimeValidation: s || v || u || i || qn,
    displayValidation: l === "native" ? s || v || $ : s || v || u || i || $,
    updateValidation(P) {
      l === "aria" && !Lo($, P) ? w(P) : x.current = P;
    },
    resetValidation() {
      let P = qn;
      Lo(P, S.current) || (S.current = P, w(P)), l === "native" && T(!1), h(!0);
    },
    commitValidation() {
      l === "native" && T(!0), h(!0);
    }
  };
}
function Jo(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function gd(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Jo(n);
  }
  return [];
}
function pa(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Il
  } : null;
}
function Lo(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
function yd(e, t, n) {
  let { validationBehavior: r, focus: o } = e;
  Kt(() => {
    if (r === "native" && (n != null && n.current) && !n.current.disabled) {
      let s = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(s), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation($d(n.current));
    }
  });
  let i = ct(() => {
    t.resetValidation();
  }), a = ct((s) => {
    var u;
    t.displayValidation.isInvalid || t.commitValidation();
    let c = n == null || (u = n.current) === null || u === void 0 ? void 0 : u.form;
    if (!s.defaultPrevented && n && c && wd(c) === n.current) {
      var f;
      o ? o() : (f = n.current) === null || f === void 0 || f.focus(), Nf("keyboard");
    }
    s.preventDefault();
  }), l = ct(() => {
    t.commitValidation();
  });
  ue(() => {
    let s = n == null ? void 0 : n.current;
    if (!s) return;
    let u = s.form;
    return s.addEventListener("invalid", a), s.addEventListener("change", l), u == null || u.addEventListener("reset", i), () => {
      s.removeEventListener("invalid", a), s.removeEventListener("change", l), u == null || u.removeEventListener("reset", i);
    };
  }, [
    n,
    a,
    l,
    i,
    r
  ]);
}
function xd(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function $d(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: xd(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function wd(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (!n.validity.valid) return n;
  }
  return null;
}
function Ed(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": o, labelElementType: i = "label" } = e;
  t = an(t);
  let a = an(), l = {};
  n ? (r = r ? `${a} ${r}` : a, l = {
    id: a,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !o && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let s = $f({
    id: t,
    "aria-label": o,
    "aria-labelledby": r
  });
  return {
    labelProps: l,
    fieldProps: s
  };
}
function Sd(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: o } = e, { labelProps: i, fieldProps: a } = Ed(e), l = Qi([
    !!t,
    !!n,
    r,
    o
  ]), s = Qi([
    !!t,
    !!n,
    r,
    o
  ]);
  return a = ft(a, {
    "aria-describedby": [
      l,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      s,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: i,
    fieldProps: a,
    descriptionProps: {
      id: l
    },
    errorMessageProps: {
      id: s
    }
  };
}
function Cd(e) {
  let { minValue: t, maxValue: n, step: r, formatOptions: o, value: i, defaultValue: a = NaN, onChange: l, locale: s, isDisabled: u, isReadOnly: c } = e;
  i === null && (i = NaN), i !== void 0 && !isNaN(i) && (r !== void 0 && !isNaN(r) ? i = Lt(i, t, n, r) : i = Oo(i, t, n)), isNaN(a) || (r !== void 0 && !isNaN(r) ? a = Lt(a, t, n, r) : a = Oo(a, t, n));
  let [f, p] = xl(i, isNaN(a) ? NaN : a, l), [d, g] = oe(() => isNaN(f) ? "" : new Jr(s, o).format(f)), h = re(() => new Al(s, o), [
    s,
    o
  ]), v = re(() => h.getNumberingSystem(d), [
    h,
    d
  ]), x = re(() => new Jr(s, {
    ...o,
    numberingSystem: v
  }), [
    s,
    o,
    v
  ]), $ = re(() => x.resolvedOptions(), [
    x
  ]), w = pe((B) => isNaN(B) || B === null ? "" : x.format(B), [
    x
  ]), S = jl({
    ...e,
    value: f
  }), E = r !== void 0 && !isNaN(r) ? r : 1;
  $.style === "percent" && (r === void 0 || isNaN(r)) && (E = 0.01);
  let [L, T] = oe(f), [_, W] = oe(s), [P, D] = oe(o);
  (!Object.is(f, L) || s !== _ || o !== P) && (g(w(f)), T(f), W(s), D(o));
  let k = re(() => h.parse(d), [
    h,
    d
  ]), z = () => {
    if (!d.length) {
      p(NaN), g(i === void 0 ? "" : w(f));
      return;
    }
    if (isNaN(k)) {
      g(w(f));
      return;
    }
    let B;
    r === void 0 || isNaN(r) ? B = Oo(k, t, n) : B = Lt(k, t, n, r), B = h.parse(w(B)), p(B), g(w(i === void 0 ? B : f));
  }, M = (B, N = 0) => {
    let ce = k;
    if (isNaN(ce)) {
      let H = isNaN(N) ? 0 : N;
      return Lt(H, t, n, E);
    } else {
      let H = Lt(ce, t, n, E);
      return B === "+" && H > ce || B === "-" && H < ce ? H : Lt(Do(B, ce, E), t, n, E);
    }
  }, q = () => {
    let B = M("+", t);
    B === f && g(w(B)), p(B), S.commitValidation();
  }, U = () => {
    let B = M("-", n);
    B === f && g(w(B)), p(B), S.commitValidation();
  }, J = () => {
    n != null && (p(Lt(n, t, n, E)), S.commitValidation());
  }, Y = () => {
    t != null && (p(t), S.commitValidation());
  }, G = re(() => !u && !c && (isNaN(k) || n === void 0 || isNaN(n) || Lt(k, t, n, E) > k || Do("+", k, E) <= n), [
    u,
    c,
    t,
    n,
    E,
    k
  ]), Z = re(() => !u && !c && (isNaN(k) || t === void 0 || isNaN(t) || Lt(k, t, n, E) < k || Do("-", k, E) >= t), [
    u,
    c,
    t,
    n,
    E,
    k
  ]);
  return {
    ...S,
    validate: (B) => h.isValidPartialNumber(B, t, n),
    increment: q,
    incrementToMax: J,
    decrement: U,
    decrementToMin: Y,
    canIncrement: G,
    canDecrement: Z,
    minValue: t,
    maxValue: n,
    numberValue: k,
    setNumberValue: p,
    setInputValue: g,
    inputValue: d,
    commit: z
  };
}
function Do(e, t, n) {
  let r = e === "+" ? t + n : t - n;
  if (t % 1 !== 0 || n % 1 !== 0) {
    const o = t.toString().split("."), i = n.toString().split("."), a = o[1] && o[1].length || 0, l = i[1] && i[1].length || 0, s = Math.pow(10, Math.max(a, l));
    t = Math.round(t * s), n = Math.round(n * s), r = e === "+" ? t + n : t - n, r /= s;
  }
  return r;
}
function Pd(e, t) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: o = !1, isReadOnly: i = !1, type: a = "text", validationBehavior: l = "aria" } = e, [s, u] = xl(e.value, e.defaultValue || "", e.onChange), { focusableProps: c } = zf(e, t), f = jl({
    ...e,
    value: s
  }), { isInvalid: p, validationErrors: d, validationDetails: g } = f.displayValidation, { labelProps: h, fieldProps: v, descriptionProps: x, errorMessageProps: $ } = Sd({
    ...e,
    isInvalid: p,
    errorMessage: e.errorMessage || d
  }), w = io(e, {
    labelable: !0
  });
  const S = {
    type: a,
    pattern: e.pattern
  };
  return yl(t, s, u), yd(e, f, t), ue(() => {
    if (t.current instanceof Wt(t.current).HTMLTextAreaElement) {
      let E = t.current;
      Object.defineProperty(E, "defaultValue", {
        get: () => E.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: h,
    inputProps: ft(w, n === "input" ? S : void 0, {
      disabled: r,
      readOnly: i,
      required: o && l === "native",
      "aria-required": o && l === "aria" || void 0,
      "aria-invalid": p || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      "aria-controls": e["aria-controls"],
      value: s,
      onChange: (E) => u(E.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      autoCorrect: e.autoCorrect,
      spellCheck: e.spellCheck,
      [parseInt(A.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: e.enterKeyHint,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...c,
      ...v
    }),
    descriptionProps: x,
    errorMessageProps: $,
    isInvalid: p,
    validationErrors: d,
    validationDetails: g
  };
}
function ma() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function Od(e, t, n) {
  let r = ct((f) => {
    let p = n.current;
    if (!p) return;
    let d = null;
    switch (f.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        d = p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteContentForward":
        d = p.selectionEnd === p.selectionStart ? p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd + 1) : p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteContentBackward":
        d = p.selectionEnd === p.selectionStart ? p.value.slice(0, p.selectionStart - 1) + p.value.slice(p.selectionStart) : p.value.slice(0, p.selectionStart) + p.value.slice(p.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        d = p.value.slice(p.selectionStart);
        break;
      default:
        f.data != null && (d = p.value.slice(0, p.selectionStart) + f.data + p.value.slice(p.selectionEnd));
        break;
    }
    (d == null || !t.validate(d)) && f.preventDefault();
  });
  ue(() => {
    if (!ma() || !n.current) return;
    let f = n.current;
    return f.addEventListener("beforeinput", r, !1), () => {
      f.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n,
    r
  ]);
  let o = ma() ? null : (f) => {
    let p = f.target.value.slice(0, f.target.selectionStart) + f.data + f.target.value.slice(f.target.selectionEnd);
    t.validate(p) || f.preventDefault();
  }, { labelProps: i, inputProps: a, descriptionProps: l, errorMessageProps: s, ...u } = Pd(e, n), c = X(null);
  return {
    inputProps: ft(a, {
      onBeforeInput: o,
      onCompositionStart() {
        let { value: f, selectionStart: p, selectionEnd: d } = n.current;
        c.current = {
          value: f,
          selectionStart: p,
          selectionEnd: d
        };
      },
      onCompositionEnd() {
        if (n.current && !t.validate(n.current.value)) {
          let { value: f, selectionStart: p, selectionEnd: d } = c.current;
          n.current.value = f, n.current.setSelectionRange(p, d), t.setInputValue(f);
        }
      }
    }),
    labelProps: i,
    descriptionProps: l,
    errorMessageProps: s,
    ...u
  };
}
var kl = {};
kl = {
  Empty: "فارغ"
};
var Vl = {};
Vl = {
  Empty: "Изпразни"
};
var Bl = {};
Bl = {
  Empty: "Prázdné"
};
var Hl = {};
Hl = {
  Empty: "Tom"
};
var Wl = {};
Wl = {
  Empty: "Leer"
};
var zl = {};
zl = {
  Empty: "Άδειο"
};
var Ul = {};
Ul = {
  Empty: "Empty"
};
var ql = {};
ql = {
  Empty: "Vacío"
};
var Yl = {};
Yl = {
  Empty: "Tühjenda"
};
var Gl = {};
Gl = {
  Empty: "Tyhjä"
};
var Kl = {};
Kl = {
  Empty: "Vide"
};
var Xl = {};
Xl = {
  Empty: "ריק"
};
var Jl = {};
Jl = {
  Empty: "Prazno"
};
var Zl = {};
Zl = {
  Empty: "Üres"
};
var Ql = {};
Ql = {
  Empty: "Vuoto"
};
var es = {};
es = {
  Empty: "空"
};
var ts = {};
ts = {
  Empty: "비어 있음"
};
var ns = {};
ns = {
  Empty: "Tuščias"
};
var rs = {};
rs = {
  Empty: "Tukšs"
};
var os = {};
os = {
  Empty: "Tom"
};
var is = {};
is = {
  Empty: "Leeg"
};
var as = {};
as = {
  Empty: "Pusty"
};
var ls = {};
ls = {
  Empty: "Vazio"
};
var ss = {};
ss = {
  Empty: "Vazio"
};
var us = {};
us = {
  Empty: "Gol"
};
var cs = {};
cs = {
  Empty: "Не заполнено"
};
var fs = {};
fs = {
  Empty: "Prázdne"
};
var ds = {};
ds = {
  Empty: "Prazen"
};
var ps = {};
ps = {
  Empty: "Prazno"
};
var ms = {};
ms = {
  Empty: "Tomt"
};
var vs = {};
vs = {
  Empty: "Boş"
};
var hs = {};
hs = {
  Empty: "Пусто"
};
var bs = {};
bs = {
  Empty: "空"
};
var gs = {};
gs = {
  Empty: "空白"
};
var ys = {};
ys = {
  "ar-AE": kl,
  "bg-BG": Vl,
  "cs-CZ": Bl,
  "da-DK": Hl,
  "de-DE": Wl,
  "el-GR": zl,
  "en-US": Ul,
  "es-ES": ql,
  "et-EE": Yl,
  "fi-FI": Gl,
  "fr-FR": Kl,
  "he-IL": Xl,
  "hr-HR": Jl,
  "hu-HU": Zl,
  "it-IT": Ql,
  "ja-JP": es,
  "ko-KR": ts,
  "lt-LT": ns,
  "lv-LV": rs,
  "nb-NO": os,
  "nl-NL": is,
  "pl-PL": as,
  "pt-BR": ls,
  "pt-PT": ss,
  "ro-RO": us,
  "ru-RU": cs,
  "sk-SK": fs,
  "sl-SI": ds,
  "sr-SP": ps,
  "sv-SE": ms,
  "tr-TR": vs,
  "uk-UA": hs,
  "zh-CN": bs,
  "zh-TW": gs
};
function Td(e) {
  return e && e.__esModule ? e.default : e;
}
function Rd(e) {
  const t = X(void 0);
  let { value: n, textValue: r, minValue: o, maxValue: i, isDisabled: a, isReadOnly: l, isRequired: s, onIncrement: u, onIncrementPage: c, onDecrement: f, onDecrementPage: p, onDecrementToMin: d, onIncrementToMax: g } = e;
  const h = Dl(Td(ys), "@react-aria/spinbutton"), v = () => clearTimeout(t.current);
  ue(() => () => v(), []);
  let x = (D) => {
    if (!(D.ctrlKey || D.metaKey || D.shiftKey || D.altKey || l))
      switch (D.key) {
        case "PageUp":
          if (c) {
            D.preventDefault(), c == null || c();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          u && (D.preventDefault(), u == null || u());
          break;
        case "PageDown":
          if (p) {
            D.preventDefault(), p == null || p();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          f && (D.preventDefault(), f == null || f());
          break;
        case "Home":
          d && (D.preventDefault(), d == null || d());
          break;
        case "End":
          g && (D.preventDefault(), g == null || g());
          break;
      }
  }, $ = X(!1), w = () => {
    $.current = !0;
  }, S = () => {
    $.current = !1;
  }, E = r === "" ? h.format("Empty") : (r || `${n}`).replace("-", "−");
  ue(() => {
    $.current && (md("assertive"), pd(E, "assertive"));
  }, [
    E
  ]);
  const L = ct((D) => {
    v(), u == null || u(), t.current = window.setTimeout(() => {
      (i === void 0 || isNaN(i) || n === void 0 || isNaN(n) || n < i) && L(60);
    }, D);
  }), T = ct((D) => {
    v(), f == null || f(), t.current = window.setTimeout(() => {
      (o === void 0 || isNaN(o) || n === void 0 || isNaN(n) || n > o) && T(60);
    }, D);
  });
  let _ = (D) => {
    D.preventDefault();
  }, { addGlobalListener: W, removeAllGlobalListeners: P } = mi();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": E,
      "aria-valuemin": o,
      "aria-valuemax": i,
      "aria-disabled": a || void 0,
      "aria-readonly": l || void 0,
      "aria-required": s || void 0,
      onKeyDown: x,
      onFocus: w,
      onBlur: S
    },
    incrementButtonProps: {
      onPressStart: () => {
        L(400), W(window, "contextmenu", _);
      },
      onPressEnd: () => {
        v(), P();
      },
      onFocus: w,
      onBlur: S
    },
    decrementButtonProps: {
      onPressStart: () => {
        T(400), W(window, "contextmenu", _);
      },
      onPressEnd: () => {
        v(), P();
      },
      onFocus: w,
      onBlur: S
    }
  };
}
var xs = {};
xs = {
  decrease: (e) => `خفض ${e.fieldLabel}`,
  increase: (e) => `زيادة ${e.fieldLabel}`,
  numberField: "حقل رقمي"
};
var $s = {};
$s = {
  decrease: (e) => `Намаляване ${e.fieldLabel}`,
  increase: (e) => `Усилване ${e.fieldLabel}`,
  numberField: "Номер на полето"
};
var ws = {};
ws = {
  decrease: (e) => `Snížit ${e.fieldLabel}`,
  increase: (e) => `Zvýšit ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Es = {};
Es = {
  decrease: (e) => `Reducer ${e.fieldLabel}`,
  increase: (e) => `Øg ${e.fieldLabel}`,
  numberField: "Talfelt"
};
var Ss = {};
Ss = {
  decrease: (e) => `${e.fieldLabel} verringern`,
  increase: (e) => `${e.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var Cs = {};
Cs = {
  decrease: (e) => `Μείωση ${e.fieldLabel}`,
  increase: (e) => `Αύξηση ${e.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var Ps = {};
Ps = {
  decrease: (e) => `Decrease ${e.fieldLabel}`,
  increase: (e) => `Increase ${e.fieldLabel}`,
  numberField: "Number field"
};
var Os = {};
Os = {
  decrease: (e) => `Reducir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Ts = {};
Ts = {
  decrease: (e) => `Vähenda ${e.fieldLabel}`,
  increase: (e) => `Suurenda ${e.fieldLabel}`,
  numberField: "Numbri väli"
};
var Rs = {};
Rs = {
  decrease: (e) => `Vähennä ${e.fieldLabel}`,
  increase: (e) => `Lisää ${e.fieldLabel}`,
  numberField: "Numerokenttä"
};
var Fs = {};
Fs = {
  decrease: (e) => `Diminuer ${e.fieldLabel}`,
  increase: (e) => `Augmenter ${e.fieldLabel}`,
  numberField: "Champ de nombre"
};
var Ls = {};
Ls = {
  decrease: (e) => `הקטן ${e.fieldLabel}`,
  increase: (e) => `הגדל ${e.fieldLabel}`,
  numberField: "שדה מספר"
};
var Ds = {};
Ds = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Ms = {};
Ms = {
  decrease: (e) => `${e.fieldLabel} csökkentése`,
  increase: (e) => `${e.fieldLabel} növelése`,
  numberField: "Számmező"
};
var As = {};
As = {
  decrease: (e) => `Riduci ${e.fieldLabel}`,
  increase: (e) => `Aumenta ${e.fieldLabel}`,
  numberField: "Campo numero"
};
var _s = {};
_s = {
  decrease: (e) => `${e.fieldLabel}を縮小`,
  increase: (e) => `${e.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var Ns = {};
Ns = {
  decrease: (e) => `${e.fieldLabel} 감소`,
  increase: (e) => `${e.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Is = {};
Is = {
  decrease: (e) => `Sumažinti ${e.fieldLabel}`,
  increase: (e) => `Padidinti ${e.fieldLabel}`,
  numberField: "Numerio laukas"
};
var js = {};
js = {
  decrease: (e) => `Samazināšana ${e.fieldLabel}`,
  increase: (e) => `Palielināšana ${e.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var ks = {};
ks = {
  decrease: (e) => `Reduser ${e.fieldLabel}`,
  increase: (e) => `Øk ${e.fieldLabel}`,
  numberField: "Tallfelt"
};
var Vs = {};
Vs = {
  decrease: (e) => `${e.fieldLabel} verlagen`,
  increase: (e) => `${e.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Bs = {};
Bs = {
  decrease: (e) => `Zmniejsz ${e.fieldLabel}`,
  increase: (e) => `Zwiększ ${e.fieldLabel}`,
  numberField: "Pole numeru"
};
var Hs = {};
Hs = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Ws = {};
Ws = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo numérico"
};
var zs = {};
zs = {
  decrease: (e) => `Scădere ${e.fieldLabel}`,
  increase: (e) => `Creștere ${e.fieldLabel}`,
  numberField: "Câmp numeric"
};
var Us = {};
Us = {
  decrease: (e) => `Уменьшение ${e.fieldLabel}`,
  increase: (e) => `Увеличение ${e.fieldLabel}`,
  numberField: "Числовое поле"
};
var qs = {};
qs = {
  decrease: (e) => `Znížiť ${e.fieldLabel}`,
  increase: (e) => `Zvýšiť ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Ys = {};
Ys = {
  decrease: (e) => `Upadati ${e.fieldLabel}`,
  increase: (e) => `Povečajte ${e.fieldLabel}`,
  numberField: "Številčno polje"
};
var Gs = {};
Gs = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Ks = {};
Ks = {
  decrease: (e) => `Minska ${e.fieldLabel}`,
  increase: (e) => `Öka ${e.fieldLabel}`,
  numberField: "Nummerfält"
};
var Xs = {};
Xs = {
  decrease: (e) => `${e.fieldLabel} azalt`,
  increase: (e) => `${e.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var Js = {};
Js = {
  decrease: (e) => `Зменшити ${e.fieldLabel}`,
  increase: (e) => `Збільшити ${e.fieldLabel}`,
  numberField: "Поле номера"
};
var Zs = {};
Zs = {
  decrease: (e) => `降低 ${e.fieldLabel}`,
  increase: (e) => `提高 ${e.fieldLabel}`,
  numberField: "数字字段"
};
var Qs = {};
Qs = {
  decrease: (e) => `縮小 ${e.fieldLabel}`,
  increase: (e) => `放大 ${e.fieldLabel}`,
  numberField: "數字欄位"
};
var eu = {};
eu = {
  "ar-AE": xs,
  "bg-BG": $s,
  "cs-CZ": ws,
  "da-DK": Es,
  "de-DE": Ss,
  "el-GR": Cs,
  "en-US": Ps,
  "es-ES": Os,
  "et-EE": Ts,
  "fi-FI": Rs,
  "fr-FR": Fs,
  "he-IL": Ls,
  "hr-HR": Ds,
  "hu-HU": Ms,
  "it-IT": As,
  "ja-JP": _s,
  "ko-KR": Ns,
  "lt-LT": Is,
  "lv-LV": js,
  "nb-NO": ks,
  "nl-NL": Vs,
  "pl-PL": Bs,
  "pt-BR": Hs,
  "pt-PT": Ws,
  "ro-RO": zs,
  "ru-RU": Us,
  "sk-SK": qs,
  "sl-SI": Ys,
  "sr-SP": Gs,
  "sv-SE": Ks,
  "tr-TR": Xs,
  "uk-UA": Js,
  "zh-CN": Zs,
  "zh-TW": Qs
};
function Fd(e) {
  return e && e.__esModule ? e.default : e;
}
function Ld(e, t, n) {
  let { id: r, decrementAriaLabel: o, incrementAriaLabel: i, isDisabled: a, isReadOnly: l, isRequired: s, minValue: u, maxValue: c, autoFocus: f, label: p, formatOptions: d, onBlur: g = () => {
  }, onFocus: h, onFocusChange: v, onKeyDown: x, onKeyUp: $, description: w, errorMessage: S, isWheelDisabled: E, ...L } = e, { increment: T, incrementToMax: _, decrement: W, decrementToMin: P, numberValue: D, inputValue: k, commit: z, commitValidation: M } = t;
  const q = Dl(Fd(eu), "@react-aria/numberfield");
  let U = an(r), { focusProps: J } = vi({
    onBlur() {
      z();
    }
  }), Y = da(d), G = re(() => Y.resolvedOptions(), [
    Y
  ]), Z = da({
    ...d,
    currencySign: void 0
  }), Q = re(() => isNaN(D) ? "" : Z.format(D), [
    Z,
    D
  ]), { spinButtonProps: B, incrementButtonProps: N, decrementButtonProps: ce } = Rd({
    isDisabled: a,
    isReadOnly: l,
    isRequired: s,
    maxValue: c,
    minValue: u,
    onIncrement: T,
    onIncrementToMax: _,
    onDecrement: W,
    onDecrementToMin: P,
    value: D,
    textValue: Q
  }), [H, ge] = oe(!1), { focusWithinProps: fe } = Fl({
    isDisabled: a,
    onFocusWithinChange: ge
  }), ee = pe((De) => {
    Math.abs(De.deltaY) <= Math.abs(De.deltaX) || (De.deltaY > 0 ? T() : De.deltaY < 0 && W());
  }, [
    W,
    T
  ]);
  qf({
    onScroll: ee,
    isDisabled: E || a || l || !H
  }, n);
  var Ae;
  let He = ((Ae = G.maximumFractionDigits) !== null && Ae !== void 0 ? Ae : 0) > 0, We = t.minValue === void 0 || isNaN(t.minValue) || t.minValue < 0, _e = "numeric";
  bl() ? We ? _e = "text" : He && (_e = "decimal") : gl() && (We ? _e = "numeric" : He && (_e = "decimal"));
  let R = (De) => {
    t.validate(De) && t.setInputValue(De);
  }, ie = io(e), he = pe((De) => {
    De.key === "Enter" ? (z(), M()) : De.continuePropagation();
  }, [
    z,
    M
  ]), { isInvalid: Fe, validationErrors: it, validationDetails: vt } = t.displayValidation, { labelProps: qe, inputProps: ht, descriptionProps: bt, errorMessageProps: Nt } = Od({
    ...L,
    ...ie,
    name: void 0,
    label: p,
    autoFocus: f,
    isDisabled: a,
    isReadOnly: l,
    isRequired: s,
    validate: void 0,
    [Xo]: t,
    value: k,
    defaultValue: void 0,
    autoComplete: "off",
    "aria-label": e["aria-label"] || void 0,
    "aria-labelledby": e["aria-labelledby"] || void 0,
    id: U,
    type: "text",
    inputMode: _e,
    onChange: R,
    onBlur: g,
    onFocus: h,
    onFocusChange: v,
    onKeyDown: re(() => dl(he, x), [
      he,
      x
    ]),
    onKeyUp: $,
    description: w,
    errorMessage: S
  }, t, n);
  yl(n, t.numberValue, t.setNumberValue);
  let gt = ft(B, J, ht, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": yf() ? null : q.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  e.validationBehavior === "native" && (gt["aria-required"] = void 0);
  let yt = (De) => {
    var Jt;
    document.activeElement !== n.current && (De.pointerType === "mouse" ? (Jt = n.current) === null || Jt === void 0 || Jt.focus() : De.target.focus());
  }, at = e["aria-label"] || (typeof e.label == "string" ? e.label : ""), Le;
  at || (Le = e.label != null ? qe.id : e["aria-labelledby"]);
  let lt = an(), It = an(), ze = ft(N, {
    "aria-label": i || q.format("increase", {
      fieldLabel: at
    }).trim(),
    id: Le && !i ? lt : null,
    "aria-labelledby": Le && !i ? `${lt} ${Le}` : null,
    "aria-controls": U,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canIncrement,
    onPressStart: yt
  }), hn = ft(ce, {
    "aria-label": o || q.format("decrease", {
      fieldLabel: at
    }).trim(),
    id: Le && !o ? It : null,
    "aria-labelledby": Le && !o ? `${It} ${Le}` : null,
    "aria-controls": U,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canDecrement,
    onPressStart: yt
  });
  return {
    groupProps: {
      ...fe,
      role: "group",
      "aria-disabled": a,
      "aria-invalid": Fe ? "true" : void 0
    },
    labelProps: qe,
    inputProps: gt,
    incrementButtonProps: ze,
    decrementButtonProps: hn,
    errorMessageProps: Nt,
    descriptionProps: bt,
    isInvalid: Fe,
    validationErrors: it,
    validationDetails: vt
  };
}
const tu = /* @__PURE__ */ xe({});
let Dd = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...o } = e;
  return o;
};
const Md = /* @__PURE__ */ wl(function(t, n) {
  [t, n] = hr(t, n, tu);
  let { hoverProps: r, isHovered: o } = so(t), { isFocused: i, isFocusVisible: a, focusProps: l } = co({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), s = !!t["aria-invalid"] && t["aria-invalid"] !== "false", u = ao({
    ...t,
    values: {
      isHovered: o,
      isFocused: i,
      isFocusVisible: a,
      isDisabled: t.disabled || !1,
      isInvalid: s
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ A.createElement("input", {
    ...ft(Dd(t), l, r),
    ...u,
    ref: n,
    "data-focused": i || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": o || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": s || void 0
  });
}), nu = /* @__PURE__ */ xe({}), Ad = /* @__PURE__ */ wl(function(t, n) {
  [t, n] = hr(t, n, nu);
  let { elementType: r = "label", ...o } = t;
  return /* @__PURE__ */ A.createElement(r, {
    className: "react-aria-Label",
    ...o,
    ref: n
  });
}), _d = /* @__PURE__ */ xe({}), ru = /* @__PURE__ */ xe({}), Zo = /* @__PURE__ */ qt(function(t, n) {
  [t, n] = hr(t, n, ru);
  let { elementType: r = "span", ...o } = t;
  return /* @__PURE__ */ A.createElement(r, {
    className: "react-aria-Text",
    ...o,
    ref: n
  });
}), bi = /* @__PURE__ */ xe(null), Nd = /* @__PURE__ */ qt(function(t, n) {
  let r = be(bi);
  return r != null && r.isInvalid ? /* @__PURE__ */ A.createElement(Id, {
    ...t,
    ref: n
  }) : null;
}), Id = /* @__PURE__ */ qt((e, t) => {
  let n = be(bi), r = io(e), o = ao({
    ...e,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return o.children == null ? null : /* @__PURE__ */ A.createElement(Zo, {
    slot: "errorMessage",
    ...r,
    ...o,
    ref: t
  });
}), jd = /* @__PURE__ */ xe(null), ou = /* @__PURE__ */ xe({}), kd = /* @__PURE__ */ qt(function(t, n) {
  [t, n] = hr(t, n, ou);
  let { isDisabled: r, isInvalid: o, onHoverStart: i, onHoverChange: a, onHoverEnd: l, ...s } = t, { hoverProps: u, isHovered: c } = so({
    onHoverStart: i,
    onHoverChange: a,
    onHoverEnd: l,
    isDisabled: r
  }), { isFocused: f, isFocusVisible: p, focusProps: d } = co({
    within: !0
  });
  r ?? (r = !!t["aria-disabled"] && t["aria-disabled"] !== "false"), o ?? (o = !!t["aria-invalid"] && t["aria-invalid"] !== "false");
  let g = ao({
    ...t,
    values: {
      isHovered: c,
      isFocusWithin: f,
      isFocusVisible: p,
      isDisabled: r,
      isInvalid: o
    },
    defaultClassName: "react-aria-Group"
  });
  var h, v;
  return /* @__PURE__ */ A.createElement("div", {
    ...ft(s, d, u),
    ...g,
    ref: n,
    role: (h = t.role) !== null && h !== void 0 ? h : "group",
    slot: (v = t.slot) !== null && v !== void 0 ? v : void 0,
    "data-focus-within": f || void 0,
    "data-hovered": c || void 0,
    "data-focus-visible": p || void 0,
    "data-disabled": r || void 0,
    "data-invalid": o || void 0
  }, g.children);
}), Vd = /* @__PURE__ */ xe(null), Bd = /* @__PURE__ */ xe(null), Hd = /* @__PURE__ */ qt(function(t, n) {
  [t, n] = hr(t, n, Vd);
  let { validationBehavior: r } = $l(jd) || {};
  var o, i;
  let a = (i = (o = t.validationBehavior) !== null && o !== void 0 ? o : r) !== null && i !== void 0 ? i : "native", { locale: l } = hi(), s = Cd({
    ...t,
    locale: l,
    validationBehavior: a
  }), u = X(null), [c, f] = Tf(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: p, groupProps: d, inputProps: g, incrementButtonProps: h, decrementButtonProps: v, descriptionProps: x, errorMessageProps: $, ...w } = Ld({
    ...Rf(t),
    label: f,
    validationBehavior: a
  }, s, u), S = ao({
    ...t,
    values: {
      state: s,
      isDisabled: t.isDisabled || !1,
      isInvalid: w.isInvalid || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), E = io(t);
  return delete E.id, /* @__PURE__ */ A.createElement(Of, {
    values: [
      [
        Bd,
        s
      ],
      [
        ou,
        d
      ],
      [
        tu,
        {
          ...g,
          ref: u
        }
      ],
      [
        nu,
        {
          ...p,
          ref: c
        }
      ],
      [
        _d,
        {
          slots: {
            increment: h,
            decrement: v
          }
        }
      ],
      [
        ru,
        {
          slots: {
            description: x,
            errorMessage: $
          }
        }
      ],
      [
        bi,
        w
      ]
    ]
  }, /* @__PURE__ */ A.createElement("div", {
    ...E,
    ...S,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-required": t.isRequired || void 0,
    "data-invalid": w.isInvalid || void 0
  }), t.name && /* @__PURE__ */ A.createElement("input", {
    type: "hidden",
    name: t.name,
    value: isNaN(s.numberValue) ? "" : s.numberValue
  }));
}), Gb = ({
  id: e,
  description: t,
  label: n,
  formatOptions: r,
  minValue: o = 0,
  ...i
}) => {
  const { isRequired: a } = i, [l, s] = oe(Math.max(i.value ?? i.defaultValue ?? 0, o)), [u, c] = oe(!1);
  ue(() => {
    i.value != null && i.value !== l && s(Math.max(i.value, o));
  }, [i.value, l, o]);
  const f = pe(
    (p) => {
      const d = p < o;
      c(d), s(Math.max(p, o));
    },
    [o]
  );
  return /* @__PURE__ */ C.jsxs(
    Hd,
    {
      ...i,
      value: l,
      onChange: f,
      validationBehavior: "native",
      formatOptions: {
        ...r,
        style: "currency",
        currencyDisplay: "symbol"
      },
      children: [
        n != null && /* @__PURE__ */ C.jsxs(Ad, { htmlFor: e, children: [
          n,
          a && /* @__PURE__ */ C.jsx(ro, {})
        ] }),
        t != null && /* @__PURE__ */ C.jsx(Zo, { className: "form-text text-muted small mb-2 d-block", slot: "description", children: t }),
        /* @__PURE__ */ C.jsxs(kd, { children: [
          /* @__PURE__ */ C.jsx(Md, { className: "input-sm form-control", id: e }),
          /* @__PURE__ */ C.jsx(Nd, { className: "text-muted mt-1 small" }),
          u && /* @__PURE__ */ C.jsx(
            Zo,
            {
              className: "form-text text-muted small mb-2 d-block",
              slot: "description",
              role: "status",
              "aria-live": "polite",
              children: "Amount was updated to meet the minimum amount required"
            }
          )
        ] })
      ]
    }
  );
};
var Br = { exports: {} }, me = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var va;
function Wd() {
  if (va) return me;
  va = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function h(v) {
    if (typeof v == "object" && v !== null) {
      var x = v.$$typeof;
      switch (x) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case u:
            case c:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case l:
                case a:
                case s:
                case p:
                case f:
                case i:
                  return v;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return me.ContextConsumer = a, me.ContextProvider = i, me.Element = e, me.ForwardRef = s, me.Fragment = n, me.Lazy = p, me.Memo = f, me.Portal = t, me.Profiler = o, me.StrictMode = r, me.Suspense = u, me.SuspenseList = c, me.isAsyncMode = function() {
    return !1;
  }, me.isConcurrentMode = function() {
    return !1;
  }, me.isContextConsumer = function(v) {
    return h(v) === a;
  }, me.isContextProvider = function(v) {
    return h(v) === i;
  }, me.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, me.isForwardRef = function(v) {
    return h(v) === s;
  }, me.isFragment = function(v) {
    return h(v) === n;
  }, me.isLazy = function(v) {
    return h(v) === p;
  }, me.isMemo = function(v) {
    return h(v) === f;
  }, me.isPortal = function(v) {
    return h(v) === t;
  }, me.isProfiler = function(v) {
    return h(v) === o;
  }, me.isStrictMode = function(v) {
    return h(v) === r;
  }, me.isSuspense = function(v) {
    return h(v) === u;
  }, me.isSuspenseList = function(v) {
    return h(v) === c;
  }, me.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === u || v === c || v === d || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === f || v.$$typeof === i || v.$$typeof === a || v.$$typeof === s || v.$$typeof === g || v.getModuleId !== void 0);
  }, me.typeOf = h, me;
}
var ve = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ha;
function zd() {
  return ha || (ha = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), g = !1, h = !1, v = !1, x = !1, $ = !1, w;
    w = Symbol.for("react.module.reference");
    function S(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === n || R === o || $ || R === r || R === u || R === c || x || R === d || g || h || v || typeof R == "object" && R !== null && (R.$$typeof === p || R.$$typeof === f || R.$$typeof === i || R.$$typeof === a || R.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === w || R.getModuleId !== void 0));
    }
    function E(R) {
      if (typeof R == "object" && R !== null) {
        var ie = R.$$typeof;
        switch (ie) {
          case e:
            var he = R.type;
            switch (he) {
              case n:
              case o:
              case r:
              case u:
              case c:
                return he;
              default:
                var Fe = he && he.$$typeof;
                switch (Fe) {
                  case l:
                  case a:
                  case s:
                  case p:
                  case f:
                  case i:
                    return Fe;
                  default:
                    return ie;
                }
            }
          case t:
            return ie;
        }
      }
    }
    var L = a, T = i, _ = e, W = s, P = n, D = p, k = f, z = t, M = o, q = r, U = u, J = c, Y = !1, G = !1;
    function Z(R) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(R) {
      return G || (G = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(R) {
      return E(R) === a;
    }
    function N(R) {
      return E(R) === i;
    }
    function ce(R) {
      return typeof R == "object" && R !== null && R.$$typeof === e;
    }
    function H(R) {
      return E(R) === s;
    }
    function ge(R) {
      return E(R) === n;
    }
    function fe(R) {
      return E(R) === p;
    }
    function ee(R) {
      return E(R) === f;
    }
    function Oe(R) {
      return E(R) === t;
    }
    function Ae(R) {
      return E(R) === o;
    }
    function He(R) {
      return E(R) === r;
    }
    function We(R) {
      return E(R) === u;
    }
    function _e(R) {
      return E(R) === c;
    }
    ve.ContextConsumer = L, ve.ContextProvider = T, ve.Element = _, ve.ForwardRef = W, ve.Fragment = P, ve.Lazy = D, ve.Memo = k, ve.Portal = z, ve.Profiler = M, ve.StrictMode = q, ve.Suspense = U, ve.SuspenseList = J, ve.isAsyncMode = Z, ve.isConcurrentMode = Q, ve.isContextConsumer = B, ve.isContextProvider = N, ve.isElement = ce, ve.isForwardRef = H, ve.isFragment = ge, ve.isLazy = fe, ve.isMemo = ee, ve.isPortal = Oe, ve.isProfiler = Ae, ve.isStrictMode = He, ve.isSuspense = We, ve.isSuspenseList = _e, ve.isValidElementType = S, ve.typeOf = E;
  }()), ve;
}
var ba;
function Ud() {
  return ba || (ba = 1, process.env.NODE_ENV === "production" ? Br.exports = Wd() : Br.exports = zd()), Br.exports;
}
var qd = Ud();
const Yd = /* @__PURE__ */ no(qd), Qo = ({
  className: e,
  family: t = Xn.solid,
  fixedWidth: n = !1,
  flip: r,
  icon: o,
  inverse: i = !1,
  pulse: a = !1,
  rotate: l,
  size: s,
  spin: u = !1,
  stack: c,
  title: f,
  variant: p,
  ...d
}) => {
  ue(() => {
    console.warn(
      "This component is deprecated. Please use the individual icon imports from @fastnorth/react-cerberus/Icons."
    );
  }, []);
  const g = ye(e, `fa-${o}`, {
    fab: t === Xn.brand,
    far: t === Xn.regular,
    fas: t === Xn.solid,
    "fa-fw": n,
    "fa-spin": u,
    "fa-pulse": a,
    "fa-inverse": i,
    [`fa-${s}`]: s,
    [`fa-rotate-${l}`]: l,
    [`fa-flip-${r}`]: r,
    [`fa-stack-${c}`]: c,
    [`text-${p}`]: p
  });
  return /* @__PURE__ */ C.jsx(
    "span",
    {
      ...d,
      className: g,
      title: f,
      "aria-hidden": f ? void 0 : !0
    }
  );
}, Gd = "_container_1g94w_1", Kd = "_stack_1g94w_14", Xd = "_circle_1g94w_24", Jd = "_svg_1g94w_40", Zd = "_spin_1g94w_47", Yn = {
  container: Gd,
  stack: Kd,
  circle: Xd,
  svg: Jd,
  spin: Zd
}, Qd = ({ size: e = er.small, variant: t, stack: n = !1, spin: r = !0, title: o, ...i }, a) => {
  ue(() => {
    if (!Object.values(er).includes(e))
      throw new Error(
        `You must provide a valid size from the SIZES enum: ${Object.keys(er).join(", ")}`
      );
  }, [e]);
  const l = ye(i.className, Yn.container, n && Yn.stack, {
    [`text-${t}`]: !n && t !== "secondary",
    "text-gray-900": t === "secondary",
    [Yn.spin]: r
  }), s = ye(Yn.circle, {
    [`bg-${t}`]: n && t !== "secondary",
    "bg-gray-100": n && t === "secondary"
  }), u = { "--size": `var(--icon-size-${e})` };
  return /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: l,
      style: u,
      title: o,
      "aria-hidden": o ? void 0 : !0,
      children: [
        n && /* @__PURE__ */ C.jsx("span", { className: s, "aria-hidden": "true", "data-circle": !0 }),
        /* @__PURE__ */ C.jsx(
          "svg",
          {
            viewBox: "0 0 512 512",
            xmlns: "http://www.w3.org/2000/svg",
            ...i,
            className: Yn.svg,
            ref: a,
            children: /* @__PURE__ */ C.jsx(
              "path",
              {
                fill: "currentColor",
                d: "m304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-368 48c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zm-294.156-294.156c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
              }
            )
          }
        )
      ]
    }
  );
}, ep = qt(Qd), tp = Tc(ep), lr = A.forwardRef(
  ({
    tag: e = "button",
    block: t = !1,
    btn: n = !0,
    busy: r = !1,
    children: o = null,
    className: i = null,
    disabled: a = !1,
    iconLeft: l = null,
    iconRight: s = null,
    outline: u = !1,
    size: c = null,
    text: f = null,
    type: p = e === "button" ? "button" : null,
    variant: d = oo.primary,
    href: g,
    ...h
  }, v) => {
    const x = ye(i, {
      btn: n,
      [`btn-outline-${d}`]: d && u,
      [`btn-${d}`]: n && d && !u,
      [`btn-${c}`]: c,
      "btn-block": t,
      disabled: a
    });
    return /* @__PURE__ */ C.jsx(C.Fragment, { children: A.createElement(
      e,
      {
        ...h,
        disabled: e === "button" && (a || r),
        href: e === "a" ? g : void 0,
        ref: v,
        type: p,
        className: x
      },
      r && /* @__PURE__ */ C.jsx(tp, { spin: !0, className: "mr-2" }),
      typeof l == "string" ? /* @__PURE__ */ C.jsx(Qo, { icon: l, className: "mr-2", "data-testid": "button-icon-left" }) : l,
      f,
      typeof s == "string" ? /* @__PURE__ */ C.jsx(Qo, { icon: s, className: "ml-2", "data-testid": "button-icon-right" }) : s,
      o
    ) });
  }
);
function np(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const rp = A.forwardRef((e, t) => {
  const {
    id: n,
    ariaDescribedBy: r,
    onChange: o = () => {
    },
    className: i,
    children: a,
    ...l
  } = e, [s, u] = A.useState([]), c = (g) => {
    const h = Array.from(g.target.files);
    u(h), o(h);
  }, f = () => {
    (p == null ? void 0 : p.current) != null && p.current.click();
  }, p = A.useRef(null);
  let d;
  return a == null ? d = /* @__PURE__ */ C.jsx(ei, { onActivateFileInput: f }) : (Yd.isFragment(a) ? d = a.props.children : d = a, d.type === ei && (d = A.cloneElement(d, {
    onActivateFileInput: f
  }))), /* @__PURE__ */ C.jsxs(ut, { children: [
    l.multiple || s.length === 0 ? /* @__PURE__ */ C.jsx(op, { className: i, onActivateFileInput: f, children: d }) : /* @__PURE__ */ C.jsx("div", { className: "mt-3", children: s.length === 1 && /* @__PURE__ */ C.jsxs(ut, { children: [
      /* @__PURE__ */ C.jsxs("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ C.jsx("strong", { className: "mr-2", children: "File:" }),
        /* @__PURE__ */ C.jsx(
          "span",
          {
            style: {
              wordBreak: "break-all"
            },
            children: s[0].name
          }
        )
      ] }),
      /* @__PURE__ */ C.jsx(
        lr,
        {
          variant: "link",
          className: "mt-1 ml-3 pl-4 text-nowrap",
          onClick: () => {
            o([]), f();
          },
          children: "Choose a different file"
        }
      )
    ] }) }),
    /* @__PURE__ */ C.jsx(
      "input",
      {
        ...l,
        className: "d-none",
        id: n,
        ref: np([p, t]),
        "aria-describedby": r,
        type: "file",
        onChange: c,
        "data-testid": "file"
      }
    )
  ] });
}), Kb = Object.assign(rp, { Chooser: ei });
function op({ className: e, onActivateFileInput: t, children: n }) {
  return /* @__PURE__ */ C.jsxs(
    "div",
    {
      className: ye(
        e,
        "form__file-upload",
        "position-relative",
        "text-center",
        "mt-3"
      ),
      children: [
        n,
        /* @__PURE__ */ C.jsx(
          lr,
          {
            className: "form__file-upload-input",
            onClick: () => {
              t();
            }
          }
        )
      ]
    }
  );
}
function ei({
  title: e = "Drop file here",
  conjunction: t = "or",
  callToActionText: n = "Choose from files",
  onActivateFileInput: r
}) {
  return /* @__PURE__ */ C.jsxs(ut, { children: [
    /* @__PURE__ */ C.jsx("span", { className: "h5 d-block mb-2", children: e }),
    /* @__PURE__ */ C.jsx("span", { className: "d-block mb-3", children: t }),
    /* @__PURE__ */ C.jsx(
      lr,
      {
        variant: oo.primary,
        onClick: () => {
          typeof r == "function" && r();
        },
        children: n
      }
    )
  ] });
}
const Xb = ({ children: e, className: t, row: n = !1, ...r }) => {
  const o = ye(t, "form-group", {
    row: n
  });
  return /* @__PURE__ */ C.jsx("div", { ...r, className: o, children: e });
}, Jb = A.forwardRef(
  ({ className: e, id: t, size: n, ...r }, o) => {
    const i = ye(e, "form-control", {
      [`form-control-${n}`]: n
    });
    return /* @__PURE__ */ C.jsx(Gt, { ...r, className: i, id: t, ref: o, tag: "textarea" });
  }
);
var ip = Object.defineProperty, ap = (e, t, n) => t in e ? ip(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Mo = (e, t, n) => (ap(e, typeof t != "symbol" ? t + "" : t, n), n);
let lp = class {
  constructor() {
    Mo(this, "current", this.detect()), Mo(this, "handoffState", "pending"), Mo(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, ln = new lp();
function br(e) {
  return ln.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function iu(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Et() {
  let e = [], t = { addEventListener(n, r, o, i) {
    return n.addEventListener(r, o, i), t.add(() => n.removeEventListener(r, o, i));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return iu(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, o) {
    let i = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: o }), this.add(() => {
      Object.assign(n.style, { [r]: i });
    });
  }, group(n) {
    let r = Et();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.includes(n) || e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0) for (let o of e.splice(r, 1)) o();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
function gr() {
  let [e] = oe(Et);
  return ue(() => () => e.dispose(), [e]), e;
}
let Se = (e, t) => {
  ln.isServer ? ue(e, t) : fi(e, t);
};
function vn(e) {
  let t = X(e);
  return Se(() => {
    t.current = e;
  }, [e]), t;
}
let te = function(e) {
  let t = vn(e);
  return A.useCallback((...n) => t.current(...n), [t]);
};
function sp(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function up(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function cp({ disabled: e = !1 } = {}) {
  let t = X(null), [n, r] = oe(!1), o = gr(), i = te(() => {
    t.current = null, r(!1), o.dispose();
  }), a = te((l) => {
    if (o.dispose(), t.current === null) {
      t.current = l.currentTarget, r(!0);
      {
        let s = br(l.currentTarget);
        o.addEventListener(s, "pointerup", i, !1), o.addEventListener(s, "pointermove", (u) => {
          if (t.current) {
            let c = sp(u);
            r(up(c, t.current.getBoundingClientRect()));
          }
        }, !1), o.addEventListener(s, "pointercancel", i, !1);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: a, onPointerUp: i, onClick: i } };
}
let fp = xe(void 0);
function gi() {
  return be(fp);
}
function ga(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function Dt(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Dt), r;
}
var ti = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(ti || {}), dp = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(dp || {});
function pt() {
  let e = mp();
  return pe((t) => pp({ mergeRefs: e, ...t }), [e]);
}
function pp({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: o, visible: i = !0, name: a, mergeRefs: l }) {
  l = l ?? vp;
  let s = au(t, e);
  if (i) return Hr(s, n, r, a, l);
  let u = o ?? 0;
  if (u & 2) {
    let { static: c = !1, ...f } = s;
    if (c) return Hr(f, n, r, a, l);
  }
  if (u & 1) {
    let { unmount: c = !0, ...f } = s;
    return Dt(c ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Hr({ ...f, hidden: !0, style: { display: "none" } }, n, r, a, l);
    } });
  }
  return Hr(s, n, r, a, l);
}
function Hr(e, t = {}, n, r, o) {
  let { as: i = n, children: a, refName: l = "ref", ...s } = Ao(e, ["unmount", "static"]), u = e.ref !== void 0 ? { [l]: e.ref } : {}, c = typeof a == "function" ? a(t) : a;
  "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t)), s["aria-labelledby"] && s["aria-labelledby"] === s.id && (s["aria-labelledby"] = void 0);
  let f = {};
  if (t) {
    let p = !1, d = [];
    for (let [g, h] of Object.entries(t)) typeof h == "boolean" && (p = !0), h === !0 && d.push(g.replace(/([A-Z])/g, (v) => `-${v.toLowerCase()}`));
    if (p) {
      f["data-headlessui-state"] = d.join(" ");
      for (let g of d) f[`data-${g}`] = "";
    }
  }
  if (i === ut && (Object.keys(tn(s)).length > 0 || Object.keys(tn(f)).length > 0)) if (!Rc(c) || Array.isArray(c) && c.length > 1) {
    if (Object.keys(tn(s)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(tn(s)).concat(Object.keys(tn(f))).map((p) => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)].join(`
`));
  } else {
    let p = c.props, d = p == null ? void 0 : p.className, g = typeof d == "function" ? (...x) => ga(d(...x), s.className) : ga(d, s.className), h = g ? { className: g } : {}, v = au(c.props, tn(Ao(s, ["ref"])));
    for (let x in f) x in v && delete f[x];
    return Fc(c, Object.assign({}, v, f, u, { ref: o(hp(c), u.ref) }, h));
  }
  return Lc(i, Object.assign({}, Ao(s, ["ref"]), i !== ut && u, i !== ut && f), c);
}
function mp() {
  let e = X([]), t = pe((n) => {
    for (let r of e.current) r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null)) return e.current = n, t;
  };
}
function vp(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e) n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function au(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"]) for (let r in n) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(r) && (n[r] = [(o) => {
    var i;
    return (i = o == null ? void 0 : o.preventDefault) == null ? void 0 : i.call(o);
  }]);
  for (let r in n) Object.assign(t, { [r](o, ...i) {
    let a = n[r];
    for (let l of a) {
      if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented) return;
      l(o, ...i);
    }
  } });
  return t;
}
function yi(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  for (let r in n) Object.assign(t, { [r](...o) {
    let i = n[r];
    for (let a of i) a == null || a(...o);
  } });
  return t;
}
function mt(e) {
  var t;
  return Object.assign(qt(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function tn(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function Ao(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function hp(e) {
  return A.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
function bp(e, t, n) {
  let [r, o] = oe(n), i = e !== void 0, a = X(i), l = X(!1), s = X(!1);
  return i && !a.current && !l.current ? (l.current = !0, a.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && a.current && !s.current && (s.current = !0, a.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : r, te((u) => (i || o(u), t == null ? void 0 : t(u)))];
}
function gp(e) {
  let [t] = oe(e);
  return t;
}
function lu(e = {}, t = null, n = []) {
  for (let [r, o] of Object.entries(e)) uu(n, su(t, r), o);
  return n;
}
function su(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function uu(e, t, n) {
  if (Array.isArray(n)) for (let [r, o] of n.entries()) uu(e, su(t, r.toString()), o);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : lu(n, t, e);
}
let yp = "span";
var xi = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(xi || {});
function xp(e, t) {
  var n;
  let { features: r = 1, ...o } = e, i = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = o["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return pt()({ ourProps: i, theirProps: o, slot: {}, defaultTag: yp, name: "Hidden" });
}
let cu = mt(xp), $p = xe(null);
function wp({ children: e }) {
  let t = be($p);
  if (!t) return A.createElement(A.Fragment, null, e);
  let { target: n } = t;
  return n ? il(A.createElement(A.Fragment, null, e), n) : null;
}
function Ep({ data: e, form: t, disabled: n, onReset: r, overrides: o }) {
  let [i, a] = oe(null), l = gr();
  return ue(() => {
    if (r && i) return l.addEventListener(i, "reset", r);
  }, [i, t, r]), A.createElement(wp, null, A.createElement(Sp, { setForm: a, formId: t }), lu(e).map(([s, u]) => A.createElement(cu, { features: xi.Hidden, ...tn({ key: s, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: n, name: s, value: u, ...o }) })));
}
function Sp({ setForm: e, formId: t }) {
  return ue(() => {
    if (t) {
      let n = document.getElementById(t);
      n && e(n);
    }
  }, [e, t]), t ? null : A.createElement(cu, { features: xi.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (n) => {
    if (!n) return;
    let r = n.closest("form");
    r && e(r);
  } });
}
let Cp = xe(void 0);
function fu() {
  return be(Cp);
}
function Pp(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && Op(n) ? !1 : r;
}
function Op(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let du = Symbol();
function Tp(e, t = !0) {
  return Object.assign(e, { [du]: t });
}
function _t(...e) {
  let t = X(e);
  ue(() => {
    t.current = e;
  }, [e]);
  let n = te((r) => {
    for (let o of t.current) o != null && (typeof o == "function" ? o(r) : o.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[du])) ? void 0 : n;
}
let $i = xe(null);
$i.displayName = "DescriptionContext";
function pu() {
  let e = be($i);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, pu), t;
  }
  return e;
}
function Rp() {
  var e, t;
  return (t = (e = be($i)) == null ? void 0 : e.value) != null ? t : void 0;
}
let Fp = "p";
function Lp(e, t) {
  let n = Yt(), r = gi(), { id: o = `headlessui-description-${n}`, ...i } = e, a = pu(), l = _t(t);
  Se(() => a.register(o), [o, a.register]);
  let s = r || !1, u = re(() => ({ ...a.slot, disabled: s }), [a.slot, s]), c = { ref: l, ...a.props, id: o };
  return pt()({ ourProps: c, theirProps: i, slot: u, defaultTag: Fp, name: a.name || "Description" });
}
let Dp = mt(Lp);
Object.assign(Dp, {});
var Ue = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Ue || {});
let fo = xe(null);
fo.displayName = "LabelContext";
function mu() {
  let e = be(fo);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, mu), t;
  }
  return e;
}
function po(e) {
  var t, n, r;
  let o = (n = (t = be(fo)) == null ? void 0 : t.value) != null ? n : void 0;
  return ((r = e == null ? void 0 : e.length) != null ? r : 0) > 0 ? [o, ...e].filter(Boolean).join(" ") : o;
}
function Mp({ inherit: e = !1 } = {}) {
  let t = po(), [n, r] = oe([]), o = e ? [t, ...n].filter(Boolean) : n;
  return [o.length > 0 ? o.join(" ") : void 0, re(() => function(i) {
    let a = te((s) => (r((u) => [...u, s]), () => r((u) => {
      let c = u.slice(), f = c.indexOf(s);
      return f !== -1 && c.splice(f, 1), c;
    }))), l = re(() => ({ register: a, slot: i.slot, name: i.name, props: i.props, value: i.value }), [a, i.slot, i.name, i.props, i.value]);
    return A.createElement(fo.Provider, { value: l }, i.children);
  }, [r])];
}
let Ap = "label";
function _p(e, t) {
  var n;
  let r = Yt(), o = mu(), i = fu(), a = gi(), { id: l = `headlessui-label-${r}`, htmlFor: s = i ?? ((n = o.props) == null ? void 0 : n.htmlFor), passive: u = !1, ...c } = e, f = _t(t);
  Se(() => o.register(l), [l, o.register]);
  let p = te((v) => {
    let x = v.currentTarget;
    if (x instanceof HTMLLabelElement && v.preventDefault(), o.props && "onClick" in o.props && typeof o.props.onClick == "function" && o.props.onClick(v), x instanceof HTMLLabelElement) {
      let $ = document.getElementById(x.htmlFor);
      if ($) {
        let w = $.getAttribute("disabled");
        if (w === "true" || w === "") return;
        let S = $.getAttribute("aria-disabled");
        if (S === "true" || S === "") return;
        ($ instanceof HTMLInputElement && ($.type === "radio" || $.type === "checkbox") || $.role === "radio" || $.role === "checkbox" || $.role === "switch") && $.click(), $.focus({ preventScroll: !0 });
      }
    }
  }), d = a || !1, g = re(() => ({ ...o.slot, disabled: d }), [o.slot, d]), h = { ref: f, ...o.props, id: l, htmlFor: s, onClick: p };
  return u && ("onClick" in h && (delete h.htmlFor, delete h.onClick), "onClick" in c && delete c.onClick), pt()({ ourProps: h, theirProps: c, slot: g, defaultTag: s ? Ap : "div", name: o.name || "Label" });
}
let Np = mt(_p), vu = Object.assign(Np, {});
function Sn(e, t, n) {
  let r = n.initialDeps ?? [], o;
  function i() {
    var a, l, s, u;
    let c;
    n.key && ((a = n.debug) != null && a.call(n)) && (c = Date.now());
    const f = e();
    if (!(f.length !== r.length || f.some((g, h) => r[h] !== g)))
      return o;
    r = f;
    let d;
    if (n.key && ((l = n.debug) != null && l.call(n)) && (d = Date.now()), o = t(...f), n.key && ((s = n.debug) != null && s.call(n))) {
      const g = Math.round((Date.now() - c) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, v = h / 16, x = ($, w) => {
        for ($ = String($); $.length < w; )
          $ = " " + $;
        return $;
      };
      console.info(
        `%c⏱ ${x(h, 5)} /${x(g, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * v, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (u = n == null ? void 0 : n.onChange) == null || u.call(n, o), o;
  }
  return i.updateDeps = (a) => {
    r = a;
  }, i;
}
function _o(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Ip = (e, t) => Math.abs(e - t) < 1, jp = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, kp = (e) => e, Vp = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, Bp = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (a) => {
    const { width: l, height: s } = a;
    t({ width: Math.round(l), height: Math.round(s) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((a) => {
    const l = () => {
      const s = a[0];
      if (s != null && s.borderBoxSize) {
        const u = s.borderBoxSize[0];
        if (u) {
          o({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      o(n.getBoundingClientRect());
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(l) : l();
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, ya = {
  passive: !0
}, xa = typeof window > "u" ? !0 : "onscrollend" in window, Hp = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = e.options.useScrollendEvent && xa ? () => {
  } : jp(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: f, isRtl: p } = e.options;
    o = f ? n.scrollLeft * (p && -1 || 1) : n.scrollTop, i(), t(o, c);
  }, l = a(!0), s = a(!1);
  s(), n.addEventListener("scroll", l, ya);
  const u = e.options.useScrollendEvent && xa;
  return u && n.addEventListener("scrollend", s, ya), () => {
    n.removeEventListener("scroll", l), u && n.removeEventListener("scrollend", s);
  };
}, Wp = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, zp = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const a = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: n
  });
};
class Up {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          const a = () => {
            this._measureElement(i.target, i);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: kp,
        rangeExtractor: Vp,
        onChange: () => {
        },
        measureElement: Wp,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Sn(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const l = n[a];
        if (o.has(l.lane))
          continue;
        const s = i.get(
          l.lane
        );
        if (s == null || l.end > s.end ? i.set(l.lane, l) : l.end < s.end && o.set(l.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, l) => a.end === l.end ? a.index - l.index : a.end - l.end)[0] : void 0;
    }, this.getMeasurementOptions = Sn(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Sn(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: a }, l) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((c) => {
          this.itemSizeCache.set(c.key, c.size);
        }));
        const s = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, s);
        for (let c = s; c < n; c++) {
          const f = i(c), p = this.options.lanes === 1 ? u[c - 1] : this.getFurthestMeasurement(u, c), d = p ? p.end + this.options.gap : r + o, g = l.get(f), h = typeof g == "number" ? g : this.options.estimateSize(c), v = d + h, x = p ? p.lane : c % this.options.lanes;
          u[c] = {
            index: c,
            start: d,
            size: h,
            end: v,
            key: f,
            lane: x
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Sn(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, r, o, i) => this.range = n.length > 0 && r > 0 ? qp({
        measurements: n,
        outerSize: r,
        scrollOffset: o,
        lanes: i
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Sn(
      () => {
        let n = null, r = null;
        const o = this.calculateRange();
        return o && (n = o.startIndex, r = o.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          r
        ];
      },
      (n, r, o, i, a) => i === null || a === null ? [] : n({
        startIndex: i,
        endIndex: a,
        overscan: r,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const a = i.key, l = this.elementsCache.get(a);
      l !== n && (l && this.observer.unobserve(l), this.observer.observe(n), this.elementsCache.set(a, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, a = r - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, a, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Sn(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, a = n.length; i < a; i++) {
          const l = n[i], s = r[l];
          o.push(s);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return _o(
          r[hu(
            0,
            r.length - 1,
            (o) => _o(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r, o = 0) => {
      const i = this.getSize(), a = this.getScrollOffset();
      r === "auto" && (r = n >= a + i ? "end" : "start"), r === "center" ? n += (o - i) / 2 : r === "end" && (n -= i);
      const l = this.options.horizontal ? "scrollWidth" : "scrollHeight", u = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[l] : this.scrollElement[l] : 0) - i;
      return Math.max(Math.min(u, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const l = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(l, r, o.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i) return;
      const [a, l] = i;
      this._scrollToOffset(a, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [u] = _o(
            this.getOffsetForIndex(n, l)
          );
          Ip(u, this.getScrollOffset()) || this.scrollToIndex(n, { align: l, behavior: o });
        } else
          this.scrollToIndex(n, { align: l, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      if (r.length === 0)
        o = this.options.paddingStart;
      else if (this.options.lanes === 1)
        o = ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const i = Array(this.options.lanes).fill(null);
        let a = r.length - 1;
        for (; a > 0 && i.some((l) => l === null); ) {
          const l = r[a];
          i[l.lane] === null && (i[l.lane] = l.end), a--;
        }
        o = Math.max(...i.filter((l) => l !== null));
      }
      return Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const hu = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function qp({
  measurements: e,
  outerSize: t,
  scrollOffset: n,
  lanes: r
}) {
  const o = e.length - 1, i = (s) => e[s].start;
  if (e.length <= r)
    return {
      startIndex: 0,
      endIndex: o
    };
  let a = hu(
    0,
    o,
    i,
    n
  ), l = a;
  if (r === 1)
    for (; l < o && e[l].end < n + t; )
      l++;
  else if (r > 1) {
    const s = Array(r).fill(0);
    for (; l < o && s.some((c) => c < n + t); ) {
      const c = e[l];
      s[c.lane] = c.end, l++;
    }
    const u = Array(r).fill(n + t);
    for (; a > 0 && u.some((c) => c >= n); ) {
      const c = e[a];
      u[c.lane] = c.start, a--;
    }
    a = Math.max(0, a - a % r), l = Math.min(o, l + (r - 1 - l % r));
  }
  return { startIndex: a, endIndex: l };
}
const $a = typeof document < "u" ? j.useLayoutEffect : j.useEffect;
function Yp(e) {
  const t = j.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var a;
      i ? rn(t) : t(), (a = e.onChange) == null || a.call(e, o, i);
    }
  }, [r] = j.useState(
    () => new Up(n)
  );
  return r.setOptions(n), $a(() => r._didMount(), []), $a(() => r._willUpdate()), r;
}
function Gp(e) {
  return Yp({
    observeElementRect: Bp,
    observeElementOffset: Hp,
    scrollToFn: zp,
    ...e
  });
}
function Kp(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function Xp(e = Kp) {
  return pe((t, n) => {
    if (typeof e == "string") {
      let r = e;
      return (t == null ? void 0 : t[r]) === (n == null ? void 0 : n[r]);
    }
    return e(t, n);
  }, [e]);
}
function Jp(e) {
  if (e === null) return { width: 0, height: 0 };
  let { width: t, height: n } = e.getBoundingClientRect();
  return { width: t, height: n };
}
function wa(e, t = !1) {
  let [n, r] = ol(() => ({}), {}), o = re(() => Jp(e), [e, n]);
  return Se(() => {
    if (!e) return;
    let i = new ResizeObserver(r);
    return i.observe(e), () => {
      i.disconnect();
    };
  }, [e]), t ? { width: `${o.width}px`, height: `${o.height}px` } : o;
}
let Zp = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let n = super.get(t);
    return n === void 0 && (n = this.factory(t), this.set(t, n)), n;
  }
};
function bu(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(o) {
    return r.add(o), () => r.delete(o);
  }, dispatch(o, ...i) {
    let a = t[o].call(n, ...i);
    a && (n = a, r.forEach((l) => l()));
  } };
}
function gu(e) {
  return Dc(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let Qp = new Zp(() => bu(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1) return this;
  let n = this.slice();
  return n.splice(t, 1), n;
} }));
function wi(e, t) {
  let n = Qp.get(t), r = Yt(), o = gu(n);
  if (Se(() => {
    if (e) return n.dispatch("ADD", r), () => n.dispatch("REMOVE", r);
  }, [n, e]), !e) return !1;
  let i = o.indexOf(r), a = o.length;
  return i === -1 && (i = a, a += 1), i === a - 1;
}
let ni = /* @__PURE__ */ new Map(), nr = /* @__PURE__ */ new Map();
function Ea(e) {
  var t;
  let n = (t = nr.get(e)) != null ? t : 0;
  return nr.set(e, n + 1), n !== 0 ? () => Sa(e) : (ni.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => Sa(e));
}
function Sa(e) {
  var t;
  let n = (t = nr.get(e)) != null ? t : 1;
  if (n === 1 ? nr.delete(e) : nr.set(e, n - 1), n !== 1) return;
  let r = ni.get(e);
  r && (r["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r["aria-hidden"]), e.inert = r.inert, ni.delete(e));
}
function em(e, { allowed: t, disallowed: n } = {}) {
  let r = wi(e, "inert-others");
  Se(() => {
    var o, i;
    if (!r) return;
    let a = Et();
    for (let s of (o = n == null ? void 0 : n()) != null ? o : []) s && a.add(Ea(s));
    let l = (i = t == null ? void 0 : t()) != null ? i : [];
    for (let s of l) {
      if (!s) continue;
      let u = br(s);
      if (!u) continue;
      let c = s.parentElement;
      for (; c && c !== u.body; ) {
        for (let f of c.children) l.some((p) => f.contains(p)) || a.add(Ea(f));
        c = c.parentElement;
      }
    }
    return a.dispose;
  }, [r, t, n]);
}
function tm(e, t, n) {
  let r = vn((o) => {
    let i = o.getBoundingClientRect();
    i.x === 0 && i.y === 0 && i.width === 0 && i.height === 0 && n();
  });
  ue(() => {
    if (!e) return;
    let o = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!o) return;
    let i = Et();
    if (typeof ResizeObserver < "u") {
      let a = new ResizeObserver(() => r.current(o));
      a.observe(o), i.add(() => a.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let a = new IntersectionObserver(() => r.current(o));
      a.observe(o), i.add(() => a.disconnect());
    }
    return () => i.dispose();
  }, [t, r, e]);
}
let ri = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var nm = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(nm || {}), rm = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(rm || {}), om = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(om || {}), yu = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(yu || {});
function im(e, t = 0) {
  var n;
  return e === ((n = br(e)) == null ? void 0 : n.body) ? !1 : Dt(t, { 0() {
    return e.matches(ri);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(ri)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var am = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(am || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function lm(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), i = t(r);
    if (o === null || i === null) return 0;
    let a = o.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function xu() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function sm() {
  return /Android/gi.test(window.navigator.userAgent);
}
function $u() {
  return xu() || sm();
}
function Gn(e, t, n, r) {
  let o = vn(n);
  ue(() => {
    if (!e) return;
    function i(a) {
      o.current(a);
    }
    return document.addEventListener(t, i, r), () => document.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function um(e, t, n, r) {
  let o = vn(n);
  ue(() => {
    if (!e) return;
    function i(a) {
      o.current(a);
    }
    return window.addEventListener(t, i, r), () => window.removeEventListener(t, i, r);
  }, [e, t, r]);
}
const Ca = 30;
function cm(e, t, n) {
  let r = wi(e, "outside-click"), o = vn(n), i = pe(function(s, u) {
    if (s.defaultPrevented) return;
    let c = u(s);
    if (c === null || !c.getRootNode().contains(c) || !c.isConnected) return;
    let f = function p(d) {
      return typeof d == "function" ? p(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(t);
    for (let p of f) if (p !== null && (p.contains(c) || s.composed && s.composedPath().includes(p))) return;
    return !im(c, yu.Loose) && c.tabIndex !== -1 && s.preventDefault(), o.current(s, c);
  }, [o, t]), a = X(null);
  Gn(r, "pointerdown", (s) => {
    var u, c;
    a.current = ((c = (u = s.composedPath) == null ? void 0 : u.call(s)) == null ? void 0 : c[0]) || s.target;
  }, !0), Gn(r, "mousedown", (s) => {
    var u, c;
    a.current = ((c = (u = s.composedPath) == null ? void 0 : u.call(s)) == null ? void 0 : c[0]) || s.target;
  }, !0), Gn(r, "click", (s) => {
    $u() || a.current && (i(s, () => a.current), a.current = null);
  }, !0);
  let l = X({ x: 0, y: 0 });
  Gn(r, "touchstart", (s) => {
    l.current.x = s.touches[0].clientX, l.current.y = s.touches[0].clientY;
  }, !0), Gn(r, "touchend", (s) => {
    let u = { x: s.changedTouches[0].clientX, y: s.changedTouches[0].clientY };
    if (!(Math.abs(u.x - l.current.x) >= Ca || Math.abs(u.y - l.current.y) >= Ca)) return i(s, () => s.target instanceof HTMLElement ? s.target : null);
  }, !0), um(r, "blur", (s) => i(s, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function mo(...e) {
  return re(() => br(...e), [...e]);
}
function fm(e, t, n, r) {
  let o = vn(n);
  ue(() => {
    e = e ?? window;
    function i(a) {
      o.current(a);
    }
    return e.addEventListener(t, i, r), () => e.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function wu(e) {
  let t = X({ value: "", selectionStart: null, selectionEnd: null });
  return fm(e, "blur", (n) => {
    let r = n.target;
    r instanceof HTMLInputElement && (t.current = { value: r.value, selectionStart: r.selectionStart, selectionEnd: r.selectionEnd });
  }), te(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== t.current.value) e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: n, selectionEnd: r } = t.current;
        n !== null && r !== null && e.setSelectionRange(n, r);
      }
      t.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function dm(e, t) {
  return re(() => {
    var n;
    if (e.type) return e.type;
    let r = (n = e.as) != null ? n : "button";
    if (typeof r == "string" && r.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type")) return "button";
  }, [e.type, e.as, t]);
}
function pm() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement, o = (n = t.defaultView) != null ? n : window;
    e = Math.max(0, o.innerWidth - r.clientWidth);
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, o = Math.max(0, r.clientWidth - r.offsetWidth), i = Math.max(0, e - o);
    n.style(r, "paddingRight", `${i}px`);
  } };
}
function mm() {
  return xu() ? { before({ doc: e, d: t, meta: n }) {
    function r(o) {
      return n.containers.flatMap((i) => i()).some((i) => i.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let l = Et();
        l.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => l.dispose()));
      }
      let i = (o = window.scrollY) != null ? o : window.pageYOffset, a = null;
      t.addEventListener(e, "click", (l) => {
        if (l.target instanceof HTMLElement) try {
          let s = l.target.closest("a");
          if (!s) return;
          let { hash: u } = new URL(s.href), c = e.querySelector(u);
          c && !r(c) && (a = c);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (l) => {
        if (l.target instanceof HTMLElement) if (r(l.target)) {
          let s = l.target;
          for (; s.parentElement && r(s.parentElement); ) s = s.parentElement;
          t.style(s, "overscrollBehavior", "contain");
        } else t.style(l.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (l) => {
        if (l.target instanceof HTMLElement) {
          if (l.target.tagName === "INPUT") return;
          if (r(l.target)) {
            let s = l.target;
            for (; s.parentElement && s.dataset.headlessuiPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth); ) s = s.parentElement;
            s.dataset.headlessuiPortal === "" && l.preventDefault();
          } else l.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var l;
        let s = (l = window.scrollY) != null ? l : window.pageYOffset;
        i !== s && window.scrollTo(0, i), a && a.isConnected && (a.scrollIntoView({ block: "nearest" }), a = null);
      });
    });
  } } : {};
}
function vm() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function hm(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
let on = bu(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Et(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: hm(n) }, o = [mm(), pm(), vm()];
  o.forEach(({ before: i }) => i == null ? void 0 : i(r)), o.forEach(({ after: i }) => i == null ? void 0 : i(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
on.subscribe(() => {
  let e = on.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", o = n.count !== 0;
    (o && !r || !o && r) && on.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && on.dispatch("TEARDOWN", n);
  }
});
function bm(e, t, n = () => ({ containers: [] })) {
  let r = gu(on), o = t ? r.get(t) : void 0, i = o ? o.count > 0 : !1;
  return Se(() => {
    if (!(!t || !e)) return on.dispatch("PUSH", t, n), () => on.dispatch("POP", t, n);
  }, [e, t]), i;
}
function gm(e, t, n = () => [document.body]) {
  let r = wi(e, "scroll-lock");
  bm(r, t, (o) => {
    var i;
    return { containers: [...(i = o.containers) != null ? i : [], n] };
  });
}
function Pa(e) {
  return [e.screenX, e.screenY];
}
function ym() {
  let e = X([-1, -1]);
  return { wasMoved(t) {
    let n = Pa(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Pa(t);
  } };
}
function xm(e = 0) {
  let [t, n] = oe(e), r = pe((s) => n(s), [t]), o = pe((s) => n((u) => u | s), [t]), i = pe((s) => (t & s) === s, [t]), a = pe((s) => n((u) => u & ~s), [n]), l = pe((s) => n((u) => u ^ s), [n]);
  return { flags: t, setFlag: r, addFlag: o, hasFlag: i, removeFlag: a, toggleFlag: l };
}
var Oa, Ta;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((Oa = process == null ? void 0 : process.env) == null ? void 0 : Oa.NODE_ENV) === "test" && typeof ((Ta = Element == null ? void 0 : Element.prototype) == null ? void 0 : Ta.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var $m = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))($m || {});
function wm(e) {
  let t = {};
  for (let n in e) e[n] === !0 && (t[`data-${n}`] = "");
  return t;
}
function Em(e, t, n, r) {
  let [o, i] = oe(n), { hasFlag: a, addFlag: l, removeFlag: s } = xm(e && o ? 3 : 0), u = X(!1), c = X(!1), f = gr();
  return Se(() => {
    var p;
    if (e) {
      if (n && i(!0), !t) {
        n && l(3);
        return;
      }
      return (p = void 0) == null || p.call(r, n), Sm(t, { inFlight: u, prepare() {
        c.current ? c.current = !1 : c.current = u.current, u.current = !0, !c.current && (n ? (l(3), s(4)) : (l(4), s(2)));
      }, run() {
        c.current ? n ? (s(3), l(4)) : (s(4), l(3)) : n ? s(1) : l(1);
      }, done() {
        var d;
        c.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (u.current = !1, s(7), n || i(!1), (d = void 0) == null || d.call(r, n));
      } });
    }
  }, [e, n, t, f]), e ? [o, { closed: a(1), enter: a(2), leave: a(4), transition: a(2) || a(4) }] : [n, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function Sm(e, { prepare: t, run: n, done: r, inFlight: o }) {
  let i = Et();
  return Pm(e, { prepare: t, inFlight: o }), i.nextFrame(() => {
    n(), i.requestAnimationFrame(() => {
      i.add(Cm(e, r));
    });
  }), i.dispose;
}
function Cm(e, t) {
  var n, r;
  let o = Et();
  if (!e) return o.dispose;
  let i = !1;
  o.add(() => {
    i = !0;
  });
  let a = (r = (n = e.getAnimations) == null ? void 0 : n.call(e).filter((l) => l instanceof CSSTransition)) != null ? r : [];
  return a.length === 0 ? (t(), o.dispose) : (Promise.allSettled(a.map((l) => l.finished)).then(() => {
    i || t();
  }), o.dispose);
}
function Pm(e, { inFlight: t, prepare: n }) {
  if (t != null && t.current) {
    n();
    return;
  }
  let r = e.style.transition;
  e.style.transition = "none", n(), e.offsetHeight, e.style.transition = r;
}
function Om(e, { container: t, accept: n, walk: r }) {
  let o = X(n), i = X(r);
  ue(() => {
    o.current = n, i.current = r;
  }, [n, r]), Se(() => {
    if (!t || !e) return;
    let a = br(t);
    if (!a) return;
    let l = o.current, s = i.current, u = Object.assign((f) => l(f), { acceptNode: l }), c = a.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; c.nextNode(); ) s(c.currentNode);
  }, [t, e, o, i]);
}
function Ra(e, t) {
  let n = X([]), r = te(e);
  ue(() => {
    let o = [...n.current];
    for (let [i, a] of t.entries()) if (n.current[i] !== a) {
      let l = r(t, o);
      return n.current = t, l;
    }
  }, [r, ...t]);
}
function vo() {
  return typeof window < "u";
}
function Mn(e) {
  return Eu(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Xe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pt(e) {
  var t;
  return (t = (Eu(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Eu(e) {
  return vo() ? e instanceof Node || e instanceof Xe(e).Node : !1;
}
function Be(e) {
  return vo() ? e instanceof Element || e instanceof Xe(e).Element : !1;
}
function St(e) {
  return vo() ? e instanceof HTMLElement || e instanceof Xe(e).HTMLElement : !1;
}
function Fa(e) {
  return !vo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Xe(e).ShadowRoot;
}
function yr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = dt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Tm(e) {
  return ["table", "td", "th"].includes(Mn(e));
}
function ho(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ei(e) {
  const t = Si(), n = Be(e) ? dt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Rm(e) {
  let t = zt(e);
  for (; St(t) && !Tn(t); ) {
    if (Ei(t))
      return t;
    if (ho(t))
      return null;
    t = zt(t);
  }
  return null;
}
function Si() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Tn(e) {
  return ["html", "body", "#document"].includes(Mn(e));
}
function dt(e) {
  return Xe(e).getComputedStyle(e);
}
function bo(e) {
  return Be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function zt(e) {
  if (Mn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Fa(e) && e.host || // Fallback.
    Pt(e)
  );
  return Fa(t) ? t.host : t;
}
function Su(e) {
  const t = zt(e);
  return Tn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : St(t) && yr(t) ? t : Su(t);
}
function sr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Su(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Xe(o);
  if (i) {
    const l = oi(a);
    return t.concat(a, a.visualViewport || [], yr(o) ? o : [], l && n ? sr(l) : []);
  }
  return t.concat(o, sr(o, [], n));
}
function oi(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Fm() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
const cn = Math.min, Ve = Math.max, ur = Math.round, Wr = Math.floor, $t = (e) => ({
  x: e,
  y: e
}), Lm = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Dm = {
  start: "end",
  end: "start"
};
function La(e, t, n) {
  return Ve(e, cn(t, n));
}
function An(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ut(e) {
  return e.split("-")[0];
}
function xr(e) {
  return e.split("-")[1];
}
function Cu(e) {
  return e === "x" ? "y" : "x";
}
function Pu(e) {
  return e === "y" ? "height" : "width";
}
function fn(e) {
  return ["top", "bottom"].includes(Ut(e)) ? "y" : "x";
}
function Ou(e) {
  return Cu(fn(e));
}
function Mm(e, t, n) {
  n === void 0 && (n = !1);
  const r = xr(e), o = Ou(e), i = Pu(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Zr(a)), [a, Zr(a)];
}
function Am(e) {
  const t = Zr(e);
  return [ii(e), t, ii(t)];
}
function ii(e) {
  return e.replace(/start|end/g, (t) => Dm[t]);
}
function _m(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function Nm(e, t, n, r) {
  const o = xr(e);
  let i = _m(Ut(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(ii)))), i;
}
function Zr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Lm[t]);
}
function Im(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function jm(e) {
  return typeof e != "number" ? Im(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Qr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Da(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = fn(t), a = Ou(t), l = Pu(a), s = Ut(t), u = i === "y", c = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[l] / 2 - o[l] / 2;
  let d;
  switch (s) {
    case "top":
      d = {
        x: c,
        y: r.y - o.height
      };
      break;
    case "bottom":
      d = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (xr(t)) {
    case "start":
      d[a] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      d[a] += p * (n && u ? -1 : 1);
      break;
  }
  return d;
}
const km = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, l = i.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: f
  } = Da(u, r, s), p = r, d = {}, g = 0;
  for (let h = 0; h < l.length; h++) {
    const {
      name: v,
      fn: x
    } = l[h], {
      x: $,
      y: w,
      data: S,
      reset: E
    } = await x({
      x: c,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: d,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = $ ?? c, f = w ?? f, d = {
      ...d,
      [v]: {
        ...d[v],
        ...S
      }
    }, E && g <= 50 && (g++, typeof E == "object" && (E.placement && (p = E.placement), E.rects && (u = E.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: c,
      y: f
    } = Da(u, p, s)), h = -1);
  }
  return {
    x: c,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: d
  };
};
async function go(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = An(t, e), g = jm(d), v = l[p ? f === "floating" ? "reference" : "floating" : f], x = Qr(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: s
  })), $ = f === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), S = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Qr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: $,
    offsetParent: w,
    strategy: s
  }) : $);
  return {
    top: (x.top - E.top + g.top) / S.y,
    bottom: (E.bottom - x.bottom + g.bottom) / S.y,
    left: (x.left - E.left + g.left) / S.x,
    right: (E.right - x.right + g.right) / S.x
  };
}
const Vm = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: h = !0,
        ...v
      } = An(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const x = Ut(o), $ = fn(l), w = Ut(l) === l, S = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), E = p || (w || !h ? [Zr(l)] : Am(l)), L = g !== "none";
      !p && L && E.push(...Nm(l, h, g, S));
      const T = [l, ...E], _ = await go(t, v), W = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (c && W.push(_[x]), f) {
        const M = Mm(o, a, S);
        W.push(_[M[0]], _[M[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: W
      }], !W.every((M) => M <= 0)) {
        var D, k;
        const M = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, q = T[M];
        if (q)
          return {
            data: {
              index: M,
              overflows: P
            },
            reset: {
              placement: q
            }
          };
        let U = (k = P.filter((J) => J.overflows[0] <= 0).sort((J, Y) => J.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!U)
          switch (d) {
            case "bestFit": {
              var z;
              const J = (z = P.filter((Y) => {
                if (L) {
                  const G = fn(Y.placement);
                  return G === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  G === "y";
                }
                return !0;
              }).map((Y) => [Y.placement, Y.overflows.filter((G) => G > 0).reduce((G, Z) => G + Z, 0)]).sort((Y, G) => Y[1] - G[1])[0]) == null ? void 0 : z[0];
              J && (U = J);
              break;
            }
            case "initialPlacement":
              U = l;
              break;
          }
        if (o !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
async function Bm(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Ut(n), l = xr(n), s = fn(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, c = i && s ? -1 : 1, f = An(t, e);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof g == "number" && (d = l === "end" ? g * -1 : g), s ? {
    x: d * c,
    y: p * u
  } : {
    x: p * u,
    y: d * c
  };
}
const Hm = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: l
      } = t, s = await Bm(t, e);
      return a === ((n = l.offset) == null ? void 0 : n.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: o + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, Wm = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x,
              y: $
            } = v;
            return {
              x,
              y: $
            };
          }
        },
        ...s
      } = An(e, t), u = {
        x: n,
        y: r
      }, c = await go(t, s), f = fn(Ut(o)), p = Cu(f);
      let d = u[p], g = u[f];
      if (i) {
        const v = p === "y" ? "top" : "left", x = p === "y" ? "bottom" : "right", $ = d + c[v], w = d - c[x];
        d = La($, d, w);
      }
      if (a) {
        const v = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", $ = g + c[v], w = g - c[x];
        g = La($, g, w);
      }
      const h = l.fn({
        ...t,
        [p]: d,
        [f]: g
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [p]: i,
            [f]: a
          }
        }
      };
    }
  };
}, zm = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: l
      } = t, {
        apply: s = () => {
        },
        ...u
      } = An(e, t), c = await go(t, u), f = Ut(o), p = xr(o), d = fn(o) === "y", {
        width: g,
        height: h
      } = i.floating;
      let v, x;
      f === "top" || f === "bottom" ? (v = f, x = p === (await (a.isRTL == null ? void 0 : a.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (x = f, v = p === "end" ? "top" : "bottom");
      const $ = h - c.top - c.bottom, w = g - c.left - c.right, S = cn(h - c[v], $), E = cn(g - c[x], w), L = !t.middlewareData.shift;
      let T = S, _ = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (_ = w), (r = t.middlewareData.shift) != null && r.enabled.y && (T = $), L && !p) {
        const P = Ve(c.left, 0), D = Ve(c.right, 0), k = Ve(c.top, 0), z = Ve(c.bottom, 0);
        d ? _ = g - 2 * (P !== 0 || D !== 0 ? P + D : Ve(c.left, c.right)) : T = h - 2 * (k !== 0 || z !== 0 ? k + z : Ve(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: _,
        availableHeight: T
      });
      const W = await a.getDimensions(l.floating);
      return g !== W.width || h !== W.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Tu(e) {
  const t = dt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = St(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, l = ur(n) !== i || ur(r) !== a;
  return l && (n = i, r = a), {
    width: n,
    height: r,
    $: l
  };
}
function Ci(e) {
  return Be(e) ? e : e.contextElement;
}
function On(e) {
  const t = Ci(e);
  if (!St(t))
    return $t(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Tu(t);
  let a = (i ? ur(n.width) : n.width) / r, l = (i ? ur(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const Um = /* @__PURE__ */ $t(0);
function Ru(e) {
  const t = Xe(e);
  return !Si() || !t.visualViewport ? Um : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qm(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Xe(e) ? !1 : t;
}
function dn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Ci(e);
  let a = $t(1);
  t && (r ? Be(r) && (a = On(r)) : a = On(e));
  const l = qm(i, n, r) ? Ru(i) : $t(0);
  let s = (o.left + l.x) / a.x, u = (o.top + l.y) / a.y, c = o.width / a.x, f = o.height / a.y;
  if (i) {
    const p = Xe(i), d = r && Be(r) ? Xe(r) : r;
    let g = p, h = oi(g);
    for (; h && r && d !== g; ) {
      const v = On(h), x = h.getBoundingClientRect(), $ = dt(h), w = x.left + (h.clientLeft + parseFloat($.paddingLeft)) * v.x, S = x.top + (h.clientTop + parseFloat($.paddingTop)) * v.y;
      s *= v.x, u *= v.y, c *= v.x, f *= v.y, s += w, u += S, g = Xe(h), h = oi(g);
    }
  }
  return Qr({
    width: c,
    height: f,
    x: s,
    y: u
  });
}
function Pi(e, t) {
  const n = bo(e).scrollLeft;
  return t ? t.left + n : dn(Pt(e)).left + n;
}
function Fu(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Pi(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Ym(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Pt(r), l = t ? ho(t.floating) : !1;
  if (r === a || l && i)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = $t(1);
  const c = $t(0), f = St(r);
  if ((f || !f && !i) && ((Mn(r) !== "body" || yr(a)) && (s = bo(r)), St(r))) {
    const d = dn(r);
    u = On(r), c.x = d.x + r.clientLeft, c.y = d.y + r.clientTop;
  }
  const p = a && !f && !i ? Fu(a, s, !0) : $t(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - s.scrollLeft * u.x + c.x + p.x,
    y: n.y * u.y - s.scrollTop * u.y + c.y + p.y
  };
}
function Gm(e) {
  return Array.from(e.getClientRects());
}
function Km(e) {
  const t = Pt(e), n = bo(e), r = e.ownerDocument.body, o = Ve(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ve(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Pi(e);
  const l = -n.scrollTop;
  return dt(r).direction === "rtl" && (a += Ve(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: l
  };
}
function Xm(e, t) {
  const n = Xe(e), r = Pt(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    const u = Si();
    (!u || u && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function Jm(e, t) {
  const n = dn(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = St(e) ? On(e) : $t(1), a = e.clientWidth * i.x, l = e.clientHeight * i.y, s = o * i.x, u = r * i.y;
  return {
    width: a,
    height: l,
    x: s,
    y: u
  };
}
function Ma(e, t, n) {
  let r;
  if (t === "viewport")
    r = Xm(e, n);
  else if (t === "document")
    r = Km(Pt(e));
  else if (Be(t))
    r = Jm(t, n);
  else {
    const o = Ru(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Qr(r);
}
function Lu(e, t) {
  const n = zt(e);
  return n === t || !Be(n) || Tn(n) ? !1 : dt(n).position === "fixed" || Lu(n, t);
}
function Zm(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = sr(e, [], !1).filter((l) => Be(l) && Mn(l) !== "body"), o = null;
  const i = dt(e).position === "fixed";
  let a = i ? zt(e) : e;
  for (; Be(a) && !Tn(a); ) {
    const l = dt(a), s = Ei(a);
    !s && l.position === "fixed" && (o = null), (i ? !s && !o : !s && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || yr(a) && !s && Lu(e, a)) ? r = r.filter((c) => c !== a) : o = l, a = zt(a);
  }
  return t.set(e, r), r;
}
function Qm(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? ho(t) ? [] : Zm(t, this._c) : [].concat(n), r], l = a[0], s = a.reduce((u, c) => {
    const f = Ma(t, c, o);
    return u.top = Ve(f.top, u.top), u.right = cn(f.right, u.right), u.bottom = cn(f.bottom, u.bottom), u.left = Ve(f.left, u.left), u;
  }, Ma(t, l, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function ev(e) {
  const {
    width: t,
    height: n
  } = Tu(e);
  return {
    width: t,
    height: n
  };
}
function tv(e, t, n) {
  const r = St(t), o = Pt(t), i = n === "fixed", a = dn(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = $t(0);
  if (r || !r && !i)
    if ((Mn(t) !== "body" || yr(o)) && (l = bo(t)), r) {
      const p = dn(t, !0, i, t);
      s.x = p.x + t.clientLeft, s.y = p.y + t.clientTop;
    } else o && (s.x = Pi(o));
  const u = o && !r && !i ? Fu(o, l) : $t(0), c = a.left + l.scrollLeft - s.x - u.x, f = a.top + l.scrollTop - s.y - u.y;
  return {
    x: c,
    y: f,
    width: a.width,
    height: a.height
  };
}
function No(e) {
  return dt(e).position === "static";
}
function Aa(e, t) {
  if (!St(e) || dt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Pt(e) === n && (n = n.ownerDocument.body), n;
}
function Du(e, t) {
  const n = Xe(e);
  if (ho(e))
    return n;
  if (!St(e)) {
    let o = zt(e);
    for (; o && !Tn(o); ) {
      if (Be(o) && !No(o))
        return o;
      o = zt(o);
    }
    return n;
  }
  let r = Aa(e, t);
  for (; r && Tm(r) && No(r); )
    r = Aa(r, t);
  return r && Tn(r) && No(r) && !Ei(r) ? n : r || Rm(e) || n;
}
const nv = async function(e) {
  const t = this.getOffsetParent || Du, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: tv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function rv(e) {
  return dt(e).direction === "rtl";
}
const ov = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ym,
  getDocumentElement: Pt,
  getClippingRect: Qm,
  getOffsetParent: Du,
  getElementRects: nv,
  getClientRects: Gm,
  getDimensions: ev,
  getScale: On,
  isElement: Be,
  isRTL: rv
};
function Mu(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function iv(e, t) {
  let n = null, r;
  const o = Pt(e);
  function i() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function a(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), i();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: p,
      height: d
    } = u;
    if (l || t(), !p || !d)
      return;
    const g = Wr(f), h = Wr(o.clientWidth - (c + p)), v = Wr(o.clientHeight - (f + d)), x = Wr(c), w = {
      rootMargin: -g + "px " + -h + "px " + -v + "px " + -x + "px",
      threshold: Ve(0, cn(1, s)) || 1
    };
    let S = !0;
    function E(L) {
      const T = L[0].intersectionRatio;
      if (T !== s) {
        if (!S)
          return a();
        T ? a(!1, T) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !Mu(u, e.getBoundingClientRect()) && a(), S = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, w);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function av(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = r, u = Ci(e), c = o || i ? [...u ? sr(u) : [], ...sr(t)] : [];
  c.forEach((x) => {
    o && x.addEventListener("scroll", n, {
      passive: !0
    }), i && x.addEventListener("resize", n);
  });
  const f = u && l ? iv(u, n) : null;
  let p = -1, d = null;
  a && (d = new ResizeObserver((x) => {
    let [$] = x;
    $ && $.target === u && d && (d.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = d) == null || w.observe(t);
    })), n();
  }), u && !s && d.observe(u), d.observe(t));
  let g, h = s ? dn(e) : null;
  s && v();
  function v() {
    const x = dn(e);
    h && !Mu(h, x) && n(), h = x, g = requestAnimationFrame(v);
  }
  return n(), () => {
    var x;
    c.forEach(($) => {
      o && $.removeEventListener("scroll", n), i && $.removeEventListener("resize", n);
    }), f == null || f(), (x = d) == null || x.disconnect(), d = null, s && cancelAnimationFrame(g);
  };
}
const Io = go, lv = Hm, sv = Wm, uv = Vm, cv = zm, fv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ov,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return km(e, t, {
    ...o,
    platform: i
  });
};
var Ur = typeof document < "u" ? fi : ue;
function eo(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!eo(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !eo(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Au(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _a(e, t) {
  const n = Au(e);
  return Math.round(t * n) / n;
}
function jo(e) {
  const t = j.useRef(e);
  return Ur(() => {
    t.current = e;
  }), t;
}
function dv(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: l = !0,
    whileElementsMounted: s,
    open: u
  } = e, [c, f] = j.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = j.useState(r);
  eo(p, r) || d(r);
  const [g, h] = j.useState(null), [v, x] = j.useState(null), $ = j.useCallback((Y) => {
    Y !== L.current && (L.current = Y, h(Y));
  }, []), w = j.useCallback((Y) => {
    Y !== T.current && (T.current = Y, x(Y));
  }, []), S = i || g, E = a || v, L = j.useRef(null), T = j.useRef(null), _ = j.useRef(c), W = s != null, P = jo(s), D = jo(o), k = jo(u), z = j.useCallback(() => {
    if (!L.current || !T.current)
      return;
    const Y = {
      placement: t,
      strategy: n,
      middleware: p
    };
    D.current && (Y.platform = D.current), fv(L.current, T.current, Y).then((G) => {
      const Z = {
        ...G,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      M.current && !eo(_.current, Z) && (_.current = Z, ir.flushSync(() => {
        f(Z);
      }));
    });
  }, [p, t, n, D, k]);
  Ur(() => {
    u === !1 && _.current.isPositioned && (_.current.isPositioned = !1, f((Y) => ({
      ...Y,
      isPositioned: !1
    })));
  }, [u]);
  const M = j.useRef(!1);
  Ur(() => (M.current = !0, () => {
    M.current = !1;
  }), []), Ur(() => {
    if (S && (L.current = S), E && (T.current = E), S && E) {
      if (P.current)
        return P.current(S, E, z);
      z();
    }
  }, [S, E, z, P, W]);
  const q = j.useMemo(() => ({
    reference: L,
    floating: T,
    setReference: $,
    setFloating: w
  }), [$, w]), U = j.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), J = j.useMemo(() => {
    const Y = {
      position: n,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return Y;
    const G = _a(U.floating, c.x), Z = _a(U.floating, c.y);
    return l ? {
      ...Y,
      transform: "translate(" + G + "px, " + Z + "px)",
      ...Au(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: G,
      top: Z
    };
  }, [n, l, U.floating, c.x, c.y]);
  return j.useMemo(() => ({
    ...c,
    update: z,
    refs: q,
    elements: U,
    floatingStyles: J
  }), [c, z, q, U, J]);
}
const _u = (e, t) => ({
  ...lv(e),
  options: [e, t]
}), pv = (e, t) => ({
  ...sv(e),
  options: [e, t]
}), mv = (e, t) => ({
  ...uv(e),
  options: [e, t]
}), vv = (e, t) => ({
  ...cv(e),
  options: [e, t]
}), Nu = {
  ...j
}, hv = Nu.useInsertionEffect, bv = hv || ((e) => e());
function Iu(e) {
  const t = j.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return bv(() => {
    t.current = e;
  }), j.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var ai = typeof document < "u" ? fi : ue;
let Na = !1, gv = 0;
const Ia = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + gv++
);
function yv() {
  const [e, t] = j.useState(() => Na ? Ia() : void 0);
  return ai(() => {
    e == null && t(Ia());
  }, []), j.useEffect(() => {
    Na = !0;
  }, []), e;
}
const xv = Nu.useId, $v = xv || yv;
let cr;
process.env.NODE_ENV !== "production" && (cr = /* @__PURE__ */ new Set());
function wv() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = cr) != null && e.has(o))) {
    var i;
    (i = cr) == null || i.add(o), console.warn(o);
  }
}
function Ev() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = cr) != null && e.has(o))) {
    var i;
    (i = cr) == null || i.add(o), console.error(o);
  }
}
function Sv() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const Cv = /* @__PURE__ */ j.createContext(null), Pv = /* @__PURE__ */ j.createContext(null), Ov = () => {
  var e;
  return ((e = j.useContext(Cv)) == null ? void 0 : e.id) || null;
}, Tv = () => j.useContext(Pv), Rv = "data-floating-ui-focusable";
function Fv(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = $v(), i = j.useRef({}), [a] = j.useState(() => Sv()), l = Ov() != null;
  if (process.env.NODE_ENV !== "production") {
    const d = r.reference;
    d && !Be(d) && Ev("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [s, u] = j.useState(r.reference), c = Iu((d, g, h) => {
    i.current.openEvent = d ? g : void 0, a.emit("openchange", {
      open: d,
      event: g,
      reason: h,
      nested: l
    }), n == null || n(d, g, h);
  }), f = j.useMemo(() => ({
    setPositionReference: u
  }), []), p = j.useMemo(() => ({
    reference: s || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [s, r.reference, r.floating]);
  return j.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: c,
    elements: p,
    events: a,
    floatingId: o,
    refs: f
  }), [t, c, p, a, o, f]);
}
function Lv(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Fv({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, a] = j.useState(null), [l, s] = j.useState(null), c = (o == null ? void 0 : o.domReference) || i, f = j.useRef(null), p = Tv();
  ai(() => {
    c && (f.current = c);
  }, [c]);
  const d = dv({
    ...e,
    elements: {
      ...o,
      ...l && {
        reference: l
      }
    }
  }), g = j.useCallback((w) => {
    const S = Be(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      contextElement: w
    } : w;
    s(S), d.refs.setReference(S);
  }, [d.refs]), h = j.useCallback((w) => {
    (Be(w) || w === null) && (f.current = w, a(w)), (Be(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !Be(w)) && d.refs.setReference(w);
  }, [d.refs]), v = j.useMemo(() => ({
    ...d.refs,
    setReference: h,
    setPositionReference: g,
    domReference: f
  }), [d.refs, h, g]), x = j.useMemo(() => ({
    ...d.elements,
    domReference: c
  }), [d.elements, c]), $ = j.useMemo(() => ({
    ...d,
    ...r,
    refs: v,
    elements: x,
    nodeId: t
  }), [d, v, x, t, r]);
  return ai(() => {
    r.dataRef.current.floatingContext = $;
    const w = p == null ? void 0 : p.nodesRef.current.find((S) => S.id === t);
    w && (w.context = $);
  }), j.useMemo(() => ({
    ...d,
    context: $,
    refs: v,
    elements: x
  }), [d, v, x, $]);
}
const ja = "active", ka = "selected";
function ko(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [ja]: a,
      [ka]: l,
      ...s
    } = e;
    i = s;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Rv]: ""
    },
    ...i,
    ...t.map((a) => {
      const l = a ? a[n] : null;
      return typeof l == "function" ? e ? l(e) : null : l;
    }).concat(e).reduce((a, l) => (l && Object.entries(l).forEach((s) => {
      let [u, c] = s;
      if (!(o && [ja, ka].includes(u)))
        if (u.indexOf("on") === 0) {
          if (r.has(u) || r.set(u, []), typeof c == "function") {
            var f;
            (f = r.get(u)) == null || f.push(c), a[u] = function() {
              for (var p, d = arguments.length, g = new Array(d), h = 0; h < d; h++)
                g[h] = arguments[h];
              return (p = r.get(u)) == null ? void 0 : p.map((v) => v(...g)).find((v) => v !== void 0);
            };
          }
        } else
          a[u] = c;
    }), a), {})
  };
}
function Dv(e) {
  e === void 0 && (e = []);
  const t = e.map((l) => l == null ? void 0 : l.reference), n = e.map((l) => l == null ? void 0 : l.floating), r = e.map((l) => l == null ? void 0 : l.item), o = j.useCallback(
    (l) => ko(l, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = j.useCallback(
    (l) => ko(l, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = j.useCallback(
    (l) => ko(l, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return j.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: a
  }), [o, i, a]);
}
function Va(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const Mv = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: n,
      overflowRef: r,
      onFallbackChange: o,
      offset: i = 0,
      index: a = 0,
      minItemsVisible: l = 4,
      referenceOverflowThreshold: s = 0,
      scrollRef: u,
      ...c
    } = An(e, t), {
      rects: f,
      elements: {
        floating: p
      }
    } = t, d = n.current[a], g = (u == null ? void 0 : u.current) || p, h = p.clientTop || g.clientTop, v = p.clientTop !== 0, x = g.clientTop !== 0, $ = p === g;
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || wv('`placement` side must be "bottom" when using the `inner`', "middleware.")), !d)
      return {};
    const w = {
      ...t,
      ...await _u(-d.offsetTop - p.clientTop - f.reference.height / 2 - d.offsetHeight / 2 - i).fn(t)
    }, S = await Io(Va(w, g.scrollHeight + h + p.clientTop), c), E = await Io(w, {
      ...c,
      elementContext: "reference"
    }), L = Ve(0, S.top), T = w.y + L, P = (g.scrollHeight > g.clientHeight ? (D) => D : ur)(Ve(0, g.scrollHeight + (v && $ || x ? h * 2 : 0) - L - Ve(0, S.bottom)));
    if (g.style.maxHeight = P + "px", g.scrollTop = L, o) {
      const D = g.offsetHeight < d.offsetHeight * cn(l, n.current.length) - 1 || E.top >= -s || E.bottom >= -s;
      ir.flushSync(() => o(D));
    }
    return r && (r.current = await Io(Va({
      ...w,
      y: T
    }, g.offsetHeight + h + p.clientTop), c)), {
      y: T
    };
  }
});
function Av(e, t) {
  const {
    open: n,
    elements: r
  } = e, {
    enabled: o = !0,
    overflowRef: i,
    scrollRef: a,
    onChange: l
  } = t, s = Iu(l), u = j.useRef(!1), c = j.useRef(null), f = j.useRef(null);
  j.useEffect(() => {
    if (!o) return;
    function d(h) {
      if (h.ctrlKey || !g || i.current == null)
        return;
      const v = h.deltaY, x = i.current.top >= -0.5, $ = i.current.bottom >= -0.5, w = g.scrollHeight - g.clientHeight, S = v < 0 ? -1 : 1, E = v < 0 ? "max" : "min";
      g.scrollHeight <= g.clientHeight || (!x && v > 0 || !$ && v < 0 ? (h.preventDefault(), ir.flushSync(() => {
        s((L) => L + Math[E](v, w * S));
      })) : /firefox/i.test(Fm()) && (g.scrollTop += v));
    }
    const g = (a == null ? void 0 : a.current) || r.floating;
    if (n && g)
      return g.addEventListener("wheel", d), requestAnimationFrame(() => {
        c.current = g.scrollTop, i.current != null && (f.current = {
          ...i.current
        });
      }), () => {
        c.current = null, f.current = null, g.removeEventListener("wheel", d);
      };
  }, [o, n, r.floating, i, a, s]);
  const p = j.useMemo(() => ({
    onKeyDown() {
      u.current = !0;
    },
    onWheel() {
      u.current = !1;
    },
    onPointerMove() {
      u.current = !1;
    },
    onScroll() {
      const d = (a == null ? void 0 : a.current) || r.floating;
      if (!(!i.current || !d || !u.current)) {
        if (c.current !== null) {
          const g = d.scrollTop - c.current;
          (i.current.bottom < -0.5 && g < -1 || i.current.top < -0.5 && g > 1) && ir.flushSync(() => s((h) => h + g));
        }
        requestAnimationFrame(() => {
          c.current = d.scrollTop;
        });
      }
    }
  }), [r.floating, s, i, a]);
  return j.useMemo(() => o ? {
    floating: p
  } : {}, [o, p]);
}
let $r = xe({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
$r.displayName = "FloatingContext";
let Oi = xe(null);
Oi.displayName = "PlacementContext";
function _v(e) {
  return re(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function Nv() {
  return be($r).setReference;
}
function Iv() {
  let { getFloatingProps: e, slot: t } = be($r);
  return pe((...n) => Object.assign({}, e(...n), { "data-anchor": t.anchor }), [e, t]);
}
function jv(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = be(Oi), n = re(() => e, [JSON.stringify(e, (o, i) => {
    var a;
    return (a = i == null ? void 0 : i.outerHTML) != null ? a : i;
  })]);
  Se(() => {
    t == null || t(n ?? null);
  }, [t, n]);
  let r = be($r);
  return re(() => [r.setFloating, e ? r.styles : {}], [r.setFloating, e, r.styles]);
}
let Ba = 4;
function kv({ children: e, enabled: t = !0 }) {
  let [n, r] = oe(null), [o, i] = oe(0), a = X(null), [l, s] = oe(null);
  Vv(l);
  let u = t && n !== null && l !== null, { to: c = "bottom", gap: f = 0, offset: p = 0, padding: d = 0, inner: g } = Bv(n, l), [h, v = "center"] = c.split(" ");
  Se(() => {
    u && i(0);
  }, [u]);
  let { refs: x, floatingStyles: $, context: w } = Lv({ open: u, placement: h === "selection" ? v === "center" ? "bottom" : `bottom-${v}` : v === "center" ? `${h}` : `${h}-${v}`, strategy: "absolute", transform: !1, middleware: [_u({ mainAxis: h === "selection" ? 0 : f, crossAxis: p }), pv({ padding: d }), h !== "selection" && mv({ padding: d }), h === "selection" && g ? Mv({ ...g, padding: d, overflowRef: a, offset: o, minItemsVisible: Ba, referenceOverflowThreshold: d, onFallbackChange(D) {
    var k, z;
    if (!D) return;
    let M = w.elements.floating;
    if (!M) return;
    let q = parseFloat(getComputedStyle(M).scrollPaddingBottom) || 0, U = Math.min(Ba, M.childElementCount), J = 0, Y = 0;
    for (let G of (z = (k = w.elements.floating) == null ? void 0 : k.childNodes) != null ? z : []) if (G instanceof HTMLElement) {
      let Z = G.offsetTop, Q = Z + G.clientHeight + q, B = M.scrollTop, N = B + M.clientHeight;
      if (Z >= B && Q <= N) U--;
      else {
        Y = Math.max(0, Math.min(Q, N) - Math.max(Z, B)), J = G.clientHeight;
        break;
      }
    }
    U >= 1 && i((G) => {
      let Z = J * U - Y + q;
      return G >= Z ? G : Z;
    });
  } }) : null, vv({ padding: d, apply({ availableWidth: D, availableHeight: k, elements: z }) {
    Object.assign(z.floating.style, { overflow: "auto", maxWidth: `${D}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${k}px)` });
  } })].filter(Boolean), whileElementsMounted: av }), [S = h, E = v] = w.placement.split("-");
  h === "selection" && (S = "selection");
  let L = re(() => ({ anchor: [S, E].filter(Boolean).join(" ") }), [S, E]), T = Av(w, { overflowRef: a, onChange: i }), { getReferenceProps: _, getFloatingProps: W } = Dv([T]), P = te((D) => {
    s(D), x.setFloating(D);
  });
  return j.createElement(Oi.Provider, { value: r }, j.createElement($r.Provider, { value: { setFloating: P, setReference: x.setReference, styles: $, getReferenceProps: _, getFloatingProps: W, slot: L } }, e));
}
function Vv(e) {
  Se(() => {
    if (!e) return;
    let t = new MutationObserver(() => {
      let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
      if (isNaN(r)) return;
      let o = parseInt(n);
      isNaN(o) || r !== o && (e.style.maxHeight = `${Math.ceil(r)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function Bv(e, t) {
  var n, r, o;
  let i = Vo((n = e == null ? void 0 : e.gap) != null ? n : "var(--anchor-gap, 0)", t), a = Vo((r = e == null ? void 0 : e.offset) != null ? r : "var(--anchor-offset, 0)", t), l = Vo((o = e == null ? void 0 : e.padding) != null ? o : "var(--anchor-padding, 0)", t);
  return { ...e, gap: i, offset: a, padding: l };
}
function Vo(e, t, n = void 0) {
  let r = gr(), o = te((s, u) => {
    if (s == null) return [n, null];
    if (typeof s == "number") return [s, null];
    if (typeof s == "string") {
      if (!u) return [n, null];
      let c = Ha(s, u);
      return [c, (f) => {
        let p = ju(s);
        {
          let d = p.map((g) => window.getComputedStyle(u).getPropertyValue(g));
          r.requestAnimationFrame(function g() {
            r.nextFrame(g);
            let h = !1;
            for (let [x, $] of p.entries()) {
              let w = window.getComputedStyle(u).getPropertyValue($);
              if (d[x] !== w) {
                d[x] = w, h = !0;
                break;
              }
            }
            if (!h) return;
            let v = Ha(s, u);
            c !== v && (f(v), c = v);
          });
        }
        return r.dispose;
      }];
    }
    return [n, null];
  }), i = re(() => o(e, t)[0], [e, t]), [a = i, l] = oe();
  return Se(() => {
    let [s, u] = o(e, t);
    if (l(s), !!u) return u(l);
  }, [e, t]), a;
}
function ju(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n = t[1].indexOf(",");
    if (n === -1) return [t[1]];
    let r = t[1].slice(0, n).trim(), o = t[1].slice(n + 1).trim();
    return o ? [r, ...ju(o)] : [r];
  }
  return [];
}
function Ha(e, t) {
  let n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), r;
}
function Hv({ children: e, freeze: t }) {
  let n = li(t, e);
  return A.createElement(A.Fragment, null, n);
}
function li(e, t) {
  let [n, r] = oe(t);
  return !e && n !== t && r(t), e ? n : t;
}
let Ti = xe(null);
Ti.displayName = "OpenClosedContext";
var fr = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(fr || {});
function Wv() {
  return be(Ti);
}
function zv({ value: e, children: t }) {
  return A.createElement(Ti.Provider, { value: e }, t);
}
function Uv(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let nn = [];
Uv(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || nn[0] === t.target) return;
    let n = t.target;
    n = n.closest(ri), nn.unshift(n ?? t.target), nn = nn.filter((r) => r != null && r.isConnected), nn.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function qv(e) {
  throw new Error("Unexpected object: " + e);
}
var Re = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Re || {});
function Wa(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(), o = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 1: {
      o === -1 && (o = n.length);
      for (let i = o - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 2: {
      for (let i = o + 1; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i) if (t.resolveId(n[i], i, n) === e.id) return i;
      return r;
    }
    case 5:
      return null;
    default:
      qv(e);
  }
}
var Ri = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(Ri || {});
function Yv(e) {
  let t = te(e), n = X(!1);
  ue(() => (n.current = !1, () => {
    n.current = !0, iu(() => {
      n.current && t();
    });
  }), [t]);
}
function Gv() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in j ? ((t) => t.useSyncExternalStore)(j)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Kv() {
  let e = Gv(), [t, n] = j.useState(ln.isHandoffComplete);
  return t && ln.isHandoffComplete === !1 && n(!1), j.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), j.useEffect(() => ln.handoff(), []), e ? !1 : t;
}
let Xv = xe(!1);
function Jv() {
  return be(Xv);
}
function Zv(e) {
  let t = Jv(), n = be(Vu), r = mo(e), [o, i] = oe(() => {
    var a;
    if (!t && n !== null) return (a = n.current) != null ? a : null;
    if (ln.isServer) return null;
    let l = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (l) return l;
    if (r === null) return null;
    let s = r.createElement("div");
    return s.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(s);
  });
  return ue(() => {
    o !== null && (r != null && r.body.contains(o) || r == null || r.body.appendChild(o));
  }, [o, r]), ue(() => {
    t || n !== null && i(n.current);
  }, [n, i, t]), o;
}
let ku = ut, Qv = mt(function(e, t) {
  let n = e, r = X(null), o = _t(Tp((f) => {
    r.current = f;
  }), t), i = mo(r), a = Zv(r), [l] = oe(() => {
    var f;
    return ln.isServer ? null : (f = i == null ? void 0 : i.createElement("div")) != null ? f : null;
  }), s = be(rh), u = Kv();
  Se(() => {
    !a || !l || a.contains(l) || (l.setAttribute("data-headlessui-portal", ""), a.appendChild(l));
  }, [a, l]), Se(() => {
    if (l && s) return s.register(l);
  }, [s, l]), Yv(() => {
    var f;
    !a || !l || (l instanceof Node && a.contains(l) && a.removeChild(l), a.childNodes.length <= 0 && ((f = a.parentElement) == null || f.removeChild(a)));
  });
  let c = pt();
  return u ? !a || !l ? null : il(c({ ourProps: { ref: o }, theirProps: n, slot: {}, defaultTag: ku, name: "Portal" }), l) : null;
});
function eh(e, t) {
  let n = _t(t), { enabled: r = !0, ...o } = e, i = pt();
  return r ? A.createElement(Qv, { ...o, ref: n }) : i({ ourProps: { ref: n }, theirProps: o, slot: {}, defaultTag: ku, name: "Portal" });
}
let th = ut, Vu = xe(null);
function nh(e, t) {
  let { target: n, ...r } = e, o = { ref: _t(t) }, i = pt();
  return A.createElement(Vu.Provider, { value: n }, i({ ourProps: o, theirProps: r, defaultTag: th, name: "Popover.Group" }));
}
let rh = xe(null), oh = mt(eh), ih = mt(nh), ah = Object.assign(oh, { Group: ih });
var lh = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(lh || {}), sh = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(sh || {}), uh = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(uh || {}), ch = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(ch || {});
function Bo(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), o = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((a, l) => a.dataRef.current.order - l.dataRef.current.order) : lm(r, (a) => a.dataRef.current.domRef.current), i = n ? o.indexOf(n) : null;
  return i === -1 && (i = null), { options: o, activeOptionIndex: i };
}
let fh = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0) return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1) return { ...e, activeOptionIndex: r, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, 3(e, t) {
  return e.isTyping === t.isTyping ? e : { ...e, isTyping: t.isTyping };
}, 2(e, t) {
  var n, r, o, i;
  if ((n = e.dataRef.current) != null && n.disabled || e.optionsElement && !((r = e.dataRef.current) != null && r.optionsPropsRef.current.static) && e.comboboxState === 1) return e;
  if (e.virtual) {
    let { options: u, disabled: c } = e.virtual, f = t.focus === Re.Specific ? t.idx : Wa(t, { resolveItems: () => u, resolveActiveIndex: () => {
      var d, g;
      return (g = (d = e.activeOptionIndex) != null ? d : u.findIndex((h) => !c(h))) != null ? g : null;
    }, resolveDisabled: c, resolveId() {
      throw new Error("Function not implemented.");
    } }), p = (o = t.trigger) != null ? o : 2;
    return e.activeOptionIndex === f && e.activationTrigger === p ? e : { ...e, activeOptionIndex: f, activationTrigger: p, isTyping: !1, __demoMode: !1 };
  }
  let a = Bo(e);
  if (a.activeOptionIndex === null) {
    let u = a.options.findIndex((c) => !c.dataRef.current.disabled);
    u !== -1 && (a.activeOptionIndex = u);
  }
  let l = t.focus === Re.Specific ? t.idx : Wa(t, { resolveItems: () => a.options, resolveActiveIndex: () => a.activeOptionIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled }), s = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === l && e.activationTrigger === s ? e : { ...e, ...a, isTyping: !1, activeOptionIndex: l, activationTrigger: s, __demoMode: !1 };
}, 4: (e, t) => {
  var n, r, o;
  if ((n = e.dataRef.current) != null && n.virtual) return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, a = Bo(e, (s) => (s.push(i), s));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(i));
  let l = { ...e, ...a, activationTrigger: 2 };
  return (o = e.dataRef.current) != null && o.__demoMode && e.dataRef.current.value === void 0 && (l.activeOptionIndex = 0), l;
}, 5: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual) return { ...e, options: e.options.filter((o) => o.id !== t.id) };
  let r = Bo(e, (o) => {
    let i = o.findIndex((a) => a.id === t.id);
    return i !== -1 && o.splice(i, 1), o;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n, r;
  if (e.virtual === null) return { ...e, virtual: { options: t.options, disabled: (n = t.disabled) != null ? n : () => !1 } };
  if (e.virtual.options === t.options && e.virtual.disabled === t.disabled) return e;
  let o = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let i = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    i !== -1 ? o = i : o = null;
  }
  return { ...e, activeOptionIndex: o, virtual: { options: t.options, disabled: (r = t.disabled) != null ? r : () => !1 } };
}, 8: (e, t) => e.inputElement === t.element ? e : { ...e, inputElement: t.element }, 9: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 10: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, Fi = xe(null);
Fi.displayName = "ComboboxActionsContext";
function wr(e) {
  let t = be(Fi);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, wr), n;
  }
  return t;
}
let Bu = xe(null);
function dh(e) {
  let t = _n("VirtualProvider"), { options: n } = t.virtual, [r, o] = re(() => {
    let u = t.optionsElement;
    if (!u) return [0, 0];
    let c = window.getComputedStyle(u);
    return [parseFloat(c.paddingBlockStart || c.paddingTop), parseFloat(c.paddingBlockEnd || c.paddingBottom)];
  }, [t.optionsElement]), i = Gp({ enabled: n.length !== 0, scrollPaddingStart: r, scrollPaddingEnd: o, count: n.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return t.optionsElement;
  }, overscan: 12 }), [a, l] = oe(0);
  Se(() => {
    l((u) => u + 1);
  }, [n]);
  let s = i.getVirtualItems();
  return s.length === 0 ? null : A.createElement(Bu.Provider, { value: i }, A.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (u) => {
    u && t.activationTrigger !== 0 && t.activeOptionIndex !== null && n.length > t.activeOptionIndex && i.scrollToIndex(t.activeOptionIndex);
  } }, s.map((u) => {
    var c;
    return A.createElement(ut, { key: u.key }, A.cloneElement((c = e.children) == null ? void 0 : c.call(e, { ...e.slot, option: n[u.index] }), { key: `${a}-${u.key}`, "data-index": u.index, "aria-setsize": n.length, "aria-posinset": u.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${u.start}px)`, overflowAnchor: "none" } }));
  })));
}
let dr = xe(null);
dr.displayName = "ComboboxDataContext";
function _n(e) {
  let t = be(dr);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, _n), n;
  }
  return t;
}
function ph(e, t) {
  return Dt(t.type, fh, e, t);
}
let mh = ut;
function vh(e, t) {
  var n, r;
  let o = gi(), { value: i, defaultValue: a, onChange: l, form: s, name: u, by: c, disabled: f = o || !1, onClose: p, __demoMode: d = !1, multiple: g = !1, immediate: h = !1, virtual: v = null, nullable: x, ...$ } = e, w = gp(a), [S = g ? [] : void 0, E] = bp(i, l, w), [L, T] = ol(ph, { dataRef: Mc(), comboboxState: d ? 0 : 1, isTyping: !1, options: [], virtual: v ? { options: v.options, disabled: (n = v.disabled) != null ? n : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: d }), _ = X(!1), W = X({ static: !1, hold: !1 }), P = Xp(c), D = te((R) => v ? c === null ? v.options.indexOf(R) : v.options.findIndex((ie) => P(ie, R)) : L.options.findIndex((ie) => P(ie.dataRef.current.value, R))), k = pe((R) => Dt(M.mode, { 1: () => S.some((ie) => P(ie, R)), 0: () => P(S, R) }), [S]), z = te((R) => L.activeOptionIndex === D(R)), M = re(() => ({ ...L, immediate: h, optionsPropsRef: W, value: S, defaultValue: w, disabled: f, mode: g ? 1 : 0, virtual: v ? L.virtual : null, get activeOptionIndex() {
    if (_.current && L.activeOptionIndex === null && (v ? v.options.length > 0 : L.options.length > 0)) {
      if (v) {
        let ie = v.options.findIndex((he) => {
          var Fe, it;
          return !((it = (Fe = v.disabled) == null ? void 0 : Fe.call(v, he)) != null && it);
        });
        if (ie !== -1) return ie;
      }
      let R = L.options.findIndex((ie) => !ie.dataRef.current.disabled);
      if (R !== -1) return R;
    }
    return L.activeOptionIndex;
  }, calculateIndex: D, compare: P, isSelected: k, isActive: z }), [S, w, f, g, d, L, v]);
  Se(() => {
    var R;
    v && T({ type: 7, options: v.options, disabled: (R = v.disabled) != null ? R : null });
  }, [v, v == null ? void 0 : v.options, v == null ? void 0 : v.disabled]), Se(() => {
    L.dataRef.current = M;
  }, [M]);
  let q = M.comboboxState === 0;
  cm(q, [M.buttonElement, M.inputElement, M.optionsElement], () => ee.closeCombobox());
  let U = re(() => {
    var R, ie, he;
    return { open: M.comboboxState === 0, disabled: f, activeIndex: M.activeOptionIndex, activeOption: M.activeOptionIndex === null ? null : M.virtual ? M.virtual.options[(R = M.activeOptionIndex) != null ? R : 0] : (he = (ie = M.options[M.activeOptionIndex]) == null ? void 0 : ie.dataRef.current.value) != null ? he : null, value: S };
  }, [M, f, S]), J = te(() => {
    if (M.activeOptionIndex !== null) {
      if (ee.setIsTyping(!1), M.virtual) N(M.virtual.options[M.activeOptionIndex]);
      else {
        let { dataRef: R } = M.options[M.activeOptionIndex];
        N(R.current.value);
      }
      ee.goToOption(Re.Specific, M.activeOptionIndex);
    }
  }), Y = te(() => {
    T({ type: 0 }), _.current = !0;
  }), G = te(() => {
    T({ type: 1 }), _.current = !1, p == null || p();
  }), Z = te((R) => {
    T({ type: 3, isTyping: R });
  }), Q = te((R, ie, he) => (_.current = !1, R === Re.Specific ? T({ type: 2, focus: Re.Specific, idx: ie, trigger: he }) : T({ type: 2, focus: R, trigger: he }))), B = te((R, ie) => (T({ type: 4, payload: { id: R, dataRef: ie } }), () => {
    M.isActive(ie.current.value) && (_.current = !0), T({ type: 5, id: R });
  })), N = te((R) => Dt(M.mode, { 0() {
    return E == null ? void 0 : E(R);
  }, 1() {
    let ie = M.value.slice(), he = ie.findIndex((Fe) => P(Fe, R));
    return he === -1 ? ie.push(R) : ie.splice(he, 1), E == null ? void 0 : E(ie);
  } })), ce = te((R) => {
    T({ type: 6, trigger: R });
  }), H = te((R) => {
    T({ type: 8, element: R });
  }), ge = te((R) => {
    T({ type: 9, element: R });
  }), fe = te((R) => {
    T({ type: 10, element: R });
  }), ee = re(() => ({ onChange: N, registerOption: B, goToOption: Q, setIsTyping: Z, closeCombobox: G, openCombobox: Y, setActivationTrigger: ce, selectActiveOption: J, setInputElement: H, setButtonElement: ge, setOptionsElement: fe }), []), [Oe, Ae] = Mp(), He = t === null ? {} : { ref: t }, We = pe(() => {
    if (w !== void 0) return E == null ? void 0 : E(w);
  }, [E, w]), _e = pt();
  return A.createElement(Ae, { value: Oe, props: { htmlFor: (r = M.inputElement) == null ? void 0 : r.id }, slot: { open: M.comboboxState === 0, disabled: f } }, A.createElement(kv, null, A.createElement(Fi.Provider, { value: ee }, A.createElement(dr.Provider, { value: M }, A.createElement(zv, { value: Dt(M.comboboxState, { 0: fr.Open, 1: fr.Closed }) }, u != null && A.createElement(Ep, { disabled: f, data: S != null ? { [u]: S } : {}, form: s, onReset: We }), _e({ ourProps: He, theirProps: $, slot: U, defaultTag: mh, name: "Combobox" }))))));
}
let hh = "input";
function bh(e, t) {
  var n, r, o, i, a;
  let l = _n("Combobox.Input"), s = wr("Combobox.Input"), u = Yt(), c = fu(), { id: f = c || `headlessui-combobox-input-${u}`, onChange: p, displayValue: d, disabled: g = l.disabled || !1, autoFocus: h = !1, type: v = "text", ...x } = e, $ = X(null), w = _t($, t, Nv(), s.setInputElement), S = mo(l.inputElement), E = gr(), L = te(() => {
    s.onChange(null), l.optionsElement && (l.optionsElement.scrollTop = 0), s.goToOption(Re.Nothing);
  }), T = re(() => {
    var N;
    return typeof d == "function" && l.value !== void 0 ? (N = d(l.value)) != null ? N : "" : typeof l.value == "string" ? l.value : "";
  }, [l.value, d]);
  Ra(([N, ce], [H, ge]) => {
    if (l.isTyping) return;
    let fe = $.current;
    fe && ((ge === 0 && ce === 1 || N !== H) && (fe.value = N), requestAnimationFrame(() => {
      if (l.isTyping || !fe || (S == null ? void 0 : S.activeElement) !== fe) return;
      let { selectionStart: ee, selectionEnd: Oe } = fe;
      Math.abs((Oe ?? 0) - (ee ?? 0)) === 0 && ee === 0 && fe.setSelectionRange(fe.value.length, fe.value.length);
    }));
  }, [T, l.comboboxState, S, l.isTyping]), Ra(([N], [ce]) => {
    if (N === 0 && ce === 1) {
      if (l.isTyping) return;
      let H = $.current;
      if (!H) return;
      let ge = H.value, { selectionStart: fe, selectionEnd: ee, selectionDirection: Oe } = H;
      H.value = "", H.value = ge, Oe !== null ? H.setSelectionRange(fe, ee, Oe) : H.setSelectionRange(fe, ee);
    }
  }, [l.comboboxState]);
  let _ = X(!1), W = te(() => {
    _.current = !0;
  }), P = te(() => {
    E.nextFrame(() => {
      _.current = !1;
    });
  }), D = te((N) => {
    switch (s.setIsTyping(!0), N.key) {
      case Ue.Enter:
        if (l.comboboxState !== 0 || _.current) return;
        if (N.preventDefault(), N.stopPropagation(), l.activeOptionIndex === null) {
          s.closeCombobox();
          return;
        }
        s.selectActiveOption(), l.mode === 0 && s.closeCombobox();
        break;
      case Ue.ArrowDown:
        return N.preventDefault(), N.stopPropagation(), Dt(l.comboboxState, { 0: () => s.goToOption(Re.Next), 1: () => s.openCombobox() });
      case Ue.ArrowUp:
        return N.preventDefault(), N.stopPropagation(), Dt(l.comboboxState, { 0: () => s.goToOption(Re.Previous), 1: () => {
          rn(() => s.openCombobox()), l.value || s.goToOption(Re.Last);
        } });
      case Ue.Home:
        if (N.shiftKey) break;
        return N.preventDefault(), N.stopPropagation(), s.goToOption(Re.First);
      case Ue.PageUp:
        return N.preventDefault(), N.stopPropagation(), s.goToOption(Re.First);
      case Ue.End:
        if (N.shiftKey) break;
        return N.preventDefault(), N.stopPropagation(), s.goToOption(Re.Last);
      case Ue.PageDown:
        return N.preventDefault(), N.stopPropagation(), s.goToOption(Re.Last);
      case Ue.Escape:
        return l.comboboxState !== 0 ? void 0 : (N.preventDefault(), l.optionsElement && !l.optionsPropsRef.current.static && N.stopPropagation(), l.mode === 0 && l.value === null && L(), s.closeCombobox());
      case Ue.Tab:
        if (l.comboboxState !== 0) return;
        l.mode === 0 && l.activationTrigger !== 1 && s.selectActiveOption(), s.closeCombobox();
        break;
    }
  }), k = te((N) => {
    p == null || p(N), l.mode === 0 && N.target.value === "" && L(), s.openCombobox();
  }), z = te((N) => {
    var ce, H, ge;
    let fe = (ce = N.relatedTarget) != null ? ce : nn.find((ee) => ee !== N.currentTarget);
    if (!((H = l.optionsElement) != null && H.contains(fe)) && !((ge = l.buttonElement) != null && ge.contains(fe)) && l.comboboxState === 0) return N.preventDefault(), l.mode === 0 && l.value === null && L(), s.closeCombobox();
  }), M = te((N) => {
    var ce, H, ge;
    let fe = (ce = N.relatedTarget) != null ? ce : nn.find((ee) => ee !== N.currentTarget);
    (H = l.buttonElement) != null && H.contains(fe) || (ge = l.optionsElement) != null && ge.contains(fe) || l.disabled || l.immediate && l.comboboxState !== 0 && E.microTask(() => {
      rn(() => s.openCombobox()), s.setActivationTrigger(1);
    });
  }), q = po(), U = Rp(), { isFocused: J, focusProps: Y } = co({ autoFocus: h }), { isHovered: G, hoverProps: Z } = so({ isDisabled: g }), Q = re(() => ({ open: l.comboboxState === 0, disabled: g, hover: G, focus: J, autofocus: h }), [l, G, J, h, g]), B = yi({ ref: w, id: f, role: "combobox", type: v, "aria-controls": (n = l.optionsElement) == null ? void 0 : n.id, "aria-expanded": l.comboboxState === 0, "aria-activedescendant": l.activeOptionIndex === null ? void 0 : l.virtual ? (r = l.options.find((N) => !N.dataRef.current.disabled && l.compare(N.dataRef.current.value, l.virtual.options[l.activeOptionIndex]))) == null ? void 0 : r.id : (o = l.options[l.activeOptionIndex]) == null ? void 0 : o.id, "aria-labelledby": q, "aria-describedby": U, "aria-autocomplete": "list", defaultValue: (a = (i = e.defaultValue) != null ? i : l.defaultValue !== void 0 ? d == null ? void 0 : d(l.defaultValue) : null) != null ? a : l.defaultValue, disabled: g || void 0, autoFocus: h, onCompositionStart: W, onCompositionEnd: P, onKeyDown: D, onChange: k, onFocus: M, onBlur: z }, Y, Z);
  return pt()({ ourProps: B, theirProps: x, slot: Q, defaultTag: hh, name: "Combobox.Input" });
}
let gh = "button";
function yh(e, t) {
  var n;
  let r = _n("Combobox.Button"), o = wr("Combobox.Button"), i = _t(t, o.setButtonElement), a = Yt(), { id: l = `headlessui-combobox-button-${a}`, disabled: s = r.disabled || !1, autoFocus: u = !1, ...c } = e, f = wu(r.inputElement), p = te((T) => {
    switch (T.key) {
      case Ue.Space:
      case Ue.Enter:
        T.preventDefault(), T.stopPropagation(), r.comboboxState === 1 && rn(() => o.openCombobox()), f();
        return;
      case Ue.ArrowDown:
        T.preventDefault(), T.stopPropagation(), r.comboboxState === 1 && (rn(() => o.openCombobox()), r.value || o.goToOption(Re.First)), f();
        return;
      case Ue.ArrowUp:
        T.preventDefault(), T.stopPropagation(), r.comboboxState === 1 && (rn(() => o.openCombobox()), r.value || o.goToOption(Re.Last)), f();
        return;
      case Ue.Escape:
        if (r.comboboxState !== 0) return;
        T.preventDefault(), r.optionsElement && !r.optionsPropsRef.current.static && T.stopPropagation(), rn(() => o.closeCombobox()), f();
        return;
      default:
        return;
    }
  }), d = te((T) => {
    T.preventDefault(), !Pp(T.currentTarget) && (T.button === Ri.Left && (r.comboboxState === 0 ? o.closeCombobox() : o.openCombobox()), f());
  }), g = po([l]), { isFocusVisible: h, focusProps: v } = co({ autoFocus: u }), { isHovered: x, hoverProps: $ } = so({ isDisabled: s }), { pressed: w, pressProps: S } = cp({ disabled: s }), E = re(() => ({ open: r.comboboxState === 0, active: w || r.comboboxState === 0, disabled: s, value: r.value, hover: x, focus: h }), [r, x, h, w, s]), L = yi({ ref: i, id: l, type: dm(e, r.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsElement) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": g, disabled: s || void 0, autoFocus: u, onMouseDown: d, onKeyDown: p }, v, $, S);
  return pt()({ ourProps: L, theirProps: c, slot: E, defaultTag: gh, name: "Combobox.Button" });
}
let xh = "div", $h = ti.RenderStrategy | ti.Static;
function wh(e, t) {
  var n, r, o;
  let i = Yt(), { id: a = `headlessui-combobox-options-${i}`, hold: l = !1, anchor: s, portal: u = !1, modal: c = !0, transition: f = !1, ...p } = e, d = _n("Combobox.Options"), g = wr("Combobox.Options"), h = _v(s);
  h && (u = !0);
  let [v, x] = jv(h), [$, w] = oe(null), S = Iv(), E = _t(t, h ? v : null, g.setOptionsElement, w), L = mo(d.optionsElement), T = Wv(), [_, W] = Em(f, $, T !== null ? (T & fr.Open) === fr.Open : d.comboboxState === 0);
  tm(_, d.inputElement, g.closeCombobox);
  let P = d.__demoMode ? !1 : c && d.comboboxState === 0;
  gm(P, L);
  let D = d.__demoMode ? !1 : c && d.comboboxState === 0;
  em(D, { allowed: pe(() => [d.inputElement, d.buttonElement, d.optionsElement], [d.inputElement, d.buttonElement, d.optionsElement]) }), Se(() => {
    var B;
    d.optionsPropsRef.current.static = (B = e.static) != null ? B : !1;
  }, [d.optionsPropsRef, e.static]), Se(() => {
    d.optionsPropsRef.current.hold = l;
  }, [d.optionsPropsRef, l]), Om(d.comboboxState === 0, { container: d.optionsElement, accept(B) {
    return B.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : B.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(B) {
    B.setAttribute("role", "none");
  } });
  let k = po([(n = d.buttonElement) == null ? void 0 : n.id]), z = re(() => ({ open: d.comboboxState === 0, option: void 0 }), [d.comboboxState]), M = te(() => {
    g.setActivationTrigger(0);
  }), q = te((B) => {
    B.preventDefault(), g.setActivationTrigger(0);
  }), U = yi(h ? S() : {}, { "aria-labelledby": k, role: "listbox", "aria-multiselectable": d.mode === 1 ? !0 : void 0, id: a, ref: E, style: { ...p.style, ...x, "--input-width": wa(d.inputElement, !0).width, "--button-width": wa(d.buttonElement, !0).width }, onWheel: d.activationTrigger === 0 ? void 0 : M, onMouseDown: q, ...wm(W) }), J = _ && d.comboboxState === 1, Y = li(J, (r = d.virtual) == null ? void 0 : r.options), G = li(J, d.value), Z = te((B) => d.compare(G, B));
  if (d.virtual) {
    if (Y === void 0) throw new Error("Missing `options` in virtual mode");
    Object.assign(p, { children: A.createElement(dr.Provider, { value: Y !== d.virtual.options ? { ...d, virtual: { ...d.virtual, options: Y } } : d }, A.createElement(dh, { slot: z }, p.children)) });
  }
  let Q = pt();
  return A.createElement(ah, { enabled: u ? e.static || _ : !1 }, A.createElement(dr.Provider, { value: d.mode === 1 ? d : { ...d, isSelected: Z } }, Q({ ourProps: U, theirProps: { ...p, children: A.createElement(Hv, { freeze: J }, typeof p.children == "function" ? (o = p.children) == null ? void 0 : o.call(p, z) : p.children) }, slot: z, defaultTag: xh, features: $h, visible: _, name: "Combobox.Options" })));
}
let Eh = "div";
function Sh(e, t) {
  var n, r, o, i;
  let a = _n("Combobox.Option"), l = wr("Combobox.Option"), s = Yt(), { id: u = `headlessui-combobox-option-${s}`, value: c, disabled: f = (o = (r = (n = a.virtual) == null ? void 0 : n.disabled) == null ? void 0 : r.call(n, c)) != null ? o : !1, order: p = null, ...d } = e, g = wu(a.inputElement), h = a.virtual ? a.activeOptionIndex === a.calculateIndex(c) : a.activeOptionIndex === null ? !1 : ((i = a.options[a.activeOptionIndex]) == null ? void 0 : i.id) === u, v = a.isSelected(c), x = X(null), $ = vn({ disabled: f, value: c, domRef: x, order: p }), w = be(Bu), S = _t(t, x, w ? w.measureElement : null), E = te(() => {
    l.setIsTyping(!1), l.onChange(c);
  });
  Se(() => l.registerOption(u, $), [$, u]);
  let L = X(!(a.virtual || a.__demoMode));
  Se(() => {
    if (!a.virtual && !a.__demoMode) return Et().requestAnimationFrame(() => {
      L.current = !0;
    });
  }, [a.virtual, a.__demoMode]), Se(() => {
    if (L.current && a.comboboxState === 0 && h && a.activationTrigger !== 0) return Et().requestAnimationFrame(() => {
      var q, U;
      (U = (q = x.current) == null ? void 0 : q.scrollIntoView) == null || U.call(q, { block: "nearest" });
    });
  }, [x, h, a.comboboxState, a.activationTrigger, a.activeOptionIndex]);
  let T = te((q) => {
    q.preventDefault(), q.button === Ri.Left && (f || (E(), $u() || requestAnimationFrame(() => g()), a.mode === 0 && l.closeCombobox()));
  }), _ = te(() => {
    if (f) return l.goToOption(Re.Nothing);
    let q = a.calculateIndex(c);
    l.goToOption(Re.Specific, q);
  }), W = ym(), P = te((q) => W.update(q)), D = te((q) => {
    if (!W.wasMoved(q) || f || h) return;
    let U = a.calculateIndex(c);
    l.goToOption(Re.Specific, U, 0);
  }), k = te((q) => {
    W.wasMoved(q) && (f || h && (a.optionsPropsRef.current.hold || l.goToOption(Re.Nothing)));
  }), z = re(() => ({ active: h, focus: h, selected: v, disabled: f }), [h, v, f]), M = { id: u, ref: S, role: "option", tabIndex: f === !0 ? void 0 : -1, "aria-disabled": f === !0 ? !0 : void 0, "aria-selected": v, disabled: void 0, onMouseDown: T, onFocus: _, onPointerEnter: P, onMouseEnter: P, onPointerMove: D, onMouseMove: D, onPointerLeave: k, onMouseLeave: k };
  return pt()({ ourProps: M, theirProps: d, slot: z, defaultTag: Eh, name: "Combobox.Option" });
}
let Ch = mt(vh), si = mt(yh), Hu = mt(bh), Ph = vu, Wu = mt(wh), zu = mt(Sh), Oh = Object.assign(Ch, { Input: Hu, Button: si, Label: Ph, Options: Wu, Option: zu });
var Qn = { exports: {} };
Qn.exports;
var za;
function Th() {
  return za || (za = 1, function(e, t) {
    var n = 200, r = "__lodash_hash_undefined__", o = 1, i = 2, a = 9007199254740991, l = "[object Arguments]", s = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", f = "[object Date]", p = "[object Error]", d = "[object Function]", g = "[object GeneratorFunction]", h = "[object Map]", v = "[object Number]", x = "[object Null]", $ = "[object Object]", w = "[object Promise]", S = "[object Proxy]", E = "[object RegExp]", L = "[object Set]", T = "[object String]", _ = "[object Symbol]", W = "[object Undefined]", P = "[object WeakMap]", D = "[object ArrayBuffer]", k = "[object DataView]", z = "[object Float32Array]", M = "[object Float64Array]", q = "[object Int8Array]", U = "[object Int16Array]", J = "[object Int32Array]", Y = "[object Uint8Array]", G = "[object Uint8ClampedArray]", Z = "[object Uint16Array]", Q = "[object Uint32Array]", B = /[\\^$.*+?()[\]{}|]/g, N = /^\[object .+?Constructor\]$/, ce = /^(?:0|[1-9]\d*)$/, H = {};
    H[z] = H[M] = H[q] = H[U] = H[J] = H[Y] = H[G] = H[Z] = H[Q] = !0, H[l] = H[s] = H[D] = H[c] = H[k] = H[f] = H[p] = H[d] = H[h] = H[v] = H[$] = H[E] = H[L] = H[T] = H[P] = !1;
    var ge = typeof Nr == "object" && Nr && Nr.Object === Object && Nr, fe = typeof self == "object" && self && self.Object === Object && self, ee = ge || fe || Function("return this")(), Oe = t && !t.nodeType && t, Ae = Oe && !0 && e && !e.nodeType && e, He = Ae && Ae.exports === Oe, We = He && ge.process, _e = function() {
      try {
        return We && We.binding && We.binding("util");
      } catch {
      }
    }(), R = _e && _e.isTypedArray;
    function ie(m, y) {
      for (var O = -1, V = m == null ? 0 : m.length, $e = 0, ne = []; ++O < V; ) {
        var Pe = m[O];
        y(Pe, O, m) && (ne[$e++] = Pe);
      }
      return ne;
    }
    function he(m, y) {
      for (var O = -1, V = y.length, $e = m.length; ++O < V; )
        m[$e + O] = y[O];
      return m;
    }
    function Fe(m, y) {
      for (var O = -1, V = m == null ? 0 : m.length; ++O < V; )
        if (y(m[O], O, m))
          return !0;
      return !1;
    }
    function it(m, y) {
      for (var O = -1, V = Array(m); ++O < m; )
        V[O] = y(O);
      return V;
    }
    function vt(m) {
      return function(y) {
        return m(y);
      };
    }
    function qe(m, y) {
      return m.has(y);
    }
    function ht(m, y) {
      return m == null ? void 0 : m[y];
    }
    function bt(m) {
      var y = -1, O = Array(m.size);
      return m.forEach(function(V, $e) {
        O[++y] = [$e, V];
      }), O;
    }
    function Nt(m, y) {
      return function(O) {
        return m(y(O));
      };
    }
    function gt(m) {
      var y = -1, O = Array(m.size);
      return m.forEach(function(V) {
        O[++y] = V;
      }), O;
    }
    var yt = Array.prototype, at = Function.prototype, Le = Object.prototype, lt = ee["__core-js_shared__"], It = at.toString, ze = Le.hasOwnProperty, hn = function() {
      var m = /[^.]+$/.exec(lt && lt.keys && lt.keys.IE_PROTO || "");
      return m ? "Symbol(src)_1." + m : "";
    }(), De = Le.toString, Jt = RegExp(
      "^" + It.call(ze).replace(B, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Cr = He ? ee.Buffer : void 0, bn = ee.Symbol, Pr = ee.Uint8Array, Or = Le.propertyIsEnumerable, Nn = yt.splice, xt = bn ? bn.toStringTag : void 0, Ot = Object.getOwnPropertySymbols, In = Cr ? Cr.isBuffer : void 0, jn = Nt(Object.keys, Object), gn = wn(ee, "DataView"), Zt = wn(ee, "Map"), yn = wn(ee, "Promise"), kn = wn(ee, "Set"), xn = wn(ee, "WeakMap"), jt = wn(Object, "create"), xo = Qt(gn), $o = Qt(Zt), Tr = Qt(yn), Rr = Qt(kn), wo = Qt(xn), Fr = bn ? bn.prototype : void 0, Vn = Fr ? Fr.valueOf : void 0;
    function Tt(m) {
      var y = -1, O = m == null ? 0 : m.length;
      for (this.clear(); ++y < O; ) {
        var V = m[y];
        this.set(V[0], V[1]);
      }
    }
    function b() {
      this.__data__ = jt ? jt(null) : {}, this.size = 0;
    }
    function F(m) {
      var y = this.has(m) && delete this.__data__[m];
      return this.size -= y ? 1 : 0, y;
    }
    function I(m) {
      var y = this.__data__;
      if (jt) {
        var O = y[m];
        return O === r ? void 0 : O;
      }
      return ze.call(y, m) ? y[m] : void 0;
    }
    function K(m) {
      var y = this.__data__;
      return jt ? y[m] !== void 0 : ze.call(y, m);
    }
    function de(m, y) {
      var O = this.__data__;
      return this.size += this.has(m) ? 0 : 1, O[m] = jt && y === void 0 ? r : y, this;
    }
    Tt.prototype.clear = b, Tt.prototype.delete = F, Tt.prototype.get = I, Tt.prototype.has = K, Tt.prototype.set = de;
    function le(m) {
      var y = -1, O = m == null ? 0 : m.length;
      for (this.clear(); ++y < O; ) {
        var V = m[y];
        this.set(V[0], V[1]);
      }
    }
    function se() {
      this.__data__ = [], this.size = 0;
    }
    function ae(m) {
      var y = this.__data__, O = Lr(y, m);
      if (O < 0)
        return !1;
      var V = y.length - 1;
      return O == V ? y.pop() : Nn.call(y, O, 1), --this.size, !0;
    }
    function Ne(m) {
      var y = this.__data__, O = Lr(y, m);
      return O < 0 ? void 0 : y[O][1];
    }
    function we(m) {
      return Lr(this.__data__, m) > -1;
    }
    function Ce(m, y) {
      var O = this.__data__, V = Lr(O, m);
      return V < 0 ? (++this.size, O.push([m, y])) : O[V][1] = y, this;
    }
    le.prototype.clear = se, le.prototype.delete = ae, le.prototype.get = Ne, le.prototype.has = we, le.prototype.set = Ce;
    function Te(m) {
      var y = -1, O = m == null ? 0 : m.length;
      for (this.clear(); ++y < O; ) {
        var V = m[y];
        this.set(V[0], V[1]);
      }
    }
    function kt() {
      this.size = 0, this.__data__ = {
        hash: new Tt(),
        map: new (Zt || le)(),
        string: new Tt()
      };
    }
    function Rt(m) {
      var y = Dr(this, m).delete(m);
      return this.size -= y ? 1 : 0, y;
    }
    function je(m) {
      return Dr(this, m).get(m);
    }
    function Bn(m) {
      return Dr(this, m).has(m);
    }
    function Eo(m, y) {
      var O = Dr(this, m), V = O.size;
      return O.set(m, y), this.size += O.size == V ? 0 : 1, this;
    }
    Te.prototype.clear = kt, Te.prototype.delete = Rt, Te.prototype.get = je, Te.prototype.has = Bn, Te.prototype.set = Eo;
    function $n(m) {
      var y = -1, O = m == null ? 0 : m.length;
      for (this.__data__ = new Te(); ++y < O; )
        this.add(m[y]);
    }
    function ec(m) {
      return this.__data__.set(m, r), this;
    }
    function tc(m) {
      return this.__data__.has(m);
    }
    $n.prototype.add = $n.prototype.push = ec, $n.prototype.has = tc;
    function Vt(m) {
      var y = this.__data__ = new le(m);
      this.size = y.size;
    }
    function nc() {
      this.__data__ = new le(), this.size = 0;
    }
    function rc(m) {
      var y = this.__data__, O = y.delete(m);
      return this.size = y.size, O;
    }
    function oc(m) {
      return this.__data__.get(m);
    }
    function ic(m) {
      return this.__data__.has(m);
    }
    function ac(m, y) {
      var O = this.__data__;
      if (O instanceof le) {
        var V = O.__data__;
        if (!Zt || V.length < n - 1)
          return V.push([m, y]), this.size = ++O.size, this;
        O = this.__data__ = new Te(V);
      }
      return O.set(m, y), this.size = O.size, this;
    }
    Vt.prototype.clear = nc, Vt.prototype.delete = rc, Vt.prototype.get = oc, Vt.prototype.has = ic, Vt.prototype.set = ac;
    function lc(m, y) {
      var O = Mr(m), V = !O && wc(m), $e = !O && !V && So(m), ne = !O && !V && !$e && qi(m), Pe = O || V || $e || ne, Me = Pe ? it(m.length, String) : [], Ie = Me.length;
      for (var Ee in m)
        ze.call(m, Ee) && !(Pe && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ee == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        $e && (Ee == "offset" || Ee == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        ne && (Ee == "buffer" || Ee == "byteLength" || Ee == "byteOffset") || // Skip index properties.
        bc(Ee, Ie))) && Me.push(Ee);
      return Me;
    }
    function Lr(m, y) {
      for (var O = m.length; O--; )
        if (Hi(m[O][0], y))
          return O;
      return -1;
    }
    function sc(m, y, O) {
      var V = y(m);
      return Mr(m) ? V : he(V, O(m));
    }
    function Hn(m) {
      return m == null ? m === void 0 ? W : x : xt && xt in Object(m) ? vc(m) : $c(m);
    }
    function ji(m) {
      return Wn(m) && Hn(m) == l;
    }
    function ki(m, y, O, V, $e) {
      return m === y ? !0 : m == null || y == null || !Wn(m) && !Wn(y) ? m !== m && y !== y : uc(m, y, O, V, ki, $e);
    }
    function uc(m, y, O, V, $e, ne) {
      var Pe = Mr(m), Me = Mr(y), Ie = Pe ? s : Bt(m), Ee = Me ? s : Bt(y);
      Ie = Ie == l ? $ : Ie, Ee = Ee == l ? $ : Ee;
      var Ke = Ie == $, st = Ee == $, ke = Ie == Ee;
      if (ke && So(m)) {
        if (!So(y))
          return !1;
        Pe = !0, Ke = !1;
      }
      if (ke && !Ke)
        return ne || (ne = new Vt()), Pe || qi(m) ? Vi(m, y, O, V, $e, ne) : pc(m, y, Ie, O, V, $e, ne);
      if (!(O & o)) {
        var Ze = Ke && ze.call(m, "__wrapped__"), Qe = st && ze.call(y, "__wrapped__");
        if (Ze || Qe) {
          var Ht = Ze ? m.value() : m, Ft = Qe ? y.value() : y;
          return ne || (ne = new Vt()), $e(Ht, Ft, O, V, ne);
        }
      }
      return ke ? (ne || (ne = new Vt()), mc(m, y, O, V, $e, ne)) : !1;
    }
    function cc(m) {
      if (!Ui(m) || yc(m))
        return !1;
      var y = Wi(m) ? Jt : N;
      return y.test(Qt(m));
    }
    function fc(m) {
      return Wn(m) && zi(m.length) && !!H[Hn(m)];
    }
    function dc(m) {
      if (!xc(m))
        return jn(m);
      var y = [];
      for (var O in Object(m))
        ze.call(m, O) && O != "constructor" && y.push(O);
      return y;
    }
    function Vi(m, y, O, V, $e, ne) {
      var Pe = O & o, Me = m.length, Ie = y.length;
      if (Me != Ie && !(Pe && Ie > Me))
        return !1;
      var Ee = ne.get(m);
      if (Ee && ne.get(y))
        return Ee == y;
      var Ke = -1, st = !0, ke = O & i ? new $n() : void 0;
      for (ne.set(m, y), ne.set(y, m); ++Ke < Me; ) {
        var Ze = m[Ke], Qe = y[Ke];
        if (V)
          var Ht = Pe ? V(Qe, Ze, Ke, y, m, ne) : V(Ze, Qe, Ke, m, y, ne);
        if (Ht !== void 0) {
          if (Ht)
            continue;
          st = !1;
          break;
        }
        if (ke) {
          if (!Fe(y, function(Ft, en) {
            if (!qe(ke, en) && (Ze === Ft || $e(Ze, Ft, O, V, ne)))
              return ke.push(en);
          })) {
            st = !1;
            break;
          }
        } else if (!(Ze === Qe || $e(Ze, Qe, O, V, ne))) {
          st = !1;
          break;
        }
      }
      return ne.delete(m), ne.delete(y), st;
    }
    function pc(m, y, O, V, $e, ne, Pe) {
      switch (O) {
        case k:
          if (m.byteLength != y.byteLength || m.byteOffset != y.byteOffset)
            return !1;
          m = m.buffer, y = y.buffer;
        case D:
          return !(m.byteLength != y.byteLength || !ne(new Pr(m), new Pr(y)));
        case c:
        case f:
        case v:
          return Hi(+m, +y);
        case p:
          return m.name == y.name && m.message == y.message;
        case E:
        case T:
          return m == y + "";
        case h:
          var Me = bt;
        case L:
          var Ie = V & o;
          if (Me || (Me = gt), m.size != y.size && !Ie)
            return !1;
          var Ee = Pe.get(m);
          if (Ee)
            return Ee == y;
          V |= i, Pe.set(m, y);
          var Ke = Vi(Me(m), Me(y), V, $e, ne, Pe);
          return Pe.delete(m), Ke;
        case _:
          if (Vn)
            return Vn.call(m) == Vn.call(y);
      }
      return !1;
    }
    function mc(m, y, O, V, $e, ne) {
      var Pe = O & o, Me = Bi(m), Ie = Me.length, Ee = Bi(y), Ke = Ee.length;
      if (Ie != Ke && !Pe)
        return !1;
      for (var st = Ie; st--; ) {
        var ke = Me[st];
        if (!(Pe ? ke in y : ze.call(y, ke)))
          return !1;
      }
      var Ze = ne.get(m);
      if (Ze && ne.get(y))
        return Ze == y;
      var Qe = !0;
      ne.set(m, y), ne.set(y, m);
      for (var Ht = Pe; ++st < Ie; ) {
        ke = Me[st];
        var Ft = m[ke], en = y[ke];
        if (V)
          var Yi = Pe ? V(en, Ft, ke, y, m, ne) : V(Ft, en, ke, m, y, ne);
        if (!(Yi === void 0 ? Ft === en || $e(Ft, en, O, V, ne) : Yi)) {
          Qe = !1;
          break;
        }
        Ht || (Ht = ke == "constructor");
      }
      if (Qe && !Ht) {
        var Ar = m.constructor, _r = y.constructor;
        Ar != _r && "constructor" in m && "constructor" in y && !(typeof Ar == "function" && Ar instanceof Ar && typeof _r == "function" && _r instanceof _r) && (Qe = !1);
      }
      return ne.delete(m), ne.delete(y), Qe;
    }
    function Bi(m) {
      return sc(m, Cc, hc);
    }
    function Dr(m, y) {
      var O = m.__data__;
      return gc(y) ? O[typeof y == "string" ? "string" : "hash"] : O.map;
    }
    function wn(m, y) {
      var O = ht(m, y);
      return cc(O) ? O : void 0;
    }
    function vc(m) {
      var y = ze.call(m, xt), O = m[xt];
      try {
        m[xt] = void 0;
        var V = !0;
      } catch {
      }
      var $e = De.call(m);
      return V && (y ? m[xt] = O : delete m[xt]), $e;
    }
    var hc = Ot ? function(m) {
      return m == null ? [] : (m = Object(m), ie(Ot(m), function(y) {
        return Or.call(m, y);
      }));
    } : Pc, Bt = Hn;
    (gn && Bt(new gn(new ArrayBuffer(1))) != k || Zt && Bt(new Zt()) != h || yn && Bt(yn.resolve()) != w || kn && Bt(new kn()) != L || xn && Bt(new xn()) != P) && (Bt = function(m) {
      var y = Hn(m), O = y == $ ? m.constructor : void 0, V = O ? Qt(O) : "";
      if (V)
        switch (V) {
          case xo:
            return k;
          case $o:
            return h;
          case Tr:
            return w;
          case Rr:
            return L;
          case wo:
            return P;
        }
      return y;
    });
    function bc(m, y) {
      return y = y ?? a, !!y && (typeof m == "number" || ce.test(m)) && m > -1 && m % 1 == 0 && m < y;
    }
    function gc(m) {
      var y = typeof m;
      return y == "string" || y == "number" || y == "symbol" || y == "boolean" ? m !== "__proto__" : m === null;
    }
    function yc(m) {
      return !!hn && hn in m;
    }
    function xc(m) {
      var y = m && m.constructor, O = typeof y == "function" && y.prototype || Le;
      return m === O;
    }
    function $c(m) {
      return De.call(m);
    }
    function Qt(m) {
      if (m != null) {
        try {
          return It.call(m);
        } catch {
        }
        try {
          return m + "";
        } catch {
        }
      }
      return "";
    }
    function Hi(m, y) {
      return m === y || m !== m && y !== y;
    }
    var wc = ji(/* @__PURE__ */ function() {
      return arguments;
    }()) ? ji : function(m) {
      return Wn(m) && ze.call(m, "callee") && !Or.call(m, "callee");
    }, Mr = Array.isArray;
    function Ec(m) {
      return m != null && zi(m.length) && !Wi(m);
    }
    var So = In || Oc;
    function Sc(m, y) {
      return ki(m, y);
    }
    function Wi(m) {
      if (!Ui(m))
        return !1;
      var y = Hn(m);
      return y == d || y == g || y == u || y == S;
    }
    function zi(m) {
      return typeof m == "number" && m > -1 && m % 1 == 0 && m <= a;
    }
    function Ui(m) {
      var y = typeof m;
      return m != null && (y == "object" || y == "function");
    }
    function Wn(m) {
      return m != null && typeof m == "object";
    }
    var qi = R ? vt(R) : fc;
    function Cc(m) {
      return Ec(m) ? lc(m) : dc(m);
    }
    function Pc() {
      return [];
    }
    function Oc() {
      return !1;
    }
    e.exports = Sc;
  }(Qn, Qn.exports)), Qn.exports;
}
var Rh = Th();
const Fh = /* @__PURE__ */ no(Rh);
var Ua = function(t) {
  return t.reduce(function(n, r) {
    var o = r[0], i = r[1];
    return n[o] = i, n;
  }, {});
}, qa = typeof window < "u" && window.document && window.document.createElement ? j.useLayoutEffect : j.useEffect, Ye = "top", rt = "bottom", ot = "right", Ge = "left", Li = "auto", Er = [Ye, rt, ot, Ge], Rn = "start", pr = "end", Lh = "clippingParents", Uu = "viewport", Kn = "popper", Dh = "reference", Ya = /* @__PURE__ */ Er.reduce(function(e, t) {
  return e.concat([t + "-" + Rn, t + "-" + pr]);
}, []), qu = /* @__PURE__ */ [].concat(Er, [Li]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Rn, t + "-" + pr]);
}, []), Mh = "beforeRead", Ah = "read", _h = "afterRead", Nh = "beforeMain", Ih = "main", jh = "afterMain", kh = "beforeWrite", Vh = "write", Bh = "afterWrite", Hh = [Mh, Ah, _h, Nh, Ih, jh, kh, Vh, Bh];
function Ct(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Je(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function pn(e) {
  var t = Je(e).Element;
  return e instanceof t || e instanceof Element;
}
function nt(e) {
  var t = Je(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Di(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Je(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Wh(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !nt(i) || !Ct(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function zh(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(s, u) {
        return s[u] = "", s;
      }, {});
      !nt(o) || !Ct(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const Uh = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Wh,
  effect: zh,
  requires: ["computeStyles"]
};
function wt(e) {
  return e.split("-")[0];
}
var sn = Math.max, to = Math.min, Fn = Math.round;
function ui() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Yu() {
  return !/^((?!chrome|android).)*safari/i.test(ui());
}
function Ln(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && nt(e) && (o = e.offsetWidth > 0 && Fn(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Fn(r.height) / e.offsetHeight || 1);
  var a = pn(e) ? Je(e) : window, l = a.visualViewport, s = !Yu() && n, u = (r.left + (s && l ? l.offsetLeft : 0)) / o, c = (r.top + (s && l ? l.offsetTop : 0)) / i, f = r.width / o, p = r.height / i;
  return {
    width: f,
    height: p,
    top: c,
    right: u + f,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function Mi(e) {
  var t = Ln(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Gu(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Di(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Mt(e) {
  return Je(e).getComputedStyle(e);
}
function qh(e) {
  return ["table", "td", "th"].indexOf(Ct(e)) >= 0;
}
function Xt(e) {
  return ((pn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function yo(e) {
  return Ct(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Di(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xt(e)
  );
}
function Ga(e) {
  return !nt(e) || // https://github.com/popperjs/popper-core/issues/837
  Mt(e).position === "fixed" ? null : e.offsetParent;
}
function Yh(e) {
  var t = /firefox/i.test(ui()), n = /Trident/i.test(ui());
  if (n && nt(e)) {
    var r = Mt(e);
    if (r.position === "fixed")
      return null;
  }
  var o = yo(e);
  for (Di(o) && (o = o.host); nt(o) && ["html", "body"].indexOf(Ct(o)) < 0; ) {
    var i = Mt(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Sr(e) {
  for (var t = Je(e), n = Ga(e); n && qh(n) && Mt(n).position === "static"; )
    n = Ga(n);
  return n && (Ct(n) === "html" || Ct(n) === "body" && Mt(n).position === "static") ? t : n || Yh(e) || t;
}
function Ai(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function rr(e, t, n) {
  return sn(e, to(t, n));
}
function Gh(e, t, n) {
  var r = rr(e, t, n);
  return r > n ? n : r;
}
function Ku() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Xu(e) {
  return Object.assign({}, Ku(), e);
}
function Ju(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Kh = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Xu(typeof t != "number" ? t : Ju(t, Er));
};
function Xh(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, l = wt(n.placement), s = Ai(l), u = [Ge, ot].indexOf(l) >= 0, c = u ? "height" : "width";
  if (!(!i || !a)) {
    var f = Kh(o.padding, n), p = Mi(i), d = s === "y" ? Ye : Ge, g = s === "y" ? rt : ot, h = n.rects.reference[c] + n.rects.reference[s] - a[s] - n.rects.popper[c], v = a[s] - n.rects.reference[s], x = Sr(i), $ = x ? s === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, w = h / 2 - v / 2, S = f[d], E = $ - p[c] - f[g], L = $ / 2 - p[c] / 2 + w, T = rr(S, L, E), _ = s;
    n.modifiersData[r] = (t = {}, t[_] = T, t.centerOffset = T - L, t);
  }
}
function Jh(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Gu(t.elements.popper, o) && (t.elements.arrow = o));
}
const Zh = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Xh,
  effect: Jh,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Dn(e) {
  return e.split("-")[1];
}
var Qh = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function eb(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Fn(n * o) / o || 0,
    y: Fn(r * o) / o || 0
  };
}
function Ka(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, s = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, f = e.isFixed, p = a.x, d = p === void 0 ? 0 : p, g = a.y, h = g === void 0 ? 0 : g, v = typeof c == "function" ? c({
    x: d,
    y: h
  }) : {
    x: d,
    y: h
  };
  d = v.x, h = v.y;
  var x = a.hasOwnProperty("x"), $ = a.hasOwnProperty("y"), w = Ge, S = Ye, E = window;
  if (u) {
    var L = Sr(n), T = "clientHeight", _ = "clientWidth";
    if (L === Je(n) && (L = Xt(n), Mt(L).position !== "static" && l === "absolute" && (T = "scrollHeight", _ = "scrollWidth")), L = L, o === Ye || (o === Ge || o === ot) && i === pr) {
      S = rt;
      var W = f && L === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        L[T]
      );
      h -= W - r.height, h *= s ? 1 : -1;
    }
    if (o === Ge || (o === Ye || o === rt) && i === pr) {
      w = ot;
      var P = f && L === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        L[_]
      );
      d -= P - r.width, d *= s ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: l
  }, u && Qh), k = c === !0 ? eb({
    x: d,
    y: h
  }, Je(n)) : {
    x: d,
    y: h
  };
  if (d = k.x, h = k.y, s) {
    var z;
    return Object.assign({}, D, (z = {}, z[S] = $ ? "0" : "", z[w] = x ? "0" : "", z.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + h + "px)" : "translate3d(" + d + "px, " + h + "px, 0)", z));
  }
  return Object.assign({}, D, (t = {}, t[S] = $ ? h + "px" : "", t[w] = x ? d + "px" : "", t.transform = "", t));
}
function tb(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, l = n.roundOffsets, s = l === void 0 ? !0 : l, u = {
    placement: wt(t.placement),
    variation: Dn(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ka(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ka(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const nb = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: tb,
  data: {}
};
var zr = {
  passive: !0
};
function rb(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, l = a === void 0 ? !0 : a, s = Je(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, zr);
  }), l && s.addEventListener("resize", n.update, zr), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, zr);
    }), l && s.removeEventListener("resize", n.update, zr);
  };
}
const ob = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: rb,
  data: {}
};
var ib = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function qr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return ib[t];
  });
}
var ab = {
  start: "end",
  end: "start"
};
function Xa(e) {
  return e.replace(/start|end/g, function(t) {
    return ab[t];
  });
}
function _i(e) {
  var t = Je(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function Ni(e) {
  return Ln(Xt(e)).left + _i(e).scrollLeft;
}
function lb(e, t) {
  var n = Je(e), r = Xt(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, l = 0, s = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = Yu();
    (u || !u && t === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + Ni(e),
    y: s
  };
}
function sb(e) {
  var t, n = Xt(e), r = _i(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = sn(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = sn(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + Ni(e), s = -r.scrollTop;
  return Mt(o || n).direction === "rtl" && (l += sn(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function Ii(e) {
  var t = Mt(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Zu(e) {
  return ["html", "body", "#document"].indexOf(Ct(e)) >= 0 ? e.ownerDocument.body : nt(e) && Ii(e) ? e : Zu(yo(e));
}
function or(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Zu(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Je(r), a = o ? [i].concat(i.visualViewport || [], Ii(r) ? r : []) : r, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(or(yo(a)))
  );
}
function ci(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ub(e, t) {
  var n = Ln(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Ja(e, t, n) {
  return t === Uu ? ci(lb(e, n)) : pn(t) ? ub(t, n) : ci(sb(Xt(e)));
}
function cb(e) {
  var t = or(yo(e)), n = ["absolute", "fixed"].indexOf(Mt(e).position) >= 0, r = n && nt(e) ? Sr(e) : e;
  return pn(r) ? t.filter(function(o) {
    return pn(o) && Gu(o, r) && Ct(o) !== "body";
  }) : [];
}
function fb(e, t, n, r) {
  var o = t === "clippingParents" ? cb(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], l = i.reduce(function(s, u) {
    var c = Ja(e, u, r);
    return s.top = sn(c.top, s.top), s.right = to(c.right, s.right), s.bottom = to(c.bottom, s.bottom), s.left = sn(c.left, s.left), s;
  }, Ja(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Qu(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? wt(r) : null, i = r ? Dn(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, s;
  switch (o) {
    case Ye:
      s = {
        x: a,
        y: t.y - n.height
      };
      break;
    case rt:
      s = {
        x: a,
        y: t.y + t.height
      };
      break;
    case ot:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Ge:
      s = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? Ai(o) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case Rn:
        s[u] = s[u] - (t[c] / 2 - n[c] / 2);
        break;
      case pr:
        s[u] = s[u] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return s;
}
function mr(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, l = n.boundary, s = l === void 0 ? Lh : l, u = n.rootBoundary, c = u === void 0 ? Uu : u, f = n.elementContext, p = f === void 0 ? Kn : f, d = n.altBoundary, g = d === void 0 ? !1 : d, h = n.padding, v = h === void 0 ? 0 : h, x = Xu(typeof v != "number" ? v : Ju(v, Er)), $ = p === Kn ? Dh : Kn, w = e.rects.popper, S = e.elements[g ? $ : p], E = fb(pn(S) ? S : S.contextElement || Xt(e.elements.popper), s, c, a), L = Ln(e.elements.reference), T = Qu({
    reference: L,
    element: w,
    placement: o
  }), _ = ci(Object.assign({}, w, T)), W = p === Kn ? _ : L, P = {
    top: E.top - W.top + x.top,
    bottom: W.bottom - E.bottom + x.bottom,
    left: E.left - W.left + x.left,
    right: W.right - E.right + x.right
  }, D = e.modifiersData.offset;
  if (p === Kn && D) {
    var k = D[o];
    Object.keys(P).forEach(function(z) {
      var M = [ot, rt].indexOf(z) >= 0 ? 1 : -1, q = [Ye, rt].indexOf(z) >= 0 ? "y" : "x";
      P[z] += k[q] * M;
    });
  }
  return P;
}
function db(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, l = n.flipVariations, s = n.allowedAutoPlacements, u = s === void 0 ? qu : s, c = Dn(r), f = c ? l ? Ya : Ya.filter(function(g) {
    return Dn(g) === c;
  }) : Er, p = f.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  p.length === 0 && (p = f);
  var d = p.reduce(function(g, h) {
    return g[h] = mr(e, {
      placement: h,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[wt(h)], g;
  }, {});
  return Object.keys(d).sort(function(g, h) {
    return d[g] - d[h];
  });
}
function pb(e) {
  if (wt(e) === Li)
    return [];
  var t = qr(e);
  return [Xa(e), t, Xa(t)];
}
function mb(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !0 : a, s = n.fallbackPlacements, u = n.padding, c = n.boundary, f = n.rootBoundary, p = n.altBoundary, d = n.flipVariations, g = d === void 0 ? !0 : d, h = n.allowedAutoPlacements, v = t.options.placement, x = wt(v), $ = x === v, w = s || ($ || !g ? [qr(v)] : pb(v)), S = [v].concat(w).reduce(function(ce, H) {
      return ce.concat(wt(H) === Li ? db(t, {
        placement: H,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: h
      }) : H);
    }, []), E = t.rects.reference, L = t.rects.popper, T = /* @__PURE__ */ new Map(), _ = !0, W = S[0], P = 0; P < S.length; P++) {
      var D = S[P], k = wt(D), z = Dn(D) === Rn, M = [Ye, rt].indexOf(k) >= 0, q = M ? "width" : "height", U = mr(t, {
        placement: D,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), J = M ? z ? ot : Ge : z ? rt : Ye;
      E[q] > L[q] && (J = qr(J));
      var Y = qr(J), G = [];
      if (i && G.push(U[k] <= 0), l && G.push(U[J] <= 0, U[Y] <= 0), G.every(function(ce) {
        return ce;
      })) {
        W = D, _ = !1;
        break;
      }
      T.set(D, G);
    }
    if (_)
      for (var Z = g ? 3 : 1, Q = function(H) {
        var ge = S.find(function(fe) {
          var ee = T.get(fe);
          if (ee)
            return ee.slice(0, H).every(function(Oe) {
              return Oe;
            });
        });
        if (ge)
          return W = ge, "break";
      }, B = Z; B > 0; B--) {
        var N = Q(B);
        if (N === "break") break;
      }
    t.placement !== W && (t.modifiersData[r]._skip = !0, t.placement = W, t.reset = !0);
  }
}
const vb = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: mb,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Za(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Qa(e) {
  return [Ye, ot, rt, Ge].some(function(t) {
    return e[t] >= 0;
  });
}
function hb(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = mr(t, {
    elementContext: "reference"
  }), l = mr(t, {
    altBoundary: !0
  }), s = Za(a, r), u = Za(l, o, i), c = Qa(s), f = Qa(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const bb = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hb
};
function gb(e, t, n) {
  var r = wt(e), o = [Ge, Ye].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [Ge, ot].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function yb(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = qu.reduce(function(c, f) {
    return c[f] = gb(f, t.rects, i), c;
  }, {}), l = a[t.placement], s = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const xb = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: yb
};
function $b(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Qu({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const wb = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: $b,
  data: {}
};
function Eb(e) {
  return e === "x" ? "y" : "x";
}
function Sb(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !1 : a, s = n.boundary, u = n.rootBoundary, c = n.altBoundary, f = n.padding, p = n.tether, d = p === void 0 ? !0 : p, g = n.tetherOffset, h = g === void 0 ? 0 : g, v = mr(t, {
    boundary: s,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), x = wt(t.placement), $ = Dn(t.placement), w = !$, S = Ai(x), E = Eb(S), L = t.modifiersData.popperOffsets, T = t.rects.reference, _ = t.rects.popper, W = typeof h == "function" ? h(Object.assign({}, t.rects, {
    placement: t.placement
  })) : h, P = typeof W == "number" ? {
    mainAxis: W,
    altAxis: W
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, W), D = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, k = {
    x: 0,
    y: 0
  };
  if (L) {
    if (i) {
      var z, M = S === "y" ? Ye : Ge, q = S === "y" ? rt : ot, U = S === "y" ? "height" : "width", J = L[S], Y = J + v[M], G = J - v[q], Z = d ? -_[U] / 2 : 0, Q = $ === Rn ? T[U] : _[U], B = $ === Rn ? -_[U] : -T[U], N = t.elements.arrow, ce = d && N ? Mi(N) : {
        width: 0,
        height: 0
      }, H = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ku(), ge = H[M], fe = H[q], ee = rr(0, T[U], ce[U]), Oe = w ? T[U] / 2 - Z - ee - ge - P.mainAxis : Q - ee - ge - P.mainAxis, Ae = w ? -T[U] / 2 + Z + ee + fe + P.mainAxis : B + ee + fe + P.mainAxis, He = t.elements.arrow && Sr(t.elements.arrow), We = He ? S === "y" ? He.clientTop || 0 : He.clientLeft || 0 : 0, _e = (z = D == null ? void 0 : D[S]) != null ? z : 0, R = J + Oe - _e - We, ie = J + Ae - _e, he = rr(d ? to(Y, R) : Y, J, d ? sn(G, ie) : G);
      L[S] = he, k[S] = he - J;
    }
    if (l) {
      var Fe, it = S === "x" ? Ye : Ge, vt = S === "x" ? rt : ot, qe = L[E], ht = E === "y" ? "height" : "width", bt = qe + v[it], Nt = qe - v[vt], gt = [Ye, Ge].indexOf(x) !== -1, yt = (Fe = D == null ? void 0 : D[E]) != null ? Fe : 0, at = gt ? bt : qe - T[ht] - _[ht] - yt + P.altAxis, Le = gt ? qe + T[ht] + _[ht] - yt - P.altAxis : Nt, lt = d && gt ? Gh(at, qe, Le) : rr(d ? at : bt, qe, d ? Le : Nt);
      L[E] = lt, k[E] = lt - qe;
    }
    t.modifiersData[r] = k;
  }
}
const Cb = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Sb,
  requiresIfExists: ["offset"]
};
function Pb(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Ob(e) {
  return e === Je(e) || !nt(e) ? _i(e) : Pb(e);
}
function Tb(e) {
  var t = e.getBoundingClientRect(), n = Fn(t.width) / e.offsetWidth || 1, r = Fn(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Rb(e, t, n) {
  n === void 0 && (n = !1);
  var r = nt(t), o = nt(t) && Tb(t), i = Xt(t), a = Ln(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Ct(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ii(i)) && (l = Ob(t)), nt(t) ? (s = Ln(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = Ni(i))), {
    x: a.left + l.scrollLeft - s.x,
    y: a.top + l.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function Fb(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var s = t.get(l);
        s && o(s);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Lb(e) {
  var t = Fb(e);
  return Hh.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Db(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Mb(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var el = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function tl() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Ab(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? el : o;
  return function(l, s, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, el, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, d = {
      state: c,
      setOptions: function(x) {
        var $ = typeof x == "function" ? x(c.options) : x;
        h(), c.options = Object.assign({}, i, c.options, $), c.scrollParents = {
          reference: pn(l) ? or(l) : l.contextElement ? or(l.contextElement) : [],
          popper: or(s)
        };
        var w = Lb(Mb([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = w.filter(function(S) {
          return S.enabled;
        }), g(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var x = c.elements, $ = x.reference, w = x.popper;
          if (tl($, w)) {
            c.rects = {
              reference: Rb($, Sr(w), c.options.strategy === "fixed"),
              popper: Mi(w)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(P) {
              return c.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var S = 0; S < c.orderedModifiers.length; S++) {
              if (c.reset === !0) {
                c.reset = !1, S = -1;
                continue;
              }
              var E = c.orderedModifiers[S], L = E.fn, T = E.options, _ = T === void 0 ? {} : T, W = E.name;
              typeof L == "function" && (c = L({
                state: c,
                options: _,
                name: W,
                instance: d
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Db(function() {
        return new Promise(function(v) {
          d.forceUpdate(), v(c);
        });
      }),
      destroy: function() {
        h(), p = !0;
      }
    };
    if (!tl(l, s))
      return d;
    d.setOptions(u).then(function(v) {
      !p && u.onFirstUpdate && u.onFirstUpdate(v);
    });
    function g() {
      c.orderedModifiers.forEach(function(v) {
        var x = v.name, $ = v.options, w = $ === void 0 ? {} : $, S = v.effect;
        if (typeof S == "function") {
          var E = S({
            state: c,
            name: x,
            instance: d,
            options: w
          }), L = function() {
          };
          f.push(E || L);
        }
      });
    }
    function h() {
      f.forEach(function(v) {
        return v();
      }), f = [];
    }
    return d;
  };
}
var _b = [ob, wb, nb, Uh, xb, vb, Cb, Zh, bb], Nb = /* @__PURE__ */ Ab({
  defaultModifiers: _b
}), Ho, nl;
function Ib() {
  if (nl) return Ho;
  nl = 1;
  var e = typeof Element < "u", t = typeof Map == "function", n = typeof Set == "function", r = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function o(i, a) {
    if (i === a) return !0;
    if (i && a && typeof i == "object" && typeof a == "object") {
      if (i.constructor !== a.constructor) return !1;
      var l, s, u;
      if (Array.isArray(i)) {
        if (l = i.length, l != a.length) return !1;
        for (s = l; s-- !== 0; )
          if (!o(i[s], a[s])) return !1;
        return !0;
      }
      var c;
      if (t && i instanceof Map && a instanceof Map) {
        if (i.size !== a.size) return !1;
        for (c = i.entries(); !(s = c.next()).done; )
          if (!a.has(s.value[0])) return !1;
        for (c = i.entries(); !(s = c.next()).done; )
          if (!o(s.value[1], a.get(s.value[0]))) return !1;
        return !0;
      }
      if (n && i instanceof Set && a instanceof Set) {
        if (i.size !== a.size) return !1;
        for (c = i.entries(); !(s = c.next()).done; )
          if (!a.has(s.value[0])) return !1;
        return !0;
      }
      if (r && ArrayBuffer.isView(i) && ArrayBuffer.isView(a)) {
        if (l = i.length, l != a.length) return !1;
        for (s = l; s-- !== 0; )
          if (i[s] !== a[s]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === a.source && i.flags === a.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof a.valueOf == "function") return i.valueOf() === a.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof a.toString == "function") return i.toString() === a.toString();
      if (u = Object.keys(i), l = u.length, l !== Object.keys(a).length) return !1;
      for (s = l; s-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, u[s])) return !1;
      if (e && i instanceof Element) return !1;
      for (s = l; s-- !== 0; )
        if (!((u[s] === "_owner" || u[s] === "__v" || u[s] === "__o") && i.$$typeof) && !o(i[u[s]], a[u[s]]))
          return !1;
      return !0;
    }
    return i !== i && a !== a;
  }
  return Ho = function(a, l) {
    try {
      return o(a, l);
    } catch (s) {
      if ((s.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw s;
    }
  }, Ho;
}
var jb = Ib();
const kb = /* @__PURE__ */ no(jb);
var Vb = [], Bb = function(t, n, r) {
  r === void 0 && (r = {});
  var o = j.useRef(null), i = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || Vb
  }, a = j.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), l = a[0], s = a[1], u = j.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(d) {
        var g = d.state, h = Object.keys(g.elements);
        ir.flushSync(function() {
          s({
            styles: Ua(h.map(function(v) {
              return [v, g.styles[v] || {}];
            })),
            attributes: Ua(h.map(function(v) {
              return [v, g.attributes[v]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = j.useMemo(function() {
    var p = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return kb(o.current, p) ? o.current || p : (o.current = p, p);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, u]), f = j.useRef();
  return qa(function() {
    f.current && f.current.setOptions(c);
  }, [c]), qa(function() {
    if (!(t == null || n == null)) {
      var p = r.createPopper || Nb, d = p(t, n, c);
      return f.current = d, function() {
        d.destroy(), f.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: l.styles,
    attributes: l.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
const Hb = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => {
    e.elements.popper.style.width = `${e.elements.reference.offsetWidth}px`;
  }
};
function rl(e) {
  if (typeof e == "object") {
    if (e.id != null)
      return String(e.id);
    throw new Error(
      "MultiSelectComboBox: An object was passed in for an item, but it did not have an id property. You must either override both the `getItemDisplayValue` and `getItemId` props to retrieve a consistent item ID, or provide an id property on the item."
    );
  }
  return String(e);
}
const eg = ({
  selectedItems: e = [],
  options: t,
  getItemDisplayValue: n = rl,
  getItemId: r = rl,
  getFilteredOptions: o = (S) => t.filter(
    (E) => n(E).toLowerCase().includes(S.toLowerCase())
  ),
  onChange: i,
  name: a,
  labelId: l,
  label: s,
  description: u,
  inputId: c,
  toggleButtonId: f,
  maxRenderableItemsInDropdown: p = 0,
  onRenderableMaxExceeded: d = () => {
  },
  placeholder: g = "Select…",
  disabled: h,
  required: v,
  dropdownClassName: x,
  dropdownPortalReference: $ = document.body,
  showSelectionHelpers: w = !0
}) => {
  const S = Yt(), [E, L] = A.useState(""), T = $ instanceof HTMLElement ? $ : document.querySelector($), _ = o(E), W = p > 0 && _.length > p, P = W ? _.slice(0, p) : _;
  ue(() => {
    W && d(_.length, p);
  }, [W, _, p]);
  const D = X(/* @__PURE__ */ new Map()), k = A.useMemo(() => {
    if (Fh(D.current, t))
      return D.current;
    const Z = new Map(t.map((Q) => [r(Q), Q]));
    return D.current = Z, Z;
  }, [t, r]), [z, M] = oe(null), [q, U] = oe(null), { styles: J, attributes: Y } = Bb(z, q, {
    placement: "auto",
    modifiers: [
      {
        name: "flip",
        options: {
          allowedAutoPlacements: ["top", "bottom"]
          // by default, all the placements are allowed
        }
      },
      Hb
    ]
  });
  function G(Z) {
    typeof i == "function" && i(Z.map((Q) => k.get(Q)).filter(Boolean).map(r));
  }
  return /* @__PURE__ */ C.jsx(
    Oh,
    {
      value: Array.from(new Set(e.map(r))),
      onChange: G,
      multiple: !0,
      disabled: h,
      children: ({ open: Z }) => /* @__PURE__ */ C.jsxs("div", { className: "form-multiselect-combobox", children: [
        (s != null || w) && /* @__PURE__ */ C.jsxs(
          "div",
          {
            className: ye("d-flex flex-wrap align-items-end mb-2", {
              "justify-content-between": s != null,
              "justify-content-end": s == null
            }),
            children: [
              s != null && /* @__PURE__ */ C.jsxs("div", { children: [
                /* @__PURE__ */ C.jsxs(vu, { id: l, className: ye({ "mb-0": u == null }), children: [
                  s,
                  v && /* @__PURE__ */ C.jsx(ro, {})
                ] }),
                u != null && /* @__PURE__ */ C.jsx(ll, { id: `${l}-description-${S}`, className: "mb-0", children: u })
              ] }),
              w && /* @__PURE__ */ C.jsxs("div", { className: "mt-n1", children: [
                /* @__PURE__ */ C.jsx(
                  lr,
                  {
                    variant: "link",
                    className: "p-0",
                    onClick: () => {
                      G(
                        t.map((Q) => k.get(r(Q))).filter(Boolean).map(r)
                      );
                    },
                    disabled: e.length === t.length,
                    children: "Select all"
                  }
                ),
                /* @__PURE__ */ C.jsx("span", { className: "text-gray-100", children: "|" }),
                /* @__PURE__ */ C.jsx(
                  lr,
                  {
                    variant: "link",
                    className: "p-0",
                    onClick: () => {
                      G([]);
                    },
                    disabled: e.length === 0,
                    children: "Clear all"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ C.jsx(
          "div",
          {
            className: `select2-container select2-container--default select2-container--below w-100 ${Z ? "select2-container--focus select2-container--open" : ""}`,
            ref: (Q) => M(Q),
            children: /* @__PURE__ */ C.jsx("div", { className: "select2-selection--multiple d-flex justify-content-between flex-wrap align-items-center custom-select", children: /* @__PURE__ */ C.jsxs(
              "div",
              {
                className: `select2-selection__rendered d-flex justify-content-between flex-wrap align-items-center w-auto flex-grow-1 p-0 ${e.length > 0 ? "" : "empty"}`,
                children: [
                  /* @__PURE__ */ C.jsx("ul", { className: "list-unstyled m-0 p-0", children: e.map((Q) => {
                    const B = `selected-item-${r(Q).toLowerCase()}`;
                    return /* @__PURE__ */ C.jsxs("li", { "data-testid": B, className: "select2-selection__choice", children: [
                      /* @__PURE__ */ C.jsx(
                        "span",
                        {
                          className: "select2-selection__choice__remove mr-1",
                          role: "presentation",
                          ...h ? { style: { pointerEvents: "none" } } : {},
                          onClick: (N) => {
                            if (N.stopPropagation(), h) {
                              N.preventDefault();
                              return;
                            }
                            G(
                              e.filter((ce) => ce !== Q).map(r)
                            );
                          },
                          children: "×"
                        }
                      ),
                      n(k.get(r(Q)))
                    ] }, B);
                  }) }),
                  /* @__PURE__ */ C.jsxs("div", { className: "select2-search select2-search--inline flex-grow-1", children: [
                    /* @__PURE__ */ C.jsx(si, { className: "select2-search__field mt-0 w-100", children: /* @__PURE__ */ C.jsx(
                      Hu,
                      {
                        className: "select2-search__field mt-0 w-100",
                        id: c,
                        name: a,
                        "aria-describedby": `${l}-description-${S}`,
                        disabled: h,
                        required: (v ?? !1) && e.length === 0,
                        placeholder: e.length > 0 ? "" : g,
                        value: E,
                        displayValue: () => E,
                        onChange: (Q) => L(Q.target.value)
                      }
                    ) }),
                    Z && T ? Ac.createPortal(
                      // This is the dropdown menu with the list of filtered items.
                      /* @__PURE__ */ C.jsx(
                        "span",
                        {
                          ref: (Q) => U(Q),
                          style: J.popper,
                          ...Y.popper,
                          className: `select2-container select2-container--default ${x}`,
                          "data-testid": "listbox-container",
                          children: /* @__PURE__ */ C.jsx("span", { className: "select2-dropdown select2-dropdown--below", children: /* @__PURE__ */ C.jsx("span", { className: "select2-results", children: /* @__PURE__ */ C.jsx(Wu, { className: "select2-results__options", static: !0, children: P.length === 0 ? /* @__PURE__ */ C.jsx("span", { className: "p-1", children: "No results found" }) : P.map((Q) => /* @__PURE__ */ C.jsx(
                            zu,
                            {
                              as: ut,
                              value: r(Q),
                              children: ({ focus: B, selected: N }) => (
                                // eslint-disable-next-line jsx-a11y/role-supports-aria-props
                                /* @__PURE__ */ C.jsx(
                                  "li",
                                  {
                                    className: `select2-results__option ${B ? "select2-results__option--highlighted" : N ? "select2-results__option--selected" : ""}`,
                                    "aria-selected": N,
                                    children: n(Q)
                                  }
                                )
                              )
                            },
                            r(Q)
                          )) }) }) })
                        }
                      ),
                      T
                    ) : null,
                    /* @__PURE__ */ C.jsxs(si, { id: f, className: "btn btn-unstyled toggle p-0", children: [
                      /* @__PURE__ */ C.jsx("span", { className: "sr-only", children: "Toggle listbox" }),
                      /* @__PURE__ */ C.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 4 5", width: "8", height: "10", children: /* @__PURE__ */ C.jsx("path", { fill: "#2d2d33", d: "M2 0 0 2h4zm0 5L0 3h4z" }) })
                    ] })
                  ] })
                ]
              }
            ) })
          }
        )
      ] })
    }
  );
}, tg = A.forwardRef((e, t) => /* @__PURE__ */ C.jsx(ul, { ...e, ref: t, pattern: "[0-9]*", inputMode: "numeric", spellCheck: "false" })), ng = A.forwardRef(
  ({ children: e, className: t, id: n, label: r, inline: o = !1, ...i }, a) => {
    const l = ye(t, "form-check", o && "form-check-inline");
    return /* @__PURE__ */ C.jsxs("div", { className: l, children: [
      /* @__PURE__ */ C.jsx(Gt, { ...i, id: n, className: "form-check-input", ref: a, type: "radio" }),
      /* @__PURE__ */ C.jsx("label", { className: "form-check-label", htmlFor: n, children: r }),
      e
    ] });
  }
), rg = A.forwardRef(
  ({
    allowPlaceholderSelectionWhenRequired: e = !1,
    className: t,
    id: n,
    options: r,
    placeholder: o = "Select…",
    required: i = !1,
    size: a,
    value: l,
    onChange: s,
    ...u
  }, c) => /* @__PURE__ */ C.jsxs(
    Gt,
    {
      ...u,
      className: ye(t, "custom-select", {
        [`custom-select-${a}`]: a
      }),
      id: n,
      ref: c,
      required: i,
      tag: "select",
      value: l,
      onChange: typeof s == "function" ? (f) => {
        s(f);
      } : void 0,
      children: [
        o && /* @__PURE__ */ C.jsx("option", { value: "", disabled: i && !e, children: o }),
        r.map((f) => /* @__PURE__ */ C.jsx("option", { value: f.value, disabled: f.disabled, children: f.label }, f.value))
      ]
    }
  )
), og = ({
  className: e,
  idPrefix: t,
  maxHeight: n = 160,
  onChange: r,
  options: o,
  selectAllLabel: i = "Select all",
  value: a,
  ...l
}) => {
  const s = ye(
    "bg-white",
    "border",
    "rounded",
    "py-2",
    "px-3",
    "overflow-auto",
    e
  ), u = () => !a || !a.length ? !1 : o.every((p) => a.includes(p.value)), c = (p) => {
    if (a.includes(p)) {
      const d = a.indexOf(p);
      r([...a.slice(0, d), ...a.slice(d + 1)]);
      return;
    }
    r([...a, p]);
  }, f = () => {
    if (u()) {
      r([]);
      return;
    }
    r(o.map((p) => p.value));
  };
  return /* @__PURE__ */ C.jsxs("div", { className: s, style: { maxHeight: n }, ...l, children: [
    /* @__PURE__ */ C.jsx(
      Zi,
      {
        checked: u(),
        indeterminate: !u() && a.length > 0,
        id: `${t}-all`,
        value: `${t}-all`,
        label: i,
        onChange: f
      }
    ),
    /* @__PURE__ */ C.jsx("div", { className: "pl-4", children: o.map((p) => /* @__PURE__ */ C.jsx(
      Zi,
      {
        checked: a.some((d) => p.value === d),
        id: `${t}-${p.value}`,
        label: p.label,
        onChange: c,
        value: p.value
      },
      p.value
    )) })
  ] });
}, ig = A.forwardRef(
  ({ className: e, icon: t, variant: n = oo.primary, ...r }, o) => {
    const i = ye(e, "switch", `switch--${n}`);
    return /* @__PURE__ */ C.jsxs("label", { className: i, children: [
      /* @__PURE__ */ C.jsx(Gt, { ...r, className: "switch__input", ref: o, type: "checkbox" }),
      /* @__PURE__ */ C.jsx("span", { className: "switch__label", children: t && /* @__PURE__ */ C.jsx(Qo, { icon: t, className: `switch__icon text-${n}` }) })
    ] });
  }
);
export {
  qb as AdvancedChoice,
  Ub as Form,
  Zi as FormCheck,
  Yb as FormColorPicker,
  Gt as FormControl,
  Gb as FormCurrency,
  al as FormFieldset,
  Kb as FormFile,
  Xb as FormGroup,
  zc as FormInputGroup,
  Uc as FormLabel,
  Vc as FormLegend,
  Jb as FormMultiLine,
  eg as FormMultiSelectComboBox,
  tg as FormNumber,
  ng as FormRadio,
  ro as FormRequired,
  rg as FormSelect,
  og as FormSelectCheckboxes,
  ul as FormSingleLine,
  ig as FormSwitch,
  ll as FormText
};
